export const fr = {
  store: "Commerçant",
  pennyRounding: "Arrondi aux 5 cents",
  meal: "Repas",
  users: "Utilisateurs",
  user: "Utilisateur",
  layout: "Disposition",
  analytics: "Analytique",
  settings: "Paramètres",
  settingsDescription: "Gérer les détails et les opérations du magasin.",
  notAvailableWhenOffline: "Non disponible hors ligne",
  offlineNotification: "Mode de travail hors ligne",
  storeDetails: "Détails du magasin",
  organization: "Organisation",
  organizationHeadquarters: "Siège de l'organisation",
  organizationLegalEntity: "Entité juridique",
  organizationBrand: "Marque",
  organizationOperator: "Exploitant",
  createOrganizationHeadquarters: "Créer le siège de l'organisation",
  createLegalEntity: "Créer l'entité juridique",
  createBrand: "Créer la marque",
  createOperator: "Créer l'exploitant",
  organizationChoose: "Choisir une organisation",
  headquarters: "Siège",
  legalEntity: "Entité juridique",
  brand: "Marque",
  operator: "Exploitant",
  notLinked: "Non lié",
  thisStore: "Ce magasin",
  organizationGroupsStores: "Une organisation regroupe des magasins pour la navigation et les rapports.",
  organizationStartAnyLevel: "Vous pouvez commencer à n'importe quel niveau. Un restaurant seul s'enregistre comme magasin.",
  organizationOperatorAcrossBrands: "Un exploitant peut gérer des magasins de plusieurs marques.",
  organizationNoAccess: "Lier un magasin ne donne pas à cette organisation l'accès au magasin.",
  storeNotLinked: "Ce magasin n'est lié à aucune organisation.",
  alsoOperatesBrands: "Exploite aussi des magasins de",
  hasNoLevel: "Il n'a pas de",
  isPartOf: "fait partie de",
  operatesIt: "l'exploite.",
  itsLegalEntityIs: "Son entité juridique est",
  headquartersLevel: "Un siège regroupe des entités juridiques.",
  legalEntityLevel: "Une entité juridique est une société enregistrée.",
  brandLevel: "Une marque est un nom de restaurant.",
  operatorLevel: "Un exploitant gère un ou plusieurs restaurants.",
  storeLevel: "Un magasin est un restaurant.",
  createOrganization: "Créer une organisation",
  registerOrganization: "Enregistrer une organisation",
  associateStore: "Associer un magasin existant",
  editOrganization: "Modifier l'organisation",
  reviewRequests: "Voir les demandes",
  acceptRequest: "Accepter",
  declineRequest: "Refuser",
  organizationName: "Nom de l'organisation",
  storeIdToAssociate: "Identifiant du magasin",
  linkThisStore: "Lier ce magasin",
  requestAssociation: "Envoyer la demande",
  organizationSaved: "Organisation enregistrée.",
  organizationRequestSent: "Demande envoyée. Le propriétaire du magasin l'accepte avant l'enregistrement du lien.",
  noOrganizationYet: "Ce magasin n'a pas encore d'organisation.",
  selectOrganizationLevel: "Choisir un niveau",
  analyticsThisStore: "Ce magasin",
  analyticsOrganizationStores: "magasins",
  advanced: "Avancé",
  mevClient: "Client MEV",
  mevClientDescription:
    "Consultez l'activité MEV cloud, surveillez les commandes entrantes et imprimez les reçus depuis ce poste.",
  monitoringActive: "Surveillance active",
  name: "Nom",
  quantity: "Quantité",
  address: "Adresse",
  email: "Email",
  phone: "Téléphone",
  thirdParty: "Tiers",
  thirdPartyDeliveryOrders: "Commandes de livraison par un tiers",
  thirdPartyHint: "Entreprises, estimations, contrats et forfaits",
  thirdPartyDashboard: "Tableau",
  thirdPartyDashboardHint: "Toute l'activité des tiers pour la période choisie.",
  thirdPartyAllActivity: "Toute l'activité",
  downloadThirdParty: "Télécharger",
  occasionalReport: "Rapport",
  occasionalReportHint: "Contrats occasionnels envoyés pour la période choisie.",
  occasionalThirdParty: "Tiers inhabituel",
  occasionalThirdPartyHint: "Enregistrez un contrat, puis envoyez ce contrat. Un contrat envoyé ne peut pas être envoyé de nouveau. Le client ne reçoit pas de reçu.",
  addOccasionalItem: "Ajouter un article",
  dateAscending: "Croissant",
  dateDescending: "Décroissant",
  noOccasionalHistory: "Aucun contrat dans l'historique.",
  historyPastDay: "Dernier jour",
  historyPast7Days: "7 derniers jours",
  historyPast1Month: "1 dernier mois",
  historyPast2Months: "2 derniers mois",
  historyPast3Months: "3 derniers mois",
  historyAllTime: "Toute la période",
  historyEmpty: "Aucun document dans l'historique.",
  occasionalItemLimit: "Un établissement peut enregistrer 60 articles.",
  noOccasionalItem: "Aucun article n'est enregistré.",
  agreementText: "Entente",
  payableDate: "Date payable",
  sendContract: "Envoyer le contrat",
  printMerchantCopy: "Imprimer la copie du commerçant",
  merchantCopyUnavailable: "La copie du commerçant n'est pas disponible pour ce contrat.",
  contractSent: "Contrat envoyé à Revenu Québec.",
  contractSentOn: "Contrat envoyé à Revenu Québec",
  contractNotSentYet: "Contrat non envoyé.",
  sendingContract: "Envoi",
  sendingContractTitle: "Envoi du contrat à Revenu Québec",
  copyContract: "Copier",
  confirmEditOccasionalItem: "Modifier ce contrat?",
  contractNotSent: "Le contrat n'a pas été envoyé.",
  connectionRequired: "Une connexion est requise pour envoyer ce contrat.",
  chooseContractItem: "Choisissez au moins un article.",
  businessCopy: "Copie du commerçant",
  businessCopyHint: "Cette copie est réservée à l'établissement.",
  occasionalItemRequired: "Entrez le prix, l'entente, la date et la date payable.",
  occasionalItemSaved: "Article enregistré.",
  confirmDeleteOccasionalItem: "Supprimer cet article?",
  reference: "Référence",
  estimation: "Estimation",
  quotation: "Soumission",
  contract: "Contrat",
  thirdPartySectionPlaceholder: "Cette section n'est pas encore disponible.",
  proposalNextStep: "Prochaine étape",
  proposalStepEnter: "Saisir",
  proposalStepSend: "Envoyer",
  proposalStepFinish: "Terminer",
  proposalCustomer: "Client",
  proposalEmail: "Courriel",
  proposalEmailHelp: "Adresse du document électronique. Laissez vide pour imprimer seulement.",
  proposalAddLine: "Ajouter une ligne",
  proposalRemoveLine: "Retirer",
  proposalDescription: "Description",
  proposalQuantity: "Quantité",
  proposalPrice: "Prix",
  proposalSales: "Ventes",
  proposalNoEmail: "Aucun courriel n'est saisi. Ce document est imprimé au poste.",
  proposalPaper: "Papier",
  proposalPaperHelp: "Imprimez le document au poste.",
  proposalPaperAndEmail: "Papier et courriel",
  proposalPaperAndEmailHelp: "Imprimez le document et envoyez-le à cette adresse.",
  proposalEmailOnly: "Courriel",
  proposalEmailOnlyHelp: "Envoyez-le à cette adresse. Le poste ne l'imprime pas.",
  proposalEdit: "Modifier",
  proposalNotSent: "Le document n'a pas été envoyé.",
  proposalConnectionRequired: "Une connexion est requise pour envoyer ce document.",
  proposalClosed: "Ce document est fermé.",
  proposalReport: "Rapport",
  proposalDocuments: "Documents",
  proposalReportHint: "Documents envoyés pour la période choisie.",
  proposalReportEmpty: "Aucun document pour cette période.",
  proposalSentToRq: "Envoyé à Revenu Québec",
  proposalReturnNumber: "Numéro de retour",
  proposalReturnDate: "Date de retour",
  proposalSending: "Envoi du document à Revenu Québec",
  proposalEmailFailed: "Le document a été envoyé. Le courriel n'a pas été envoyé.",
  proposalPrintFailed: "Le document a été envoyé. Il n'a pas été imprimé.",
  proposalSentPrinted: "Envoyé et imprimé.",
  proposalSentEmailed: "Envoyé par courriel.",
  proposalSentBoth: "Envoyé, imprimé et transmis par courriel.",
  proposalDraftNext: "Prochaine étape : envoyer et imprimer.",
  proposalChargeToAccount: "Porté au compte",
  proposalPayment: "Paiement",
  proposalReason: "Raison",
  proposalReasonHelp: "Cette raison est imprimée sur le reçu de fermeture.",
  proposalStatusDraft: "Brouillon",
  proposalStatusSent: "Envoyé",
  proposalStatusRevised: "Révisé",
  proposalStatusAccepted: "Accepté",
  proposalStatusDeclined: "Refusé",
  proposalStatusCompleted: "Terminé",
  proposalStatusCancelled: "Annulé",
  quotationPurpose: "Une offre de prix. Envoyez-la et imprimez-la. Si le client accepte, imprimez la facture suivante. Si le client refuse, arrêtez.",
  quotationEmpty: "Aucune soumission n'est enregistrée. Cliquez sur Nouvelle soumission. Entrez les articles, enregistrez, puis envoyez.",
  quotationNew: "Nouvelle soumission",
  quotationSaveNext: "Enregistrez l'offre. Rien n'est envoyé avant Envoyer la soumission.",
  quotationSend: "Envoyer la soumission",
  quotationSendPrintConfirm: "Envoyer cette soumission et l'imprimer?",
  quotationSendEmailConfirm: "Envoyer cette soumission par courriel?",
  quotationFinishNext: "Demandez au client. Accepter imprime la facture suivante. Refuser arrête ici. Réviser envoie une nouvelle soumission si les prix ont changé.",
  quotationAccept: "Accepter",
  quotationAcceptHelp: "Le client veut cette offre. Choisissez la facture suivante, puis imprimez-la.",
  quotationDecline: "Refuser",
  quotationDeclineHelp: "Le client ne veut pas cette offre. Rien d'autre n'est envoyé.",
  quotationRevise: "Réviser",
  quotationReviseHelp: "Les prix ont changé. Envoyez une soumission révisée. Le papier indique SOUMISSION RÉVISÉE.",
  quotationContinueQuestion: "Comment cette offre continue-t-elle?",
  quotationTemporaryBill: "Facture temporaire",
  quotationTemporaryBillHelp: "Imprimez une facture maintenant. Le paiement est perçu plus tard.",
  quotationClosingReceipt: "Reçu de fermeture",
  quotationClosingReceiptHelp: "Imprimez le reçu final. Choisissez le paiement, ou portez le montant au compte.",
  quotationBillNext: "Cette facture renvoie à la soumission. Le code QR est imprimé dessus.",
  quotationPrintTemporary: "Imprimer la facture temporaire",
  quotationPrintClosing: "Imprimer le reçu de fermeture",
  quotationDeclineConfirm: "Refuser cette soumission? Rien d'autre n'est envoyé.",
  quotationDeclinedNext: "Cette soumission est fermée.",
  quotationReviseNext: "Modifiez les prix, puis envoyez la soumission révisée. La première soumission reste au dossier.",
  quotationSendRevised: "Envoyer la soumission révisée",
  quotationContinue: "Continuer",
  quotationAnswer: "Inscrire la réponse",
  quotationCardSent: "Demandez au client, puis acceptez ou refusez.",
  estimatePurpose: "Prix ou quantités qui peuvent encore changer. Envoyez-la et imprimez-la. À la fin des travaux, imprimez un reçu de fermeture. Si les travaux sont annulés, imprimez un reçu de fermeture de 0,00 $.",
  estimateEmpty: "Aucune estimation n'est enregistrée. Cliquez sur Nouvelle estimation. Entrez les articles prévus, enregistrez, puis envoyez.",
  estimateNew: "Nouvelle estimation",
  estimateSaveNext: "Enregistrez l'estimation. Rien n'est envoyé avant Envoyer l'estimation.",
  estimateSend: "Envoyer l'estimation",
  estimateSendNext: "Envoyez cette estimation. Un reçu de fermeture est encore requis à la fin des travaux.",
  estimateSendPrintConfirm: "Envoyer cette estimation et l'imprimer?",
  estimateSendEmailConfirm: "Envoyer cette estimation par courriel?",
  estimateFinishNext: "L'estimation est imprimée. Quand les travaux sont terminés, complétez-la. Si les quantités changent, révisez-la. Si les travaux s'arrêtent, annulez-la. Chaque fin imprime un reçu de fermeture.",
  estimateComplete: "Compléter",
  estimateCompleteHelp: "Les travaux sont terminés. Confirmez les montants finaux et imprimez le reçu de fermeture.",
  estimateRevise: "Réviser",
  estimateReviseHelp: "Les quantités ou les prix ont changé. Envoyez une estimation révisée. Le papier indique ESTIMATION RÉVISÉE.",
  estimateCancel: "Annuler l'estimation",
  estimateCancelHelp: "Les travaux ne seront pas faits. Un reçu de fermeture de 0,00 $ est imprimé. Le papier indique ESTIMATION ANNULÉE.",
  estimateCompleteNext: "Ce reçu ferme l'estimation et y renvoie. Le code QR est imprimé dessus.",
  estimatePrintClosing: "Imprimer le reçu de fermeture",
  estimateCancelPrint: "Annuler l'estimation et imprimer",
  estimateReviseNext: "Modifiez les quantités ou les prix, puis envoyez l'estimation révisée.",
  estimateSendRevised: "Envoyer l'estimation révisée",
  estimateFinish: "Terminer",
  estimateCardSent: "Terminez cette estimation avec un reçu de fermeture.",
  contractPurpose: "Un banquet, un service de traiteur ou une entente de groupe. Entrez l'entente, envoyez-la et imprimez-la. Quand le service est rendu, imprimez le reçu de fermeture.",
  contractEmpty: "Aucun contrat n'est enregistré. Cliquez sur Nouveau contrat. Entrez l'entente, enregistrez, puis envoyez.",
  contractNew: "Nouveau contrat",
  contractDescription: "Description",
  contractDescriptionHelp: "Ce que couvre cette entente.",
  contractReferenceHelp: "Le numéro de l'entente.",
  contractServiceDate: "Date du service",
  contractServiceDateHelp: "La date à laquelle le service est rendu.",
  contractPayableHelp: "La date à laquelle le montant complet est dû.",
  contractGuests: "Personnes",
  contractGuestsHelp: "Le nombre de personnes couvertes par cette entente.",
  contractPriceHelp: "Le montant avant taxes.",
  contractSaveNext: "Enregistrez l'entente. Envoyez-la quand les détails sont finaux. Le client reçoit une estimation imprimée avec un code QR. Un reçu de fermeture suit quand le service est rendu.",
  contractSend: "Envoyer le contrat",
  contractSendPrintConfirm: "Envoyer ce contrat et l'imprimer?",
  contractSendEmailConfirm: "Envoyer ce contrat par courriel?",
  contractFinishNext: "Le contrat est imprimé. Quand le service est rendu, imprimez le reçu de fermeture. Si l'événement change, révisez-le. S'il s'arrête, annulez-le.",
  contractComplete: "Compléter",
  contractCompleteHelp: "Le service est rendu. Imprimez le reçu de fermeture.",
  contractCompleteNext: "Ce reçu ferme le contrat et y renvoie. Le code QR est imprimé dessus.",
  contractRevise: "Réviser",
  contractReviseHelp: "Une date, le nombre de personnes ou le prix a changé. Envoyez le contrat révisé.",
  contractCancel: "Annuler le contrat",
  contractCancelHelp: "L'événement n'aura pas lieu. Imprimez un reçu de fermeture de 0,00 $.",
  contractReviseNext: "Modifiez l'entente, puis envoyez le contrat révisé.",
  contractSendRevised: "Envoyer le contrat révisé",
  contractFinish: "Terminer",
  contractCardSent: "Terminez ce contrat avec un reçu de fermeture.",
  packageDeal: "Forfait",
  packagePurpose: "Un forfait acheté à l'extérieur du restaurant. Entrez le forfait et les articles inclus, puis envoyez le reçu de fermeture. Aucun paiement n'est perçu.",
  packageEmpty: "Aucun forfait n'est enregistré. Cliquez sur Nouveau forfait. Entrez le forfait, enregistrez, puis envoyez.",
  packageNew: "Nouveau forfait",
  packageName: "Nom du forfait",
  packageNameHelp: "Le nom de ce forfait.",
  packageAmount: "Montant du forfait",
  packageAmountHelp: "Ce montant est le négatif des articles inclus. Le total est de 0,00 $.",
  packageLinePriceHelp: "Entrez le prix de chaque article. Laissez le prix vide lorsqu'il n'y a pas de prix.",
  packageAddItem: "Ajouter un article",
  packageItemOptional: "Les articles sont facultatifs. Ajoutez un article seulement lorsqu'il fait partie de ce forfait.",
  packageServiceDate: "Date du service (facultatif)",
  packageServiceDateHelp: "Laissez ce champ vide lorsqu'il n'y a pas de date de service.",
  packagePayableDate: "Date payable (facultatif)",
  packagePayableHelp: "Laissez ce champ vide lorsqu'il n'y a pas de date payable.",
  packageLeaving: "Vous quittez cet écran.",
  packageLeavingSave: "Ce forfait sera enregistré.",
  packageLeavingName: "Entrez un nom de forfait pour enregistrer ce forfait.",
  packageStay: "Rester",
  packageSaveNext: "Enregistrez le forfait. Rien n'est envoyé tant que vous ne cliquez pas sur Envoyer le forfait.",
  packageSend: "Envoyer le forfait",
  packageSendPrintConfirm: "Envoyer ce forfait et l'imprimer?",
  packageSendEmailConfirm: "Envoyer ce forfait par courriel?",
  packageSendNext: "Envoyez ce forfait. Le reçu de fermeture indique aucun paiement et un total de 0,00 $.",
  packageFinishNext: "Le forfait est imprimé. Si un article change, révisez-le. S'il s'arrête, annulez-le.",
  packageComplete: "Compléter",
  packageCompleteHelp: "Le service est rendu. Imprimez le reçu de fermeture. Aucun paiement n'est perçu.",
  packageCompleteNext: "Ce reçu ferme le forfait. Aucun paiement n'est perçu. Le total est de 0,00 $.",
  packageNoPayment: "Aucun paiement n'est perçu. Le total du reçu est de 0,00 $.",
  packageRevise: "Réviser",
  packageReviseHelp: "Un article ou un prix a changé. Envoyez le forfait révisé.",
  packageReviseNext: "Modifiez le forfait, puis envoyez le forfait révisé.",
  packageSendRevised: "Envoyer le forfait révisé",
  packageCancel: "Annuler le forfait",
  packageCancelHelp: "Ce forfait ne sera pas fourni. Imprimez un reçu de fermeture de 0,00 $.",
  packageFinish: "Terminer",
  packageCardSent: "Ce forfait a un reçu de fermeture.",
  frequentThirdParty: "Tiers habituel",
  frequentThirdPartyHint: "Ajoutez une entreprise, puis envoyez la déclaration lorsque l'entente est nouvelle, modifiée ou terminée. Vous pouvez l'enregistrer et l'envoyer plus tard.",
  addFrequentThirdParty: "Ajouter un tiers habituel",
  frequentThirdPartyLimit: "Un établissement peut enregistrer 10 tiers habituels.",
  noFrequentThirdParty: "Aucun tiers habituel n'est enregistré.",
  frequentThirdPartySaved: "Tiers habituel enregistré.",
  frequentThirdPartyRequired: "Entrez le nom et le numéro de TVQ.",
  sendDeclaration: "Envoyer la déclaration",
  saveForLater: "Enregistrer pour plus tard",
  sendingDeclaration: "Envoi",
  view: "Afficher",
  moreActions: "Autres actions",
  confirmEditThirdParty: "Modifier ce tiers habituel?",
  confirmDeleteThirdParty: "Supprimer ce tiers habituel?",
  declarationSent: "Déclaration envoyée.",
  declarationSentOn: "Déclaration envoyée",
  declarationNotSent: "Déclaration non envoyée.",
  oneFrequentThirdPartyPerBill: "Une facture ne peut inclure qu'un seul tiers habituel. Placez l'autre entreprise sur une facture distincte.",
  thirdPartyReport: "Rapport de tiers habituel",
  thirdPartyReportHint: "Ventes perçues pour une entreprise.",
  reportPeriod: "Période",
  reportPeriodDay: "Jour",
  reportPeriodMonth: "Mois",
  amountToPay: "Total",
  noThirdPartySales: "Aucune vente pour cette entreprise pendant cette période.",
  sendReportEmail: "Envoyer le courriel",
  reportEmailSent: "Rapport envoyé.",
  reportEmailSentAt: "Courriel envoyé",
  reportEmailFailed: "Le rapport n'a pas été envoyé.",
  reportEmailRequired: "Entrez une adresse courriel.",
  thirdPartyRefund: "Remboursement",
  thirdPartyPrinted: "Envoyé à l'imprimante.",
  saveReportPdf: "Enregistrer le PDF",
  declarationFailed: "La déclaration n'a pas été envoyée.",
  billingActivity: "Activité de facturation",
  nonRegulatedItem: "Article non visé",
  selectFrequentThirdParty: "Sélectionner un tiers habituel",
  addThirdPartyInSettings: "Ajoutez un tiers habituel dans les paramètres.",
  legalName: "Nom légal",
  qstNumber: "Numéro de TVQ",
  civicNumber: "Numéro civique",
  street: "Rue",
  city: "Ville",
  postalCode: "Code postal",
  extension: "Poste",
  neq: "NEQ",
  contractReason: "Raison du contrat",
  newContract: "Nouveau",
  amendment: "Modification",
  expiration: "Expiration",
  signedOn: "Date de signature",
  effectiveOn: "Date d'entrée en vigueur",
  expiresOn: "Date d'expiration",
  serviceDescription: "Description du service",
  frequency: "Fréquence",
  timeOfDay: "Moment de la journée",
  dayTime: "Jour",
  evening: "Soir",
  night: "Nuit",
  galleryForCustomer: "Galerie/Publicité pour l'écran face aux clients",
  customMealCategory: "Catégorie de repas personnalisée",
  storeType: "Type de magasin",
  tableOrderingSetting: "Réglage des commandes à table",
  serviceMode: "Mode de service",
  sharedService: "Service partagé — Par défaut",
  assignedService: "Service assigné",
  sharedServiceDescription: "Tous les serveurs et caissiers autorisés peuvent accéder aux commandes ouvertes et les gérer, peu importe qui les a créées. Les employés peuvent s'entraider pour la prise de commande, la cuisine, la division de l'addition et les paiements sans transférer la responsabilité.",
  assignedServiceDescription: "Chaque commande appartient à l'employé qui l'ouvre. Les autres employés ne peuvent pas la modifier ni la traiter, sauf si la responsabilité leur est transférée ou s'ils ont une autorisation spéciale.",
  serviceModeSaved: "Mode de service enregistré",
  orderBelongsToAnotherEmployee: "Cette commande appartient à un autre employé.",
  claimOrderBeforeChanges: "Prenez en charge cette commande avant de la modifier.",
  claimOrder: "Prendre en charge",
  transferOrderOwnership: "Transférer la responsabilité",
  selectReceivingEmployee: "Sélectionner l'employé qui reçoit",
  confirmTransfer: "Confirmer le transfert",
  transferFromTo: "De {from} à {to}",
  transferOwnershipToast: "Responsabilité transférée",
  idleTableAutoClosing: "Fermeture automatique d'une table inactive",
  idleTableAfter: "Après",
  idleTableMinutes: "minutes, fermeture automatique d'une table inactive.",
  idleTableCloseMinutes: "Après combien de minutes ?",
  tableStatusDirtyAfterPayment: "Définir le statut de la table à À nettoyer après le paiement",
  tableStatusAvailableAfterPayment: "Définir le statut de la table à Libre après le paiement",
  dirtyTableAutoAvailable: "Définir automatiquement le statut de À nettoyer à Libre",
  tableOrderingSaved: "Réglage des commandes à table enregistré",
  closeTableQuestion: "Fermer cette table ?",
  keepTableOpen: "Laisser ouverte",
  tableHoldOrderDetail: "Détail de la commande",
  lockTable: "Verrouiller la table",
  lockFor1Hour: "Verrouiller pour la prochaine heure",
  lockFor2Hours: "Verrouiller pour les 2 prochaines heures",
  lockFor3Hours: "Verrouiller pour les 3 prochaines heures",
  lockForRestOfNight: "Verrouiller le reste de la nuit",
  lockForRestOfDay: "Verrouiller le reste de la journée",
  unlockTable: "Déverrouiller la table",
  tableLockedBy: "Verrouillée par",
  tableLockedUntil: "Jusqu'à",
  noOpenOrder: "Aucune commande ouverte",
  closeTable: "Fermer la table",
  changeTableStatus: "Changer le statut",
  tableStatus: "Statut de la table",
  tableStatusAvailable: "Libre",
  tableStatusSeated: "Assis",
  tableStatusOrdering: "Commande",
  tableStatusInService: "En service",
  tableStatusPayment: "Paiement en attente",
  tableStatusDirty: "À nettoyer",
  tableFaceSeated: "Assis",
  tableFaceOrdering: "Commande",
  tableFaceService: "Service",
  tableFacePayment: "Paiement",
  tableFaceDirty: "Sale",
  tableStatusMaintenance: "En entretien",
  tableFaceMaintenance: "Entretien",
  tableInMaintenance: "Cette table est en entretien.",
  tableNeedsCleaning: "Cette table doit être nettoyée avant l'ouverture d'une commande. Maintenez la table enfoncée, puis réglez le statut sur Libre.",
  releaseTable: "Libérer la table",
  billingSubactivity: "Activité",
  billingSubactivityHelp: "Cette activité est définie pour le magasin et est utilisée sur les factures.",
  itemUsesStoreActivity: "Activité du magasin",
  billingSubactivityUpdated: "Activité mise à jour",
  cartPosition: "Position du panier",
  cartPositionLeft: "Gauche",
  cartPositionRight: "Droite",
  cartPositionHelp: "Choisissez le côté du panier. Les catégories du menu occupent l'autre côté.",
  cartPositionUpdated: "Position du panier mise à jour",
  cartNowOnLeft: "Le panier est à gauche.",
  cartNowOnRight: "Le panier est à droite.",
  categoryInMiddle: "Catégories au milieu",
  categoryInMiddleHelp: "Les catégories se placent entre les produits et le panier. Le panier reste du côté choisi ci-dessus.",
  categoryInMiddleUpdated: "Catégories mises à jour",
  categoryNowInMiddle: "Les catégories sont au milieu.",
  categoryNowOnSide: "Les catégories sont sur le côté.",
  activityRestaurant: "Restaurant",
  activityBar: "Bar",
  activityFoodTruck: "Camion de restauration",
  barActivityTaxNote: "Pour un article de bar, cochez la taxe sur l'alcool sous Taxes ci-dessous.",
  currency: "Devise",
  add: "Ajouter",
  print: "Imprimer",
  sessions: "Sessions",
  orders: "Commandes",
  customerFacingScreen: "Écran côté client",
  cashierView: "Vue caissière",
  kitchenView: "Vue cuisine",
  layoutView: "Vue de la disposition",
  history: "Historique",
  noOrderRecordsExist: "Aucun enregistrement de commande existant",
  noSessionRecordsExist: "Aucun enregistrement de session existant",
  updateMenu: "Mettre à jour le menu",
  updateMenuSuccessfully: "Menu mis à jour avec succès",
  updateMenuTooltip:
    "Publie les changements de menus et de catégories.",
  updateMenuFrontEndWarning:
    "Mettre à jour le menu publie les changements de menus et de catégories.",
  syncingMenu: "Synchronisation...",
  errorSyncingMenu: "Erreur lors de la synchronisation du menu",
  serving: "Service",
  active: "Actif",
  inactive: "Inactif",
  amount: "Montant",
  total: "Total",
  table: "Table",
  payment: "Paiement",
  changeDue: "Monnaie due",
  tips: "Pourboire",
  tipPercent: "Pourboire %",
  tipAmount: "Montant du pourboire",
  customTip: "Personnalisé",
  totalWithTip: "Total avec pourboire",
  paymentTipPercentages: "Pourcentages de pourboire (paiement)",
  paymentTipsBeforeTaxes: "Pourboire calculé avant taxes",
  paymentTipsAfterTaxes: "Pourboire calculé après taxes",
  tipsSharedAmongStaff: "Les pourboires sont partagés entre le personnel",
  printReceipt: "Imprimer le reçu",
  cancel: "Annuler",
  complete: "Terminer",
  edit: "Modifier",
  delete: "Supprimer",
  update: "Mettre à jour",
  deleteOrder: "Supprimer la commande",
  printOrderSlip: "Imprimer le bon de commande",
  printKitchenSlip: "Imprimer le bon de cuisine",
  latestOrderAt: "Dernière commande à",
  completedAt: "Terminé à",
  received: "Reçu",
  startEditing: "Commencer l'édition",
  save: "Sauvegarder",
  addSmallDiningTable: "ajouter une petite table à manger",
  addMediumDiningTable: "ajouter une table à manger moyenne",
  addLargeDiningTable: "ajouter une grande table à manger",
  clearAll: "tout effacer",
  undo: "annuler",
  reorder: "réorganiser",
  renew: "Renouveler",
  renewSession: "Renouveler la session",
  createNewSession: "Créer une nouvelle session",
  addSession: "Ajouter une session",
  createSession: "Créer une session",
  printSession: "Imprimer le code QR",
  takeOrder: "Prendre commande",
  editOrder: "Modifier la commande",
  completeOrder: "Terminer la commande",
  description: "Description",
  ingredients: "Ingrédients",
  price: "Prix",
  category: "Catégorie",
  createdDate: "Date de création",
  lastUpdated: "Dernière mise à jour",
  lastUpdatedAt: "Dernière mise à jour à",
  admins: "Administrateurs",
  members: "Membres",
  invited: "Invité",
  owner: "Propriétaire",
  member: "Membre",
  admin: "Administrateur",
  kdsUser: "Utilisateur KDS",
  kdsUsers: "Utilisateurs KDS",
  chooseRole: "Choisir un rôle",
  addMemberNotPosNotice: "Un utilisateur PDV et un NIP de 6 chiffres sont créés avec cette connexion. Le propriétaire du magasin peut voir le NIP. Cette personne peut changer son propre NIP.",
  memberRoleHint: "Membre est une connexion d'arrière-bureau. Un utilisateur PDV et un NIP sont créés avec cette connexion.",
  adminRoleHint: "Administrateur est une connexion d'arrière-bureau avec accès aux paramètres du magasin. Un utilisateur PDV et un NIP sont créés avec cette connexion.",
  kdsUserHint: "Utilisateur KDS est une connexion d'arrière-bureau pour l'affichage cuisine. Un utilisateur PDV et un NIP sont créés avec cette connexion.",
  confirmCreateRoleTitle: "Confirmer ce rôle",
  confirmCreateRoleIntro: "Vous êtes sur le point de créer cette connexion. Veuillez confirmer le rôle.",
  adminsTooltip:
    "Seul le Super Admin (propriétaire du magasin) peut attribuer et retirer le rôle d'administrateur",
  membersTooltip:
    "Le membre est autorisé à uniquement visualiser et gérer les commandes des clients.",
  invitedTooltip:
    "Les personnes invitées se verront attribuer le rôle de [Membre] une fois l'invitation acceptée.",
  invitedPeople: "Personnes Invitées",
  transferOnwership: "Transférer la propriété",
  removeAdminRole: "Retirer le rôle d'administrateur",
  grantAdminRole: "Attribuer le rôle d'administrateur",
  invitePeople: "Inviter des personnes",
  addStore: "Ajouter un magasin",
  alreadyExists: "existe déjà",
  existingInvitationTo: "Invitation existante pour",
  emailIsRequired: "L'email est requis",
  nameIsRequired: "Le nom est requis",
  priceIsRequired: "Le prix est requis",
  invalidEmailAddress: "Adresse email invalide",
  fullService: "Service complet",
  limitedService: "Service limité",
  storeTypeDescription:
    "Changer le type de magasin affectera la manière dont la caisse affiche et termine chaque commande.",
  limitedServiceDescription:
    "Le service limité gère les commandes comme une commande par soumission. (par exemple, kiosque alimentaire/beverage, food court)",
  fullServiceDescription:
    "Le service complet gère les commandes comme une commande par table/session. (par exemple, restaurant, café)",
  fullServiceExplain:
    "Le service complet offre une expérience de repas complète et le client paie généralement après avoir mangé. (par exemple, restaurant, café)",
  limitedServiceExplain:
    "Le service limité termine généralement son interaction avec le client (service et paiement) avant ou lors de la livraison des repas. (par exemple, kiosque alimentaire/beverage, food court)",
  orderIsEmpty: "La commande est vide",
  completedByKitchen: "Terminé par la cuisine",
  changeMealImage: "Changer l'image du repas",
  uploadMealImage: "Télécharger l'image du repas",
  food: "Nourriture",
  drink: "Boisson",
  side: "Accompagnement",
  submitted: "Soumis",
  confirmDeleteMeal: "Confirmer la suppression du repas ?",
  confirmRenewSession:
    "La session est encore valide, confirmer le renouvellement de la session ?",
  confirmCompleteOrder: "Confirmer la finalisation de la commande ?",
  confirmDeleteSession: "Confirmer la suppression de la session ?",
  confirmDeleteImage: "Confirmer la suppression de l'image ?",
  storeInvitation: "Invitation au magasin",
  noInvitationFound:
    "Aucune invitation trouvée, veuillez demander une autorisation auprès de l'administrateur du magasin",
  join: "Rejoindre",
  joinStore: "Rejoindre le magasin",
  settingUpStore: "Configuration de votre magasin",
  createStore: "Créer un magasin",
  invitation: "Invitation",
  uploadProfilePicture: "Télécharger la photo de profil",
  changeProfilePicture: "Changer la photo de profil",
  myStores: "Mes magasins",
  profile: "Profil",
  accountSettings: "Paramètres du compte",
  signOut: "Déconnexion",
  deleteStore: "Supprimer le magasin",
  cloneStore: "Cloner le magasin",
  uploadImage: "Télécharger une image",
  temporarySession: "Temporaire (la session expirera dans 24 heures)",
  deleteSessionOnCompletion: "Supprimer la session à la fin de la commande",
  autoRenew:
    "Renouvellement automatique de la session à la fin de la commande (la suppression de la session est requise)",
  limitedServiceSession:
    "L'expiration et la suppression de la session ont été désactivées pour s'adapter à l'opération de service limité, vous pouvez configurer votre préférence de comportement de session ci-dessous",
  noExistingNameFound: "Créez une session ici puis créez une table à ",
  ifYouWantLink:
    " pour lier la session et la table dans la Vue de la disposition",
  noOptions: "Pas d'options",
  addCustomerGallery: "Ajouter une publicité/une galerie à l'écran",
  grantAdminRoleToast: "a reçu le rôle [Administrateur]",
  removeAdminRoleToast: "a été déplacé vers la liste des membres",
  deleteInvitationToast: "a été retiré de la liste d'invitations",
  deleteMemberToast: "a été retiré de la liste des membres",
  deleteAdminToast: "a été retiré de la liste des administrateurs",
  transferOnwershipToast: "le transfert de propriété du magasin à",
  sendInvitationToast: "Invitation envoyée avec succès à",
  switchedStoreToast: "Changement effectué vers",
  deleteStoreToast: "Supprimé avec succès",
  recommendItToCustomer: "Recommander aux clients",
  emailUs: "Envoyez-nous un email pour toute question",
  emailUsShort: "Email",
  signup: "Inscription",
  login: "Connexion",
  quitStore: "Quitter le magasin",
  switchToStore: "Changer de magasin",
  currentStoreLabel: "Actuel",
  confirmSwitchStoreTitle: "Changer de magasin ?",
  confirmSwitchStoreBody: "Passer à",
  changeLogo: "Changer le logo",
  uploadLogo: "Télécharger le logo",
  emailVerifiedToast: "Votre email a été vérifié !",
  emailSentToast: "Email envoyé !",
  emailSentToastDescription:
    "Veuillez vérifier votre email pour la vérification",
  emailVerificationErrorToast: "Email de vérification déjà envoyé",
  emailVerificationFailedToast: "Échec de l'envoi de l'email de vérification",
  resetPasswordToast:
    "Merci, consultez votre email pour les instructions de réinitialisation de votre mot de passe",
  emailNotExist: "L'email n'existe pas",
  failedToUpload: "Échec du téléchargement",
  saveLayoutToast: "la disposition de la table a été mise à jour",
  invalidEmailOrPassword: "Email ou mot de passe invalide",
  failedToLogin: "Échec de la connexion",
  accountCreated: "Compte créé",
  verificationEmailSent: "Vérifiez votre e-mail",
  verficiationEmailSentDescription:
    "Pour compléter le processus d'enregistrement de votre compte, nous devons vérifier que l'adresse e-mail vous appartient.",
  emailAlreadyExist: "L'email existe déjà",
  successfullyCreateStore: "Magasin créé avec succès",
  pleaseSwitchStore: ", veuillez passer à votre nouveau magasin.",
  pleaseCreateMeal:
    ", veuillez procéder à la création de repas pour votre magasin.",
  youAreNowMemberOf: "Vous êtes maintenant membre de",
  orderFromTable: "Commande de table",
  isCompleted: "est terminé",
  addedCategory: "Catégorie ajoutée",
  removedCategory: "Catégorie supprimée",
  currencyChanged: "La devise a été changée en",
  successfullyUpdateStore: "Magasin mis à jour avec succès",
  storeTypeChanged: "Le type de magasin a été changé en",
  layoutNotReady: "Disposition non prête...",
  layoutNotReadyDescription:
    "Vous n'avez pas encore créé votre disposition, veuillez procéder à la création de la disposition pour votre magasin.",
  createLayout: "Créer une disposition",
  confirmQuitStore: "Confirmer la fermeture du magasin ?",
  minimumItemQuantity: "Quantité minimale de commande en décimal",
  noMoreOrder: "Il n'y a plus de commande",
  loadMore: "Charger plus",
  id: "ID",
  notifications: "Notifications",
  switchToDarkMode: "Mode sombre",
  switchToLightMode: "Mode clair",
  highContrast: "Contraste élevé",
  highContrastOff: "Contraste standard",
  defaultMode: "Mode par défaut",
  defaultModeHint: "Ce thème s'applique aux écrans du PDV. Le personnel peut le modifier pendant la session. Après la déconnexion, ce mode par défaut s'applique de nouveau.",
  enterFullscreen: "Plein écran",
  exitFullscreen: "Quitter le plein écran",
  noNotificationFound: "Aucune notification trouvée",
  noticeHistory: "Historique",
  noticePlain: "Texte",
  noticeHidden: "Masquée",
  allowMemberEdit: "Permettre aux membres de modifier les commandes",
  storeCreated: "Magasin créé",
  storeCreatedNotification:
    "Vous avez réussi à configurer votre magasin, veuillez procéder à la création de repas pour votre magasin.",
  manageSubscription: "Gérer l'abonnement",
  billing: "Facturation",
  currentSubscription: "Abonnement actuel",
  mySubscription: "Mon abonnement",
  initiateSubscription:
    "Si vous êtes propriétaire d'un magasin, veuillez d'abord créer un magasin.",
  selectYourStoreType: "Sélectionnez le type de votre magasin",
  configureStoreTypeInfo:
    "Le type de magasin peut être reconfiguré plus tard si vous n'êtes pas sûr du choix à faire.",
  compulsoryItem: "Quantité automatiquement ajoutée et immuable",
  compulsory: "Obligatoire",
  yes: "Oui",
  no: "Non",
  hiddenFromMenu: "Caché du menu",
  dashboard: "Tableau de bord",
  addedPaymentMethod: "Méthode de paiement ajoutée",
  removedPaymentMethod: "Méthode de paiement supprimée",
  paymentMethod: "Méthode de paiement",
  paymentMethods: "Méthodes de paiement",
  // Payment Method Names (French only)
  paymentMethodArgentComptant: "Argent comptant",
  paymentMethodCarteCredit: "Carte de crédit",
  paymentMethodPaiementMixte: "Paiement mixte",
  chooseNextPaymentMethod: "Paiement suivant",
  editTendered: "Modifier le montant remis",
  cashAmountDue: "Dû",
  changeDue: "Monnaie",
  receiptPrinting: "Impression du reçu",
  amountReceived: "Reçu",
  amountRemaining: "Reste à payer",
  mixedPaymentSettingNote: "Ce choix n'apparaît pas dans la fenêtre de paiement. Lorsqu'il est activé, une addition peut être payée avec plus d'un mode. L'addition de fermeture est envoyée comme paiement mixte.",
  discardPartialPaymentsTitle: "Cette addition n'est pas payée.",
  discardPartialPaymentsBody: "Les paiements saisis ici seront écartés.",
  keepPaying: "Continuer le paiement",
  discardPayments: "Écarter les paiements",
  paymentMethodCarteDebit: "Carte de débit",
  paymentMethodTransfertElectronique: "Transfert électronique de fonds",
  paymentMethodPortefeuilleElectronique: "Portefeuille électronique",
  paymentMethodCryptomonnaie: "Cryptomonnaie",
  paymentMethodCertificatCadeau: "Certificat-cadeau",
  paymentMethodProgrammeFidelisation: "Programme de fidélisation",
  paymentMethodPorteAuCompte: "Porté au compte",
  paymentMethodCheque: "Chèque",
  paymentMethodAutre: "Autre mode de paiement",
  paymentMethodAucunPaiement: "Aucun paiement",
  paymentMethodSansObjet: "Sans objet",
  openCashDrawer: "Ouvrir le tiroir-caisse",
  openCashDrawerDescription: "Le tiroir-caisse s'ouvrira lors de l'utilisation de ce mode de paiement",
  cashDrawerOpened: "Tiroir-caisse ouvert",
  cashDrawerError: "Échec de l'ouverture du tiroir-caisse",
  allowRefund: "Autoriser le traitement des remboursements sur le TPV",
  allowRefundDescription: "Ce mode de paiement peut être utilisé pour les remboursements dans le système TPV",
  options: "Options",
  summarized: "Résumé",
  unit: "Unité",
  unitPlaceHolder:
    "Unité à des fins d'affichage (par ex., gramme, kg, ensembles)",
  totalAmount: "Montant total",
  checkout: "Envoyer",
  back: "Retour",
  close: "Fermer",
  remark: "Remarque",
  orderSettings: "Commande",
  paymentKitchenOrder: "Servi en premier / Paiement en premier",
  paymentFirst: "Paiement en premier",
  servedFirst: "Servi en premier",
  alwaysCompleteAtKitchenView:
    "Pour une opération Paiement en premier, terminez votre commande à la Vue Cuisine à chaque fois après le paiement.",
  paymentFirstWarning:
    "Sélectionner Paiement en premier pour un Service complet peut causer un comportement inattendu",
  paymentKitchenExplained:
    "Sélectionnez l'option paiement en premier uniquement pour éviter la suppression de la commande après paiement. Cela est utile si votre personnel doit lire les informations dans la vue cuisine (par ex., ingrédients).",
  kitchenPrintTiming: "Impression cuisine",
  kitchenPrintBeforePayment: "Avant le paiement",
  kitchenPrintAfterPayment: "Après le paiement",
  kitchenPrintAfterAutomatic: "Après le paiement, automatique",
  kitchenPrintAfterManual: "Après le paiement, manuel",
  kitchenPrintTimingHelp: "Choisissez le moment d'impression du bon de cuisine.",
  afterOrderScreen: "Après la commande",
  afterOrderScreenHelp: "Choisissez où l'écran va lorsque la commande est terminée ou annulée.",
  afterOrderStay: "Rester sur cet écran",
  afterOrderOpenTip: "Ouvrir TIP",
  afterOrderUpdated: "Réglage après commande mis à jour",
  kitchenPrintMode: "Bon de cuisine",
  kitchenPrintAutomatic: "Auto",
  kitchenPrintManual: "Manuel",
  kitchenPrintModeHelp: "Auto imprime le bon après le paiement. Manuel demande avant l'impression.",
  kitchenPrintUpdated: "Réglage d'impression cuisine mis à jour",
  kitchenService: "Service cuisine",
  kitchenServiceUpdated: "Service cuisine mis à jour",
  kitchenCourses: "Services",
  addCourse: "Ajouter un service",
  kdsCourseFireFlash: "Clignotement KDS à l'envoi du service",
  courseFirstTicket: "Premier bon",
  courseOnFire: "À l'envoi",
  courseOnHold: "En attente",
  courseFireNow: "Envoie",
  coursePrintOnFirst: "Imprimer sur le premier bon",
  coursePrintOnSecond: "Imprimer sur le deuxième bon",
  kdsFlash13: "13 secondes",
  kdsFlash15: "15 secondes",
  kdsFlash30: "30 secondes",
  serviceSequence: "Séquence de service",
  fire: "Envoie",
  fireSent: "Service envoyé",
  fireNone: "Aucun service à envoyer",
  fireNoPrinter: "Aucune cuisine n'est configurée pour ces plats",
  printKitchenTicket: "Imprimer le bon de cuisine",
  kitchenReceiptNotPrinted: "Le bon de cuisine n'a pas été imprimé. Voulez-vous continuer?",
  tableName: "Nom de la table de session / disposition",
  storeOperation: "Opération du magasin",
  reservationConfirmationEmail: "Courriel de confirmation des réservations",
  reservationConfirmationEmailHelp: "Saisir au maximum 3 adresses électroniques, séparées par des virgules.",
  reservationConfirmationEmailInvalid: "Saisir au maximum 3 adresses électroniques valides, séparées par des virgules.",
  reservationConfirmationEmailSaved: "Adresses de confirmation des réservations enregistrées.",
  offline: "Hors ligne",
  offlineBatchSize: "Limite de taille du lot",
  offlineBatchSizeHelp: "Les factures hors ligne sont envoyées par demandes jusqu'à cette taille. Le maximum est 256 Ko.",
  offlineBatchSizeInvalid: "Entrez un nombre entier de 1 à 256.",
  offlineBatchSizeSaved: "Taille du lot hors ligne enregistrée.",
  alternativeTimeOffered: "Autre heure proposée : {date} {time}",
  keypadPopupAtLogin: "Pavé PIN à la connexion",
  keypadPopupAtLoginToggle: "Afficher le pavé PIN à la connexion",
  keypadPopupAtLoginDescription:
    "Lorsque c'est activé, le pavé PIN apparaît à la connexion même si un utilisateur POS est lié. Lorsque c'est désactivé, l'utilisateur POS lié démarre automatiquement.",
  keypadPopupAtLoginEnabled: "Pavé PIN activé",
  keypadPopupAtLoginDisabled: "Pavé PIN désactivé",
  keypadPopupAtLoginEnabledHint: "Le pavé PIN apparaîtra automatiquement à la connexion",
  keypadPopupAtLoginDisabledHint: "Le pavé PIN restera masqué à la connexion",
  keypadPopupAtLoginUpdateFailed: "Échec de la mise à jour du pavé PIN à la connexion",
  sessionControl: "Contrôle de session",
  all: "Tous",
  simple: "Simple",
  sessionControlExplained:
    "Avec le contrôle de session [Simple], vous ne pourrez pas [Ajouter une nouvelle session], [Supprimer une session], [Renouveler une session] et [Imprimer une session] dans la [Vue Caissier], donc veuillez configurer correctement votre configuration de session avant de passer au contrôle de session [Simple].",
  none: "Aucun",
  nearest: "Le plus proche",
  up: "Haut",
  down: "Bas",
  roundingTotal: "Arrondissement du prix total",
  roundingItem: "Arrondissement du prix de l'article",
  changeTo: "Changé en",
  allSessionControl: "Contrôle de session complet",
  simpleSessionControl: "Contrôle de session simple",
  requiredTableName:
    "Demander au personnel/client d'insérer le nom de la table (Non relié à la table de la disposition) lors du paiement",
  pleaseInsertTableName: "Veuillez insérer le nom de votre table",
  session: "Session",
  inheritFromStore: "Hérité du magasin",
  customerScreen: "Écran client",
  openCustomerScreen: "Ouvrir l'écran client",
  openCustomerScreenHelp: "Ouvre l'écran client dans une deuxième fenêtre.",
  customerScreenActive: "Actif",
  customerScreenOff: "Inactif",
  customerScreenActiveHelp: "Active ou ferme l'écran client.",
  customerScreenAlwaysOnHelp: "L'écran client est activé pour ce magasin.",
  customerScreenAppearance: "Apparence",
  customerScreenLight: "Clair",
  customerScreenDark: "Sombre",
  pinCustomerScreen: "Épingler",
  unpinCustomerScreen: "Détacher",
  chooseThisCustomer: "Choisir ce client",
  recentOrders: "Commandes récentes",
  standard: "Standard",
  standardMenuControl: "Contrôle du menu standard",
  simpleMenuControl: "Contrôle du menu simple",
  menuControl: "Menu du personnel",
  completePaymentFirstAlert:
    "Veuillez d'abord compléter le paiement à la [Vue Caissier]",
  detail: "Détail",
  detailNotExists: "Le détail de la commande n'existe plus",
  addedRemarkShortcut: "Raccourci de remarque ajouté",
  removedRemarkShortcut: "Raccourci de remarque supprimé",
  remarkShortcuts: "Raccourcis de remarques",
  paymentMethodNameIsRequired: "Le nom de la méthode de paiement est requis",
  paymentMethodAlreadyExisted: "La méthode de paiement existe déjà",
  categoryNameIsRequired: "Le nom de la catégorie est requis",
  categoryAlreadyExisted: "La catégorie existe déjà",
  shortcutNameIsRequired: "Le nom du raccourci est requis",
  shortcutAlreadyExisted: "Le raccourci existe déjà",
  shortcut: "Raccourci",
  createOption: "Créer une option",
  optionName: "Nom de l'option",
  requireChange: "Nécessite un calcul de monnaie lors du paiement",
  menuSettings: "Paramètres du menu",
  paymentSettings: "Paramètres de paiement",
  submittingOrder: "Soumission de la commande...",
  submittedOrder: "Commande soumise avec succès !",
  addMeal: "Ajouter un repas",
  createdFirstMeal: "Créer le premier repas",
  pleaseUpdateMenu:
    "Vous avez créé avec succès votre premier repas, veuillez cliquer ici pour mettre à jour votre menu après avoir complètement configuré vos repas.",
  pleaseCreateSession:
    "Veuillez procéder à la [Vue Caissier] pour créer votre première session/table.",
  storeSetupComplete: "Configuration de la session réussie",
  moreStoreConfiguration:
    "Appuyez sur le code QR pour commencer à prendre des commandes, ou imprimez le code QR pour que vos clients puissent commander. Procédez à la section [Paramètres] pour mettre à jour la configuration spécifique du magasin afin de l'adapter parfaitement à l'opération de votre magasin.",
  ok: "D'accord",
  features: "Fonctionnalités",
  others: "Autres",
  kitchen: "Vue Cuisine",
  hasBeen: "a été ",
  enabled: "activé",
  disabled: "désactivé",
  untickToDisable: "Décochez pour désactiver la fonctionnalité",
  debugMode: "Mode debug",
  currentUrl: "URL actuelle",
  printAfterCompletion: "Imprimer après la fin de la commande",
  userDecide: "Décision de l'utilisateur",
  alreadyAMember: "Déjà membre ?",
  sign_up: "S'inscrire",
  log_in: "Se connecter",
  welcomeToNuagePos: "Bienvenue sur NuagePOS Eagle",
  signInToAccountPOS: "Connectez-vous à votre compte.",
  password: "Mot de passe",
  confirmPassword: "Confirmer le mot de passe",
  passwordMustBe6: "Le mot de passe doit comporter au moins 6 caractères",
  passwordRequirements: "Utilisez 8 à 25 caractères, avec une majuscule, une minuscule, un chiffre et un symbole.",
  passwordRuleLength: "8 à 25 caractères",
  passwordRuleUpper: "Lettre majuscule",
  passwordRuleLower: "Lettre minuscule",
  passwordRuleNumber: "Chiffre",
  passwordRuleSymbol: "Symbole",
  passwordSymbolsLabel: "Symboles permis",
  passwordUnsupportedCharacter: "Retirez les caractères qui ne sont pas une lettre, un chiffre ou un symbole permis.",
  required: "Requis",
  passwordUnmatched: "Les mots de passe ne correspondent pas",
  forgotPassword: "Mot de passe oublié ?",
  OR: "OU",
  signInWithGoogle: "Se connecter avec Google",
  forgotPasswordInfo:
    "Vous recevrez un e-mail avec un lien de réinitialisation",
  resetPassword: "Réinitialiser le mot de passe",
  sendResetPassword: "Envoyer la réinitialisation du mot de passe",
  passwordResetFailed: "Le courriel de réinitialisation n'a pas été envoyé",
  verifyYourEmail: "Vérifiez votre adresse e-mail",
  check: "Vérifier",
  toVerify: "pour vérifier votre compte et commencer.",
  ifYouHaveNotReceived:
    "Si vous n'avez pas reçu l'e-mail après quelques minutes, veuillez vérifier votre dossier spam",
  resendVerificationEmail: "Renvoyer l'e-mail de vérification",
  refresh: "Rafraîchir",
  startNow: "Commencer maintenant",
  freeUnlimitedUsers: "Gratuit. Utilisateurs illimités.",
  etilhubDescription:
    "Une solution POS légère pour gérer efficacement votre restaurant et votre entreprise de F&B.",
  cloudSmart: "Basé sur le cloud | Intelligent",
  pointOfSale: "Point de vente",
  registerForFree: "Inscrivez-vous gratuitement",
  qrFoodOrdering: "Commande de nourriture QR",
  contactlessOrders: "Commandes sans contact",
  instantAndEasySetup: "Configuration instantanée et facile",
  adjustableForEveryBusiness:
    "Adaptable pour chaque modèle d'entreprise de F&B",
  billingProcessingPrinting: "Traitement de la facturation et impression",
  orderSlipPrinting: "Impression de bon de commande",
  issueReceipt: "Émettre des reçus imprimés ou électroniques",
  sessionQRPrinting: "Impression de code QR de session",
  instantKitchenView: "Vue instantanée de la cuisine",
  realtimeOrderStatus: "Statut de commande en temps réel",
  orderQueue: "File d'attente de commandes",
  ingredientsDisplay: "Affichage des ingrédients",
  customizableFloorPlan: "Plan d'étage personnalisable",
  restaurantTableLayout: "Disposition des tables du restaurant",
  realtimeTableStatus: "Statut des tables en temps réel",
  intuitiveInterface: "Interface intuitive",
  moreFeatures: "Plus de fonctionnalités",
  comingsoon: "prochainement...",
  noItemExist: "Aucun enregistrement d'objet",
  myStore: "Mon magasin",
  logout: "Se déconnecter",
  navigationSettings: "Paramètres de navigation",
  navigateToPaymentAfterSubmit:
    "Naviguer vers le paiement après la soumission de la commande (Vue Caissier)",
  size: "Taille",
  small: "Petit",
  medium: "Moyen",
  large: "Grand",
  tableNameMustBeSame:
    "Le nom de la table doit être le même que le nom de la session, vous pouvez créer une table ici d'abord avant de procéder à la création d'une session pour votre magasin.",
  confirmDeleteStore:
    "Confirmez que vous souhaitez supprimer ce magasin:",
  deleteThisStore: "Supprimer ce magasin ?",
  deleteStoreWarning:
    "Ce faisant, le magasin sera définitivement supprimé et ne pourra pas être récupéré à l'avenir.",
  pleaseInsertStoreName: "Veuillez insérer le nom du magasin",
  typeDeleteToConfirm: "Tapez DELETE pour confirmer la suppression",
  typeDeletePlaceholder: "Tapez DELETE",
  cloneThisStore: "Cloner le magasin",
  cloneStoreInfo: "Mettez à jour les détails pour votre nouveau magasin.",
  addIngredient: "Ajouter un ingrédient",
  orderUpdatedAt: "Commande mise à jour à la table",
  simpleMenuInfo:
    "Note : Le menu simple a une limitation de sélectionner plusieurs options pour chaque repas.",
  fiverr: "Fiverr",
  bySigningUp: "En vous inscrivant, vous acceptez notre",
  privacyPolicy: "Politique de confidentialité",
  termsAndConditions: "Termes et conditions",
  and: "et",
  storeExceedSubscriptionLimit:
    "Le nombre de magasins dépasse la limite d'abonnement, mettez à jour votre plan pour ajouter plus de magasins.",
  someStoreIsNotShowing:
    "Certains magasins ne s'affichent pas en raison de l'expiration de votre abonnement.",
  currentPeriodStart: "Début de la période actuelle",
  currentPeriodEnd: "Votre plan se renouvelle le",
  planCanceledOn: "Votre plan sera annulé le",
  // Subscription plan names
  planEssential: "Essentiel (Gratuit à vie)",
  planStandard: "Standard",
  planProKitchen: "Pro Kitchen",
  planEliteKitchen: "Elite Kitchen",
  // Subscription messages
  orderLimitReached: "Limite de commande atteinte",
  orderLimitReachedMessage: "Vous avez atteint la limite. Veuillez passer au plan Standard pour continuer.",
  upgradePlanToContinue: "Vous avez atteint la limite de commande quotidienne. Veuillez mettre à niveau votre plan pour continuer.",
  upgradePlanToUseService: "Veuillez mettre à niveau votre plan pour utiliser ce service",
  serviceNotAvailable: "Service non disponible",
  daysRemaining: "jours restants",
  upgradeNow: "Mettre à niveau maintenant",
  upgradeRequired: "Mise à niveau requise",
  upgradeToContinue: "Pour continuer à utiliser le système POS, veuillez mettre à niveau votre plan d'abonnement.",
  accessBlocked: "Accès bloqué",
  storeExceededLimitMessage: "Votre magasin a dépassé la limite du plan pendant 7 jours. Veuillez passer au plan Standard pour continuer à utiliser le POS.",
  goBack: "Retour",
  currentPlan: "Plan actuel",
  subscriptionStatus: "Statut de l'abonnement",
  orderLimit: "Limite de commande",
  currentUsage: "Utilisation actuelle",
  unlimited: "Illimité",
  manageSubscriptions: "Gérer les abonnements",
  assignPlan: "Attribuer un plan",
  selectPlan: "Sélectionner un plan",
  updatePlan: "Mettre à jour le plan",
  updating: "Mise à jour...",
  planDetails: "Détails du plan",
  manageAllSubscriptions: "Gérer tous les abonnements des magasins",
  search: "Rechercher des magasins...",
  allPlans: "Tous les plans",
  allStatuses: "Tous les statuts",
  price: "Prix",
  storeAdmin: "Administrateur du magasin",
  actions: "Actions",
  manage: "Gérer",
  noStoresFound: "Aucun magasin trouvé",
  totalStores: "Total des magasins",
  filteredStores: "Filtré",
  comingSoon: "Bientôt disponible",
  stripeIntegrationComingSoon: "L'intégration Stripe arrive bientôt",
  feature: "Fonctionnalité",
  stripeConfiguration: "Configuration Stripe",
  stripeConfigInfo: "Configurez vos clés API Stripe pour activer la gestion des abonnements. Ces clés sont stockées en toute sécurité dans Firestore.",
  stripeSecretKey: "Clé secrète Stripe",
  stripeSecretKeyHint: "Obtenez votre clé secrète depuis Stripe Dashboard > Développeurs > Clés API",
  stripeWebhookSecret: "Secret Webhook Stripe",
  stripeWebhookSecretHint: "Obtenez votre secret webhook depuis Stripe Dashboard > Développeurs > Webhooks",
  webhookEndpointUrl: "URL du point de terminaison Webhook",
  webhookEndpointHint: "Configurez cette URL dans Stripe Dashboard > Développeurs > Webhooks > Ajouter un point de terminaison",
  saveConfiguration: "Enregistrer la configuration",
  saving: "Enregistrement...",
  stripeConfigSaved: "Configuration Stripe enregistrée avec succès",
  onlyOwnerCanConfigure: "Seul le propriétaire du magasin peut configurer les paramètres Stripe",
  unauthorized: "Non autorisé",
  copied: "Copié",
  copiedToClipboard: "copié dans le presse-papiers",
  subscriptionManagement: "Gestion de l'abonnement",
  planName: "Nom du plan",
  manageSubscription: "Gérer l'abonnement",
  manageSubscriptionInfo: "Pour gérer votre abonnement (annuler, mettre à jour le mode de paiement, etc.), veuillez utiliser le portail de facturation ou contacter le support.",
  onlyOwnerCanManage: "Seul le propriétaire du magasin peut gérer les abonnements",
  stripeCheckoutRequiresOnline: "Le paiement Stripe nécessite une connexion Internet",
  cannotDowngrade: "Impossible de rétrograder",
  contactSupportToDowngrade: "Veuillez contacter le support pour rétrograder au plan Essential",
  failedToStartCheckout: "Échec du démarrage du processus de paiement",
  subscription: "Abonnement",
  perDay: "par jour",
  // Plan features
  planFeatures: "Fonctionnalités du plan",
  counterService: "Service au comptoir",
  tableService: "Service à table",
  takeawayService: "Service à emporter",
  deliveryService: "Service de livraison",
  onlineOrders: "Commandes en ligne",
  reservations: "Réservations",
  storeQuantity: "Quantité de magasins",
  dailyOrder: "Limite de commande quotidienne",
  perStore: "par magasin",
  createdBy: "Créé par",
  completedBy: "Complété par",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  sunday: "Dimanche",
  morePrices: "Plus de prix dans les Options",
  moreIngredients: "Plus d'ingrédients dans les Options",
  all_: "Tous",
  filter: "Filtrer",
  expired: "Expiré",
  updated: "Mis à jour",
  limitTime: "Limite de temps",
  limitDay: "Limite de jour",
  outOfStock: "Rupture de stock",
  startFrom: "Commence à partir de",
  endAt: "Finit à",
  hour: "Heure",
  hours: "Heures",
  default: "Par défaut",
  cloud: "Cloud",
  printMethod: "Méthode d'impression",
  sessionCreated: "Session créée",
  orderCreated: "Commande créée",
  event: "Événement",
  eventDescription:
    "Tous les boutons d'impression (par ex., Imprimer la session, Imprimer le bon de commande, Imprimer le bon de cuisine, Imprimer le reçu) déclencheront l'événement de webhook par défaut. Sélectionnez tout type supplémentaire d'événements pour déclencher des webhooks",
  endPointDescription:
    "Entrez l'URL à laquelle vous souhaitez recevoir les webhooks",
  webhookDescription:
    "Nous enverrons une requête POST à cette URL avec un objet JSON représentant les données de l'événement pour tout événement que vous choisissez de déclencher",
  testEndpointUrl: "Tester l'URL du point de terminaison",
  failedToPrint: "Échec de l'impression",
  secretKeyDescription:
    "La clé secrète sera utilisée pour signer le corps HTTP en utilisant HMAC-SHA256 et contenue dans l'en-tête nommé X-Hub-Signature",
  outGoingWebhooks: "Webhooks sortants",
  urlIsRequired: "L'URL est requise",
  invalidUrl: "URL invalide",
  endpointUrl: "URL du point de terminaison",
  addWebhook: "Ajouter un Webhook",
  confirmDeleteWebhook: "Confirmer la suppression du webhook ?",
  printButtonClick: "Cuisine",
  takeOrderforTable: "Commandez ",
  addGuestNumber: "Ajouter invités",
  endSession: "Terminer la session",
  orderNow: "Commandez",
  viewMenu: "Menu",
  adults: "Adultes",
  kids: "Enfants",
  seniors: "Aînés",
  other: "Autre",
  leaveWarning: "Êtes-vous sûr de vouloir quitter? Les modifications que vous avez apportées ne seront peut-être pas enregistrées.",
  personAtTable: "pers.commandant à tbl",
  bePatient: "Veuillez patienter.",
  checkMenu: "Veuillez voir le menu.",
  categoryDeleted: "Catégorie supprimée",
  categorySuccessfullyDeleted: "Catégorie supprimée avec succès",
  errorDeletingCategory: "Erreur lors de la suppression de la catégorie",
  anErrorOccurred: "Une erreur est survenue",
  cloneItem: "Cloner l'article",
  language: "Langue",
  itemPrintName: "Nom de l'impression de l'article",
  samePriceForAllChannels: "Même prix pour tous les canaux",
  editImage: "Modifier l'image",
  removeImage: "Retirer l'image",
  serviceFee: "Frais de service",
  salesReport: "Rapport de ventes",
  chatPrint: "Impression de chat",
  send: "Envoyer",
  openChatPrint: "Ouvrir l'impression du chat",
  deleteCategory: "Supprimer la catégorie",
  deleteCategoryConfirmation: "Confirmer la suppression de la catégorie",
  categoryName: "Nom de la catégorie",
  deleteCategoryWarning: "Êtes-vous sûr de vouloir supprimer cette catégorie ?",
  cannotDeleteCategoryWithItems: "Impossible de supprimer une catégorie contenant des articles",
  totalItems: "Articles au total",
  itemsInCategory: "Articles dans la catégorie",
  pleaseRemoveItemsFirst: "Veuillez d'abord supprimer les articles",
  deletionFailed: "La suppression a échoué",
  transferOwnership: "Transférer la propriété",
  transferOwnershipToast: "La propriété a été transférée",
  verificationEmailSentDescription: "Un e-mail de vérification a été envoyé",
  categoryAll: "Tous",
  languageSettings: "Paramètres de langue",
  selectLanguagePopupInfo: "Veuillez choisir la langue à afficher dans la fenêtre contextuelle de démarrage, mais vous devez obtenir la langue de chaque plat téléchargé dans le système.",
  languagePopupEnabled: "Activer la fenêtre contextuelle de langue",
  languageChoiceActive: "Choix de langue actif",
  selectLanguage: "Sélectionner la langue",
  languageChoiceUpdated: "Choix de langue mis à jour en",
  loadingSession: "Chargement de la session...",
  sessionInvalid: "Session invalide",
  loadingMenu: "Chargement du menu...",
  mergeTables: "Fusionner les Tables",
  selectTablesToMerge: "Sélectionner les Tables à Fusionner",
  selectedTables: "Tables Sélectionnées",
  primary: "Principale",
  active: "Active",
  cannotRemove: "Impossible de Supprimer",
  primaryTableRequired: "Impossible de supprimer la table principale",
  add: "Ajouter",
  applyMerge: "Appliquer la Fusion",
  invalidTables: "Tables Invalides",
  noActiveOrders: "n'ont pas de commandes actives",
  enterYourName: "Entrez votre nom",
  continue: "Continuer",
  othersOrdering: "Bienvenue pour vous joindre!",
  nameRequired: "Nom requis",
  pleaseEnterName: "Veuillez entrer votre nom pour continuer",
  error: "Erreur",
  somethingWentWrong: "Quelque chose s'est mal passé",
  welcomeBack: "Bienvenue de retour",
  pleaseWait: "Veuillez patienter",
  sessionCheckInProgress: "Vérification de session en cours",
  noSuchTable: "Désolé, cette table n'existe pas !",
  waitingForStaff: "En attente du personnel pour vous ouvrir la table ...",
  scanQRCodeAgain: "Veuillez scanner à nouveau le code QR pour commander ou accéder au menu !",
  bonAppetit: "Bon appétit !",
  modalSelectLanguage: "Sélectionner la langue",
  sessionNotProvided: "Aucune session fournie",
  noStoreIdProvided: "Aucun ID de magasin dans la session",
  storeNotConfigured: "Magasin introuvable",
  failedToLoadData: "Échec du chargement des données",
  orderNumber: "Commande #",
  orderTotal: "Total de la commande",
  totalWithTaxes: "Total avec taxes",
  customerName: "Nom",
  totalFor: "Total pour",
  noOrders: "Aucune commande",
  pastOrders: "Commandes passées",
  closeButton: "Fermer",
  thisSelectionIsRequired: "Cette sélection est requise",
  pleaseSelectAtLeast: "Veuillez sélectionner au moins",
  maximumSelections: "Maximum",
  selectionsAllowed: "sélections autorisées",
  optionItems: "options",
  customizeYourOrder: "Personnalisez votre commande",
  totalExtra: "Supplément total",
  cancelButton: "Annuler",
  addToCart: "Ajouter au panier",
  selectExactly: "Vous devez sélectionner exactement",
  singleItem: "élément",
  selectRange: "Sélectionnez",
  rangeTo: "à",
  selectAtLeast: "Sélectionnez au moins",
  selectUpTo: "Sélectionnez jusqu'à",
  selectMultipleOptional: "Sélection multiple (Optionnel)",
  selectOneRequired: "Sélectionnez un (Obligatoire)",
  requiredOption: "Obligatoire",
  invalidStoreId: "ID de magasin invalide",
  tableRedirectStoreNotFound: "Magasin introuvable",
  tableRedirectError: "Une erreur s'est produite. Veuillez réessayer.",
  loadingTable: "Recherche de votre table...",
  fixedTableQrDisabled: "Les codes QR de table fixe sont désactivés pour ce magasin.",
  contactStaffForHelp: "Veuillez contacter le personnel pour obtenir de l'aide",

  // MEV translations
  mevMonitor: "Moniteur MEV",
  mevPrinters: "Imprimantes",
  mevSettings: "Paramètres MEV",
  mevLogs: "Journaux",
  mevGlobalApplicationConfiguration: "Configuration globale de l'application",
  mevRealTimeDiagnosticStream: "Flux de diagnostic en temps réel",
  mevCoreEngineStream: "Flux du moteur principal",
  mevPriorityAll: "Priorité : Tous",
  mevLive: "En direct",
  mevNoSystemEvents: "Aucun événement système",
  mevWaitingForTransactions: "En attente de transactions...",
  mevCertificate: "Certificat",
  mevOrderMonitor: "Moniteur de Commandes MEV",
  orderJobs: "Commandes ({count})",
  noJobsAvailable: "Aucune commande disponible. Surveillance des nouvelles commandes...",
  startedMonitoring: "Surveillance des nouvelles commandes démarrée",
  viewDetails: "Voir les détails",
  jobDetails: "Détails de la Commande",
  jobId: "ID de Commande",
  cloudMevClient: "Client MEV Cloud",
  cloudMev: "MEV cloud",
  cloudMevKicker: "Opérations fiscales infonuagiques",
  cloudMevDescription: "Opérations MEV cloud pour ce magasin. Les identifiants du worker sont configurés par le super administrateur.",
  cloudMevWorker: "Worker",
  cloudMevStatus: "Statut",
  cloudMevStatusHint: "Service et enrôlement MEV cloud actuels pour ce magasin.",
  cloudMevCertificate: "Certificat",
  cloudMevWorkerUrl: "URL du worker",
  cloudMevWorkerSecret: "Secret du worker",
  cloudMevGenerateSecret: "Générer un secret",
  cloudMevCopySecret: "Copier le secret",
  cloudMevSaveWorker: "Enregistrer le worker",
  cloudMevWorkerSaved: "Paramètres du worker enregistrés",
  cloudMevPing: "Tester le worker",
  cloudMevPingOk: "Worker joignable",
  cloudMevPingFail: "Échec du test du worker",
  cloudMevNotConfigured: "Non configuré par le super administrateur",
  cloudMevConfigured: "Prêt",
  cloudMevServiceStatus: "Service cloud",
  cloudMevEnroll: "Enrôler le certificat",
  cloudMevEnrolled: "Certificat enrôlé",
  cloudMevPasteSecretHint: "Collez ce secret dans le tableau de bord Cloudflare Worker comme INTERNAL_SHARED_SECRET.",
  cloudMevUserId: "Numéro d'identification",
  cloudMevAuthCode: "Code d'autorisation",
  cloudMevQstNumber: "Numéro TVQ",
  cloudMevGstNumber: "Numéro TPS",
  cloudMevDossierNumber: "Numéro de dossier",
  cloudMevActivitySubsector: "Sous-secteur d'activité",
  cloudMevNickname: "Surnom du certificat",
  cloudMevEnvironment: "Environnement",
  cloudMevEnvSharedHint: "Cet environnement s'applique à toutes les pages MEV cloud de ce magasin.",
  cloudMevConfirmSwitchEnvTitle: "Changer l'environnement MEV cloud?",
  cloudMevConfirmSwitchEnvBody:
    "Toutes les pages MEV cloud passeront de {from} à {to}. Le certificat du poste de travail de ce magasin utilisera uniquement {to}.",
  cloudMevLastError: "Dernière erreur",
  cloudMevLastEnroll: "Dernier enrôlement",
  cloudMevEnrollmentStatus: "Statut d'enrôlement",
  cloudMevIdApprl: "ID d'approbation",
  cloudMevSelectStore: "Sélectionnez d'abord un magasin",
  cloudMevInvalidUrl: "Entrez une URL HTTPS de worker valide",
  cloudMevSecretRequired: "Générez d'abord un secret de worker",
  cloudMevFillRequired: "Remplissez tous les champs obligatoires",
  cloudMevNicknameForm: "Le nom du certificat de poste est Certificat A avec serveur. Une autre lettre garde cette forme, par exemple Certificat R avec serveur.",
  cloudMevNicknameRequired: "Entrez un surnom de certificat.",
  cloudMevNicknameUseNextCsr: "Générez de nouveau la CSR pour utiliser ce surnom.",
  cloudMevHasSecret: "Le secret est configuré",
  cloudMevNoSecret: "Aucun secret enregistré",
  cloudMevCertificateHint: "Certificat du poste de travail pour ce PC. La clé privée reste sur ce poste.",
  cloudMevCertificateEnvHint: "Le certificat du poste de travail ci-dessous appartient uniquement à {env}.",
  cloudMevAddCertHint: "Si l'appareil n'a pas encore reçu cet identifiant ou si l'identifiant a été perdu, la valeur initiale doit être « 0000-0000-0000 ».",
  cloudMevNoActiveCert: "Aucun certificat MEV cloud actif.",
  cloudMevNoCsrYet: "Aucune DCS pour le moment.",
  cloudMevCsrFailed: "Échec de la génération de la DCS",
  cloudMevExpiry: "Expiration",
  cloudMevDayRemaining: "jour restant",
  cloudMevExpiryWarning: "Le rappel du certificat est actif.",
  cloudMevCertReminder: "Rappel du certificat",
  cloudMevCertReminderStartsInOne: "Le rappel du certificat commencera dans 1 jour.",
  cloudMevCertReminderStartsIn: "Le rappel du certificat commencera dans {days} jours.",
  cloudMevCertReminderActive: "Le rappel du certificat est actif.",
  cloudMevCertReminderDays: "Jours avant l'expiration",
  cloudMevCertReminderDate: "Date du rappel",
  cloudMevCertReminderExpired: "Certificat expiré. Remplacez-le.",
  cloudMevCertReminderExpiresToday: "Le certificat expire aujourd'hui. Remplacez-le.",
  cloudMevCertReminderReplaceOne: "Remplacez le certificat. Il expire dans 1 jour.",
  cloudMevCertReminderReplace: "Remplacez le certificat. Il expire dans {days} jours.",
  cloudMevCertReminderBar: "Le certificat expire dans {days} jours. Cliquez pour les détails.",
  cloudMevCertReminderBarOne: "Le certificat expire dans 1 jour. Cliquez pour les détails.",
  cloudMevCertReminderBarToday: "Le certificat expire aujourd'hui. Cliquez pour les détails.",
  cloudMevCertReminderBarExpired: "Certificat expiré. Cliquez pour les détails.",
  cloudMevCertReminderAdmin: "Informez votre administration de remplacer ce certificat.",
  cloudMevCertReminderDesktop: "Le remplacement du certificat se fait dans ce logiciel, pas sur le web.",
  cloudMevCertificateDetails: "Détails du certificat",
  cloudMevNoLastError: "Aucun",
  cloudMevUsers: "Utilisateurs MEV",
  cloudMevTerminals: "Terminaux",
  cloudMevTerminalName: "Nom du terminal",
  cloudMevAddTerminal: "Ajouter un terminal",
  cloudMevPrimaryTerminal: "Appareil MEV cloud principal",
  cloudMevDeleteTerminal: "Supprimer le terminal?",
  cloudMevDeleteTerminalMessage: "Retirer ce terminal de la liste MEV cloud?",
  cloudMevUserReportHint: "Construire le document RUT annuel et l'envoyer avec le certificat cloud.",
  cloudMevGeneralReport: "Rapport utilisateur",
  cloudMevGeneralReportHint: "Choisissez tous les utilisateurs ou un utilisateur. Le produire l'envoie au WEB-SRM.",
  cloudMevUserChoiceHint: "Choisissez tous les utilisateurs ou un utilisateur. Le produire l'envoie au WEB-SRM.",
  cloudMevCurrentReport: "Votre rapport utilisateur",
  cloudMevCurrentReportHint: "Ce rapport est celui de la personne connectée à ce poste. Le produire l'envoie au WEB-SRM.",
  historyRailHint: "Factures, rapport utilisateur et journal système de ce poste.",
  cloudMevGenerateAndSend: "Produire et envoyer",
  cloudMevReportSentWithGenerate: "Votre rapport a été envoyé au WEB-SRM.",
  cloudMevReportHistory: "Historique des rapports",
  cloudMevReportHistoryEmpty: "Aucun rapport n'a été produit.",
  cloudMevReportHistoryLoading: "Chargement.",
  cloudMevReportDocumentNumber: "Numéro de document de Revenu Québec",
  cloudMevReportView: "Voir",
  cloudMevReportNotStored: "Ce rapport n'a pas été enregistré. Produisez-le de nouveau.",
  cloudMevReportOffline: "Le rapport utilisateur est disponible lorsque ce poste est en ligne.",
  cloudMevReportRemove: "Retirer",
  cloudMevReportRemoveTitle: "Retirer cette inscription?",
  cloudMevReportRemoveMessage: "Le rapport peut être produit de nouveau.",
  cloudMevReportDenied: "Un gestionnaire, l'exploitant ou un utilisateur inscrit au WEB-SRM peut produire le rapport de tous les utilisateurs.",
  cloudMevReportSignIn: "Connectez-vous à ce poste pour produire votre rapport.",
  cloudMevGenerateReport: "Générer le rapport",
  cloudMevSubmitReport: "Soumettre au WEB-SRM",
  cloudMevReportGenerated: "Rapport utilisateur généré",
  cloudMevReportSubmitted: "Rapport utilisateur soumis",
  cloudMevGenerateReportFirst: "Générez d'abord le rapport",
  cloudMevConfirmReport: "Soumettre le rapport utilisateur?",
  cloudMevConfirmReportMessage: "Soumettre ce rapport utilisateur au WEB-SRM?",
  cloudMevReportScope: "Portée",
  cloudMevSingleUser: "Utilisateur actuel",
  cloudMevAllUsers: "Tous les utilisateurs",
  cloudMevOrdersIncluded: "Commandes incluses",
  cloudMevLogsHint: "Opérations MEV cloud pour ce magasin et cet environnement.",
  cloudMevNoLogs: "Aucune opération MEV cloud pour le moment.",
  cloudMevJsonOverlayTitle: "Réponse MEV cloud",
  cloudMevJsonOverlaySending: "Envoi de la transaction MEV cloud…",
  cloudMevJsonOverlayClose: "Fermer",
  cloudMevJsonOverlayHeaders: "En-têtes",
  cloudMevJsonOverlayRequest: "Requête envoyée",
  cloudMevJsonOverlayResponse: "Réponse reçue",
  cloudMevJsonOverlayError: "Erreur MEV cloud",
  cloudMevDebug: "Debug",
  cloudMevDebugHint:
    "Données envoyées à Revenu Québec (Envoi) et reçues (Retour) pour ce magasin et cet environnement.",
  cloudMevDebugUp: "Envoi — envoyé à Revenu Québec",
  cloudMevDebugDown: "Retour — reçu de Revenu Québec",
  cloudMevNoDebug: "Aucun échange Revenu Québec enregistré pour le moment.",
  cloudMevServerResponse: "Réponse du serveur",
  cloudMevNoServerResponse: "Aucune réponse pour le moment.",
  cloudMevWorking: "Traitement en cours… veuillez patienter",
  cloudMevWorkingCsr: "Génération du CSR…",
  cloudMevWorkstationCsrFailed: "Impossible de créer la demande de certificat du poste de travail.",
  cloudMevWorkstationCngRequired: "Windows CNG est requis pour enregistrer la clé du poste de travail.",
  cloudMevWorkstationKeySaveFailed: "Impossible d'enregistrer la clé du poste de travail.",
  cloudMevWorkstationRequestFirst: "Générez d'abord la demande de certificat du poste de travail sur ce PC.",
  cloudMevWorkstationKeyMissing: "La clé privée du poste de travail est introuvable.",
  cloudMevWorkstationRejected: "Revenu Québec a refusé le certificat du poste de travail.",
  cloudMevWindowsStoreRejected: "Le magasin de certificats Windows a refusé le certificat.",
  cloudMevWorkingEnroll: "Envoi de la demande de certificat…",
  cloudMevWorkingRequest: "Envoi de la demande…",
  cloudMevCsrBadOrganization:
    "Ce CSR a Organization Restaurant-…. Revenu Québec exige RBC-<code d'autorisation>. Redéployez le Worker mev-csr, générez un nouveau CSR, puis ajoutez le certificat.",
  cloudMevActiveCertHint: "Certificat MEV actuellement installé",
  cloudMevDeviceId: "ID de l'appareil (IDAPPRL)",
  cloudMevExpirationDate: "Date d'expiration",
  cloudMevCertificateContent: "Contenu du certificat",
  cloudMevNotAssigned: "Non attribué",
  cloudMevInstallCertHint: "Installez un certificat à l'aide des onglets Génération du CSR et Ajout.",
  cloudMevValid: "Valide",
  cloudMevRemaining: "restant",
  cloudMevCsrUsedAt: "Ce CSR a été utilisé le {time}. Il ne peut plus être utilisé.",
  cloudMevCsrAlreadyUsed: "Ce CSR a déjà servi à générer un certificat. Générez un nouveau CSR.",
  cloudMevHowTo: "Guide",
  mevPathEnableTitle: "Activer {name}?",
  mevPathDisableTitle: "Désactiver {name}?",
  mevPathEnableBody: "Les commandes PDV pourront utiliser {name} après confirmation.",
  mevPathDisableBody: "Les commandes PDV n'utiliseront plus {name} tant que vous ne le réactiverez pas.",
  mevPrintersDesktopHint:
    "Les imprimantes physiques utilisent le client MEV de bureau. Ouvrez cette page dans l'application de bureau pour ajouter et gérer les imprimantes.",
  cloudMevHowToTitle: "Première configuration Cloud MEV",
  cloudMevHowToIntro:
    "Ce guide explique comment créer une demande de signature de certificat (CSR), installer le certificat Revenu Québec et ajouter un utilisateur MEV pour que le magasin puisse envoyer des transactions.",
  cloudMevHowToBeforeTitle: "Avant de commencer",
  cloudMevHowToBeforeBody:
    "Ouvrez Cloud MEV et choisissez l'environnement en haut à droite. Utilisez DEV ou ESSAI pour pratiquer. Utilisez PROD seulement lorsque vous êtes prêt à inscrire le magasin auprès de Revenu Québec.",
  cloudMevHowToOverview: "Ce que vous allez faire",
  cloudMevHowToOverview1: "Enregistrer les informations d'entreprise",
  cloudMevHowToOverview2: "Générer un CSR et ajouter le premier certificat",
  cloudMevHowToOverview3: "Noter l'identifiant de l'appareil",
  cloudMevHowToOverview4: "Ajouter un utilisateur MEV",
  cloudMevHowToOpenStep: "Ouvrir cette étape",
  cloudMevHowToStep1Title: "Informations d'entreprise",
  cloudMevHowToStep1Body:
    "Dans Certificat, ouvrez Entreprise. Entrez le nom légal, l'adresse, la ville, la province, le code postal et le téléphone. En production, ces champs sont obligatoires avant que Revenu Québec n'accepte le certificat.",
  cloudMevHowToStep1Action: "Cliquez sur Enregistrer lorsque le formulaire est complet.",
  cloudMevHowToStep2Title: "Créer le CSR et ajouter le certificat",
  cloudMevHowToStep2Body:
    "Ouvrez Créer CSR. Remplissez le numéro d'identification, le code d'autorisation, les numéros TVQ et TPS, le numéro de dossier, le sous-secteur d'activité, le fuseau horaire et le nom du certificat.",
  cloudMevHowToStep2Generate:
    "Cliquez sur Générer CSR. Lorsque la demande réussit, le texte PEM apparaît à droite.",
  cloudMevHowToStep2Add:
    "Pour une première installation, cliquez sur Utiliser pour l'ajout, puis ouvrez Ajouter Certificat et envoyez. N'utilisez pas Remplacer sur un nouveau magasin.",
  cloudMevHowToStep2Success:
    "Un ajout réussi inscrit le certificat. Ce CSR ne peut plus être réutilisé. Générez un nouveau CSR si vous avez besoin d'un autre certificat plus tard.",
  cloudMevHowToStep2Caption: "Créer CSR : générez la demande, puis choisissez Utiliser pour l'ajout la première fois.",
  cloudMevHowToStep3Title: "Protéger l'identifiant de l'appareil",
  cloudMevHowToStep3Body:
    "Après l'ajout du premier certificat, le système émet un identifiant d'appareil unique (IDAPPRL) pour ce MEV. Ouvrez Certificat Actif pour le voir.",
  cloudMevHowToStep3Warn:
    "Cet identifiant est créé une seule fois et ne peut pas être modifié pendant toute la durée de vie de l'appareil. Notez-le et conservez-le précieusement. N'essayez pas de le remplacer, et n'effectuez pas un second ajout initial sur le même magasin.",
  cloudMevHowToStep4Title: "Ajouter un utilisateur",
  cloudMevHowToStep4Body:
    "Ouvrez Certifier l'utilisateur. Entrez le nom ainsi que les numéros TPS et TVQ, puis envoyez. Au moins une personne certifiée est requise avant d'opérer.",
  cloudMevHowToReadyTitle: "Vous êtes prêt",
  cloudMevHowToReadyBody:
    "Avec un certificat actif, un identifiant d'appareil et une personne certifiée, ce magasin peut envoyer des transactions Cloud MEV.",
  cloudMevHowToLaterTitle: "Opérations ultérieures",
  cloudMevHowToDeleteUserTitle: "Supprimer l'utilisateur certifié",
  cloudMevHowToDeleteUserBody:
    "Ouvrez Supprimer l'utilisateur certifié, choisissez la personne, puis confirmez. Le processus est le même que Certifier l'utilisateur, en sens inverse.",
  cloudMevHowToReplaceTitle: "Remplacer un certificat expiré",
  cloudMevHowToReplaceBody:
    "Les certificats Revenu Québec sont généralement valides cinq ans. À l'expiration, générez un nouveau CSR, cliquez sur Utiliser pour le remplacement, puis ouvrez Remplacer Certificat et envoyez. Le nouveau certificat conserve le même identifiant d'appareil.",
  cloudMevHowToReplaceNote:
    "Ne cliquez jamais sur Utiliser pour l'ajout pour renouveler. L'ajout sert uniquement au premier certificat d'un nouvel appareil.",
  confirmSignOut: "Confirmer la déconnexion",
  signOutMessage: "Les tâches d'impression seront manquées lors de la déconnexion",
  signIn: "Se connecter",
  loginRequired: "Connexion requise",
  connected: "Connecté et prêt à recevoir des commandes du cloud",
  disconnected: "Déconnecté, veuillez vous connecter",
  status: "Statut",
  created: "Créé",
  processed: "Traité",
  pending: "En Attente",
  processing: "En Cours",
  completed: "Complété",
  failed: "Échoué",
  environment: "Environnement",
  business: "Entreprise",
  activeCert: "Certificat Actif",
  createCSR: "Créer CSR",
  generateCSR: "Générer CSR",
  addCert: "Ajouter Certificat",
  add_certificate: "Ajouter Certificat",
  replaceCert: "Remplacer Certificat",
  replace_certificate: "Remplacer Certificat",
  deleteCert: "Supprimer Certificat",
  delete_certificate: "Supprimer Certificat",
  addUser: "Ajouter Utilisateur",
  deleteUser: "Supprimer Utilisateur",
  certifyUser: "Certifier l'utilisateur",
  deleteCertifyUser: "Supprimer l'utilisateur certifié",
  businessInformation: "Informations d'Entreprise",
  companyName: "Nom de l'Entreprise",
  contactInformation: "Informations de Contact",
  addressInformation: "Informations d'Adresse",
  addressLine1: "Ligne d'Adresse 1",
  addressLine2: "Ligne d'Adresse 2",
  province: "Province",
  postalCode: "Code Postal",
  printerName: "Nom de l'Imprimante",
  apiKey: "Clé API",
  printerType: "Type d'Imprimante",
  commandLanguage: "Commande d'impression",
  printerTypeNetwork: "Réseau",
  printerTypeWindowsShared: "Partagée Windows",
  printingType: "Type d'impression",
  printCommandCheck: "Vérification de la commande d'impression",
  printCommandSwitchHelp: "Imprimez un coupon d'essai. Confirmez qu'il est lisible avant d'enregistrer cette commande d'impression. La prochaine impression utilisera {command}.",
  printTestSlip: "Imprimer un coupon d'essai",
  printCommandPaused: "L'impression en direct pour cette imprimante est en pause.",
  printCommandThisComputer: "Cet ordinateur",
  printCommandComputerReady: "Cet ordinateur est prêt",
  printCommandComputerNotReady: "Cet ordinateur n'est pas prêt",
  printCommandStoreCopy: "Copie du magasin sur cet ordinateur",
  printCommandChecking: "Vérification",
  printCommandSaved: "Enregistrée",
  printCommandMismatch: "Ne correspond pas",
  printCommandNextJob: "La prochaine impression utilisera {command}.",
  testSlipReadable: "Le coupon d'essai est lisible",
  testSlipNotReadable: "Le coupon d'essai n'est pas lisible",
  printCommandUpdated: "Commande d'impression mise à jour.",
  printCommandNotConfirmed: "Le coupon d'essai n'est pas confirmé. La commande d'impression précédente reste en place.",
  starLine: "Star Line",
  starGraphic: "Star Graphic",
  starPrnt: "StarPRNT",
  starImpact: "Star Impact",
  starSeries: "Série Star",
  printCommandDependsOnConfiguration: "Le protocole dépend de la configuration de l'imprimante. Le coupon d'essai le confirme.",
  escposEmulation: "Émulation ESC/POS",
  escposEmulationHelp: "Laissez cette case décochée, sauf si cette imprimante est réglée sur l'émulation ESC/POS. Si elle n'est pas réglée, le reçu ne s'imprimera pas correctement.",
  numCopies: "Nombre de Copies",
  networkPrinterAddress: "Adresse de l'Imprimante Réseau",
  networkPrinterPort: "Port de l'Imprimante Réseau",
  windowsSharedPrinterName: "Nom de l'Imprimante Partagée Windows",
  printerModelNumber: "Numéro de modèle",
  printerModelNumberHelp: "Facultatif. Pour votre information.",
  printerLocation: "Emplacement",
  printerLocationHelp: "Facultatif. Où se trouve cette imprimante.",
  addPrinter: "Ajouter une Imprimante",
  editPrinter: "Modifier l'Imprimante",
  edit_printer: "Modifier l'Imprimante",
  add_printer: "Ajouter une Imprimante",
  printer_name: "Nom de l'Imprimante",
  api_key: "Clé API",
  num_copies: "Nombre de Copies",
  printer_type: "Type d'Imprimante",
  network_printer_address: "Adresse de l'Imprimante Réseau",
  network_printer_port: "Port de l'Imprimante Réseau",
  windows_shared_printer_name: "Nom de l'Imprimante Partagée Windows",
  test_printer: "Tester l'Imprimante",
  print_qr_receipt: "Imprimer le Reçu QR",
  save_changes: "Enregistrer les Modifications",
  receipt_image_settings: "Paramètres d'image du reçu MEV",
  receipt_text_settings: "Paramètres de texte du reçu MEV",
  receipt_text_enabled: "Imprimer sur le reçu",
  open_at_os_startup: "Ouvrir au démarrage du système",
  openAtOsStartupHelp: "L'application s'ouvre au démarrage de l'ordinateur.",
  print_merchant_copy: "Imprimer copie marchand avec facturation (Facture d'original)",
  print_merchant_copy_temporary: "Imprimer copie marchand avec facturation (Facture d'original)",
  print_merchant_copy_closing: "Imprimer copie marchand avec finalisation (Reçu de fermeture)",
  merchant_copy_font_size_increase: "Augmenter la taille de police de",
  no_increase: "Aucune augmentation",
  receipt_content_shift: "Décalage du contenu du reçu (négatif vers la gauche)",
  receipt_content_shift_range: "(-20 à 20)",
  api_wait_time: "Temps d'attente API MEV",
  api_wait_time_description: "Temps d'attente maximum pour la communication avec WEB-SRM (minimum 5 secondes)",
  save_receipt_as_image: "Enregistrer le reçu en tant qu'image",
  save_location: "Emplacement de sauvegarde",
  enter_folder_path: "Entrez le chemin du dossier",
  chooseFolderPath: "Choisir un dossier",
  receiptImageMaxHint: "Conserve les 100 images de reçu les plus récentes. Les plus anciennes sont supprimées automatiquement pour ne pas remplir le disque.",
  receiptImageFolderDesktopHint: "Ouvrez cette page dans l'application bureau pour choisir un dossier Windows.",
  scrollPageUp: "Page précédente",
  scrollPageDown: "Page suivante",
  scrollToTopHint: "Appuyez pour monter d'une page. Maintenez pour aller en haut.",
  scrollToBottomHint: "Appuyez pour descendre d'une page. Maintenez pour aller en bas.",
  receipt_text_top: "Texte du haut du reçu (max 100 caractères)",
  receipt_text_bottom: "Texte du bas du reçu (max 100 caractères)",
  receipt_text_french_notice: "Les reçus émis au Québec doivent être en français, y compris le libellé des taxes. Le texte personnalisé de cette carte n'est pas transmis au WEB-SRM.",
  receipt_text_compliance_title: "Avis de conformité – Charte de la langue française",
  receipt_text_compliance_body: "En vertu des articles 57, 89 et 91 de la Charte de la langue française et des règles de facturation obligatoire de Revenu Québec, tout reçu produit au Québec doit être rédigé en français. Tout texte personnalisé ajouté au reçu demeure l'entière responsabilité légale et réglementaire de l'exploitant.\n\nSi vous ajoutez un texte personnalisé ou non français au reçu, vous reconnaissez que votre entreprise assume l'entière responsabilité des amendes, sanctions ou conséquences réglementaires en cas de non-conformité.",
  receipt_text_compliance_consent: "J'ai lu l'avis, je confirme que le texte du reçu respecte la réglementation linguistique du Québec et j'accepte d'en assumer l'entière responsabilité.",
  receipt_text_agree_save: "Accepter",
  receipt_text_not_french: "Ce texte ne contient pas de caractères français. Voulez-vous vraiment l'enregistrer?",
  receipt_text_save_anyway: "Enregistrer quand même",
  enter_top_text: "Bienvenue chez",
  enter_bottom_text: "Merci, journée",
  last_edited: "Dernière modification",
  total_logs: "Total des journaux: {count} entrées",
  system_logs: "Journaux système",
  print_jobs_live_logs: "Journaux en direct des tâches",
  removePrinter: "Supprimer l'Imprimante",
  printers: "Imprimantes",
  printerOffline: "Imprimante hors ligne",
  systemDeviceManagement: "Gestion des périphériques",
  printerVirtualName: "Imprimante virtuelle",
  printerApiKeyTail: "Clé API",
  printerStatusOnline: "En ligne",
  enableDisablePrinter: "Activer/Désactiver",
  printerPrintingOff: "Impression arrêtée",
  printerTurnOffPrinting: "Désactiver l'impression",
  printerTurnedOffHelp: "L'imprimante peut rester en ligne. L'impression est arrêtée.",
  printerNoTicket: "Veuillez sélectionner une imprimante virtuelle. Sinon, aucun ticket ne sera imprimé sur cette imprimante.",
  createVirtualPrinter: "Créer une imprimante virtuelle",
  printersInfoQMev: "Qu'est-ce que l'imprimante Cloud MEV ?",
  printersInfoAMev: "L'imprimante Cloud MEV est une imprimante virtuelle obligatoire. Elle imprime le reçu du client et le reçu du commerçant. Le reçu du client contient le code QR et les renseignements de Revenu Québec. Le client vérifie le reçu en balayant le code QR.",
  printersInfoAMevLimits: "Certains de ses paramètres peuvent être modifiés. Elle ne peut pas être supprimée.",
  printersInfoQKitchen: "Qu'est-ce que Kitchen All ?",
  printersInfoAKitchen: "Kitchen All est l'imprimante virtuelle obligatoire pour la cuisine. Sa liste de plats reste entièrement sélectionnée, donc chaque plat de cuisine y est imprimé. Un plat ajouté ensuite est assigné automatiquement à cette imprimante virtuelle.",
  printersInfoAKitchenLimits: "Certains paramètres peuvent être modifiés, y compris le comportement de coupe. Elle ne peut pas être renommée ni supprimée.",
  printersInfoQSplit: "Qu'est-ce qu'une imprimante virtuelle ? Pourquoi en ai-je besoin ?",
  printersInfoASplit: "L'impression répartie envoie les plats de cuisine vers des imprimantes différentes.",
  printersInfoAVirtual: "Une imprimante virtuelle est requise. Elle regroupe les plats qui s'impriment ensemble. Assignez ces plats à l'imprimante virtuelle et définissez le comportement de coupe de ce groupe.",
  printersInfoAssign: "Un plat qui n'est assigné à aucune imprimante virtuelle n'est pas imprimé.",
  itemPrinterAssignWarning: "Assignez ce plat à une imprimante virtuelle dans Paramètres, sous Imprimer, dans Liste des imprimantes.",
  printersInfoQExample: "J'ai trois postes : Légumes, Viande et Bar. Chaque poste a sa propre imprimante. Comment configurer l'impression répartie ?",
  printersInfoExampleStep1: "Créez trois imprimantes virtuelles, une pour chaque poste, et assignez les plats correspondants à chaque imprimante virtuelle.",
  printersInfoExampleStep2: "Allez dans Imprimantes, créez une imprimante, et assignez l'imprimante virtuelle correspondante à l'imprimante physique.",
  printersInfoExampleStep3: "Lorsqu'un nouvel article de légumes, de viande, de spiritueux ou de vin est ajouté au menu, assignez-le à l'imprimante virtuelle pour qu'il soit imprimé.",
  printerStatusOffline: "Hors ligne",
  printerQrEnabled: "QR activé",
  addPrinterButton: "Ajouter une Imprimante",
  findPrinters: "Trouver des imprimantes",
  printerDiscovery: "Découverte",
  findPrintersHint: "Recherchez sur cet ordinateur et le réseau local, puis ajoutez les imprimantes voulues.",
  findPrintersScan: "Analyser",
  findPrintersStopScan: "Arrêter l'analyse",
  findPrintersLastScan: "Dernière analyse",
  findPrintersNeverScanned: "Aucune analyse pour le moment. Cliquez sur Analyser pour rechercher.",
  findPrintersAddSelected: "Ajouter la sélection",
  findPrintersCheckIp: "Vérifier l'IP",
  findPrintersEmpty: "Aucune imprimante trouvée. Relancez l'analyse ou ajoutez une adresse IP.",
  findPrintersSelectOne: "Sélectionnez au moins une imprimante à ajouter.",
  findPrintersAddedTitle: "Imprimantes ajoutées",
  findPrintersAddedBody: "Les imprimantes sélectionnées ont été ajoutées. Vous pouvez les modifier plus tard.",
  findPrintersAlreadyAddedTitle: "Cette imprimante a déjà été ajoutée",
  findPrintersAlreadyAddedBody: "Cette imprimante est déjà dans votre liste. La même imprimante peut servir à des usages différents. Voulez-vous l'ajouter une fois de plus ?",
  findPrintersAlreadyAddedManyBody: "Une ou plusieurs imprimantes sélectionnées sont déjà dans votre liste. La même imprimante peut servir à des usages différents. Voulez-vous les ajouter une fois de plus ?",
  findPrintersDesktopHint: "Ouvrez cette page dans l'application bureau pour rechercher les imprimantes de cet ordinateur et du réseau local.",
  addPrinterByIp: "Ajouter une imprimante par adresse IP",
  addPrinterManually: "Saisir manuellement",
  printerNotFoundTitle: "Imprimante introuvable",
  printerNotFoundBody: "Nous n'avons pas trouvé cette imprimante. Vous pouvez tout de même l'ajouter et l'allumer plus tard.",
  printerStatusReady: "Prête",
  printerStatusError: "Erreur",
  printerStatusUnreachable: "Injoignable",
  printerStatusUnknown: "Inconnu",
  noPrintersFound: "Aucune imprimante trouvée. Cliquez sur 'Ajouter une Imprimante' pour commencer.",
  deletePrinterTitle: "Supprimer l'imprimante",
  deletePrinterConfirm: "Êtes-vous sûr de vouloir supprimer cette imprimante?",
  mevDefaultPrinterName: "Imprimante MEV",
  mevCustomerReceiptEntry: "Reçu client MEV",
  mevPrinterNotConfigured: "Non configurée",
  mevPrinterReservedApiKey: "Cette imprimante est réservée aux reçus MEV.",
  mevSetWindowsSharedPrinterName: "Définissez le nom de l'imprimante partagée Windows",
  mevWindowsSharedPrinterHint: "Entrez le nom de l'imprimante partagée Windows pour que cette imprimante MEV puisse imprimer.",
  mevVirtualPrinterFromSettings: "Imprimante virtuelle (paramètres)",
  mevSelectVirtualPrinter: "-- Sélectionner une imprimante virtuelle --",
  mevNoVirtualPrinters: "Aucune imprimante virtuelle dans les paramètres",
  proceed: "Procéder",
  success: "Succès",
  confirmCertificateAddition: "Confirmer l'Ajout de Certificat",
  confirmCertificateAdditionMessage: "Vous êtes sur le point d'ajouter un nouveau certificat. Êtes-vous sûr de vouloir continuer?",
  confirmCertificateDeletion: "Confirmer la Suppression de Certificat",
  confirmCertificateDeletionMessage: "Vous êtes sur le point de supprimer le certificat avec le numéro de série {serialNumber}. Êtes-vous sûr de vouloir continuer?",
  confirmUserAddition: "Confirmer Certifier l'utilisateur",
  confirmUserAdditionMessage: "Vous êtes sur le point de certifier cette personne. Voulez-vous continuer?",
  confirmUserDeletion: "Confirmer Supprimer l'utilisateur certifié",
  confirmUserDeletionMessage: "Vous êtes sur le point de retirer cette certification. Voulez-vous continuer?",
  mevTypeDelete: "Tapez delete",
  mevUserAdded: "Ajouté",
  certificateDeletedSuccess: "Le certificat a été supprimé avec succès.",
  userAddedSuccess: "L'utilisateur a été ajouté avec succès.",
  userDeletedSuccess: "L'utilisateur a été supprimé avec succès.",
  logs: "Journaux",
  userReport: "Rapport utilisateur",
  identification_number: "Numéro d'identification",
  authorization_code: "Code d'autorisation",
  qst_number: "Numéro TVQ",
  gst_number: "Numéro TPS",
  dossier_number: "Numéro de dossier",
  certificate: "Certificat",
  requiredFieldsMissing: "Champs Requis Manquants",
  fillRequiredFields: "Veuillez remplir tous les champs requis: {fields}",
  saveModifications: "Enregistrer les Modifications",
  saveChanges: "Enregistrer les Modifications",
  mevCustomerReceiptInfo: "Utilisez 'MEV-CUSTOMER-RECEIPT' comme clé API pour les reçus MEV",
  submit: "Soumettre",
  testPrinter: "Tester l'Imprimante",
  printTestSent: "Test d'impression envoyé avec succès",
  printTestFailed: "Échec du test d'impression : {error}",
  printQrReceipt: "Imprimer le Reçu QR",
  enterBottomText: "Entrez le texte à afficher en bas des reçus",
  enterFolderPath: "Entrez le chemin du dossier",
  enterTopText: "Entrez le texte à afficher en haut des reçus",
  lastEdited: "Dernière Modification",
  merchantCopyFontSizeIncrease: "Augmentation de la Taille de Police de la Copie Marchand",
  noIncrease: "Aucune Augmentation",
  openAtOsStartup: "Ouvrir au Démarrage du Système",
  printJobsLiveLogs: "Journaux en Direct des Travaux d'Impression",
  printMerchantCopy: "Imprimer la Copie Marchand",
  receiptContentShift: "Décalage du Contenu du Reçu",
  receiptContentShiftRange: "Ajuster la position horizontale (-50 à 50 pixels)",
  receiptImageSettings: "Paramètres de l'Image du Reçu",
  receiptTextBottom: "Texte du Bas du Reçu",
  receiptTextSettings: "Paramètres du Texte du Reçu",
  receiptTextTop: "Texte du Haut du Reçu",
  saveLocation: "Emplacement de Sauvegarde",
  saveReceiptAsImage: "Enregistrer le Reçu comme Image",
  systemLogs: "Journaux Système",
  logViewerSubtitle: "Actions du personnel et réponses WEB-SRM",
  logFiles: "Fichiers journaux",
  logDay: "Jour",
  bothLogs: "PDV et WEB-SRM",
  posLog: "Journal PDV",
  logReceiptEmailedTo: "Reçu envoyé à",
  logReceiptEmailed: "Reçu envoyé",
  logReceiptEmailQueuedFor: "Courriel du reçu en attente pour",
  logReceiptEmailQueued: "Courriel du reçu en attente",
  logReceiptEmailNotDeliveredTo: "Courriel du reçu non livré à",
  logReceiptEmailNotDelivered: "Courriel du reçu non livré",
  logReceiptEmailSkippedFor: "Courriel du reçu omis pour",
  logReceiptEmailSkipped: "Courriel du reçu omis",
  logReceiptAlreadySent: "déjà envoyé",
  apiLog: "Journal WEB-SRM",
  noApiLogForDay: "Aucun journal WEB-SRM pour ce jour.",
  fastFilters: "Filtres",
  allEvents: "TOUS LES ÉVÉNEMENTS",
  searchLogs: "Rechercher dans le journal...",
  noLogsInFile: "Aucun journal pour ce jour.",
  eventTime: "HEURE",
  eventType: "TYPE",
  eventDescription: "DESCRIPTION",
  copyDay: "Copier la journée",
  dayCopied: "Copié dans le presse-papiers",
  copyFailed: "La copie n'a pas pu être effectuée.",
  nothingToCopy: "Aucun enregistrement n'est disponible pour cette journée.",
  backupYourLog: "Exporter les journaux",
  backupFrom: "Du",
  backupTo: "Au",
  backupRange: "Sélectionnez une période de 30 jours ou moins.",
  backupTooWide: "La période ne peut pas dépasser 30 jours. Exportez les autres périodes séparément.",
  backupTooLarge: "L'exportation dépasse le délai autorisé. Sélectionnez une période plus courte.",
  backupEmpty: "Aucun enregistrement n'a été trouvé pour la période sélectionnée.",
  backupReady: "Le fichier d'exportation se trouve dans",
  backupFailed: "L'exportation n'a pas pu être effectuée.",
  deleteOldLogs: "Supprimer les journaux",
  deleteOldLogsTitle: "Supprimer les journaux?",
  deleteOldLogsMessage: "Seuls les journaux de plus de six ans peuvent être supprimés.",
  oldLogsDeleted: "Les enregistrements de plus de six ans ont été supprimés.",
  noOldLogs: "Aucun enregistrement de plus de six ans n'a été trouvé.",
  deleteOldFailed: "La suppression n'a pas pu être effectuée.",
  failedToListLogs: "Impossible de lister les fichiers journaux",
  failedToReadLog: "Impossible de lire le fichier journal",
  totalLogs: "Total des Journaux: {count}",
  requiredField: "Champ requis",
  confirmCsrGeneration: "Confirmer la génération du CSR",
  confirmCsrGenerationMessage: "Vous êtes sur le point de générer une nouvelle demande de signature de certificat (CSR). Cette opération peut écraser tout CSR en attente existant. Êtes-vous sûr de vouloir continuer?",
  useInAddition: "Utiliser pour ajouter le certificat",
  useInReplacement: "Utiliser pour remplacer le certificat",
  copyToClipboard: "Copier dans le presse-papiers",
  copied: "Copié",
  certificate_details: "Détails du certificat",
  certificate_text: "Texte du certificat",
  expiry: "Expiration",
  serial: "Numéro de série",
  idapprl: "IDAPPRL",
  noActiveCertificate: "Aucun certificat actif trouvé. Veuillez d'abord ajouter un certificat.",
  expired: "Expiré",
  posDashboard: "Tableau de bord POS",
  quickAccessToPosFunctions: "Accès rapide à toutes les fonctions POS",
  quickAccessProducts: "Produits en accès rapide",
  pinSearchRow: "Épingler la recherche",
  unpinSearchRow: "Désépingler la recherche",
  pinMenu: "Épingler le menu",
  unpinMenu: "Désépingler le menu",
  pinPaymentMethod: "Épingler le mode de paiement",
  unpinPaymentMethod: "Désépingler le mode de paiement",
  pinCategory: "Épingler la catégorie",
  unpinCategory: "Désépingler la catégorie",
  quebecAlcoholTax: "Taxe sur l'alcool du Québec",
  backToDashboard: "Retour au tableau de bord",
  dashboardPage: "Page du tableau de bord",
  categories: "Catégories",
  products: "Produits",
  tables: "Tables",
  kds: "KDS",
  transactions: "Transactions",
  delivery: "Livraison",
  browseByCategory: "Parcourir par catégorie",
  browseByCategoryCounterService: "Parcourir par catégorie/Service au comptoir",
  quickSaleTakeaway: "Vente rapide / À emporter",
  counterServiceQuickSales: "Service au comptoir / Service rapide",
  savedCart: "Tickets en attente",
  savedCartDescription: "Voir et gérer les tickets de comptoir en attente",
  parkedTickets: "Tickets en attente",
  parkedTicketsDescription: "Voir et gérer les tickets de comptoir en attente",
  parked: "En attente",
  parkedPrintedOrder: "Tickets en traitement",
  noParkedPrintedOrders: "Aucune commande en cours",
  sortByOrderNumber: "Trier par numéro de commande",
  ticketsInProgress: "TEC",
  ticketsInProgressFull: "Tickets en cours",
  ticketsInProgressDescription: "Commandes au comptoir",
  newOrder: "Nouvelle commande",
  sortByNumber: "Trier par numéro",
  tipItems: "Articles",
  tipRefunded: "Remboursé",
  tipPaymentChanged: "Mode de paiement modifié",
  tipReprints: "Réimpressions",
  reprintKitchenReceipt: "Réimprimer le bon de cuisine",
  reprintKitchenSent: "Bon de cuisine envoyé",
  reprintKitchenPrinted: "Imprimé",
  reprintKitchenNone: "Aucune cuisine n'est configurée pour ces articles",
  reprintKitchenFailed: "Le bon de cuisine n'a pas été envoyé",
  tipService: "Service",
  tipInProcess: "En cours",
  tipCanceled: "Annulé",
  tipTemporaryBillPrinted: "Facture temporaire imprimée",
  tipCancellationReceipt: "Reçu d'annulation",
  tipCanceledNoNumber: "Sans numéro",
  noCanceledTickets: "Aucun ticket annulé",
  tipNewPhoneOrder: "Nouvelle commande téléphonique",
  tipDispatch: "Répartition",
  tipAsap: "Dès que possible",
  tipDueSoon: "Échéance proche",
  tipLate: "En retard",
  tipLocalDelivery: "Livraison locale",
  tipPhoneOrder: "Commande téléphonique",
  tipDeliveryFee: "Frais de livraison",
  tipDistance: "Distance",
  tipNote: "Note",
  tipAddress: "Adresse",
  tipStatusReady: "Prête",
  tipStatusOnRoute: "En route",
  tipStatusComplete: "Terminée",
  tipStatusCanceled: "Annulée",
  tipStatusConfirmed: "Confirmée",
  takeawayStartTitle: "Nouvelle commande pour emporter",
  takeawayStartHint: "Choisissez le type de commande.",
  takeawayThisOrder: "Cette commande",
  takeawayDefaultLabel: "Par défaut",
  takeawaySetDefault: "Option par défaut",
  takeawayDefaultHint: "Utilisé à la prochaine ouverture.",
  phoneOrderInformationRequired: "Renseignements requis pour la commande téléphonique",
  customerInfoRequiredMessage: "Les renseignements suivants sont requis avant de poursuivre ce ticket.",
  customerInfoComplete: "Renseignements du client complets",
  customerInfoCompleteMessage: "Tous les renseignements requis sont présents. Poursuivez l'action précédente.",
  customerFieldPresent: "Saisi",
  customerFieldMissing: "Manquant",
  enterCustomerInfo: "Saisir les renseignements du client",
  parkTicket: "Stationner le ticket",
  parkTicketTitle: "Stationner ce ticket ?",
  parkTicketLeaveMessage: "Ce ticket contient des articles. Stationnez-le pour plus tard ou jetez-le.",
  parkTicketLeaveMessageTakeaway: "Ce ticket contient des articles. Stationnez-le dans TEC (Pour emporter), jetez-le ou demeurez sur cet écran.",
  parkTicketLeaveMessageDelivery: "Ce ticket contient des articles. Stationnez-le dans TEC (Livraison), jetez-le ou demeurez sur cet écran.",
  parkOnTakeaway: "Stationner le ticket",
  parkOnDelivery: "Stationner le ticket",
  ticketParked: "Ticket stationné",
  orderSavedToTip: "La commande a été enregistrée dans TIP. Vous la trouverez dans TIP.",
  parkChoiceTitle: "Stationner",
  parkChoiceHint: "Choisissez la prochaine étape.",
  parkGoToTip: "Aller à TEC",
  stayHere: "Rester ici",
  openTicketsInProgress: "Ouvrir les tickets en cours",
  seatAtTable: "Asseoir à une table",
  seatHere: "Asseoir ici",
  freeSeats: "{free} libres",
  partyNeedsSeats: "Ce groupe a besoin de {party} places.",
  saleKeepsNumber: "Cette vente conserve {number}.",
  saleStartsAtTable: "Cette vente commence à la table.",
  noTableWithSeats: "Aucune table n'a assez de places libres.",
  seatedAtTable: "Assis à la table",
  ticketParkedMessage: "Le ticket est en attente.",
  ticketParkedOnTakeaway: "Le ticket est stationné dans TEC (Pour emporter).",
  ticketParkedOnDelivery: "Le ticket est stationné dans TEC (Livraison).",
  errorParkingTicket: "Échec du stationnement du ticket",
  discardTicket: "Jeter",
  draftTicket: "Brouillon",
  stay: "Rester",
  noSavedCarts: "Aucun ticket en attente",
  noSavedCartsDescription: "Les tickets de comptoir en attente apparaîtront ici",
  savedAt: "Stationné",
  openCart: "Ouvrir le ticket",
  confirmDeleteCart: "Êtes-vous sûr de vouloir jeter ce ticket ?",
  deleteSavedCart: "Jeter le ticket",
  areYouSureDeleteCart: "Êtes-vous sûr de vouloir jeter {name} ?",
  cartSaved: "Ticket stationné",
  cartSavedMessage: "Ticket stationné.",
  errorSavingCart: "Échec du stationnement du ticket",
  pleaseAddItemBeforeSave: "Veuillez ajouter un article avant de stationner",
  errorCreatingNewSession: "Échec de la création d'une nouvelle session de comptoir",
  skipCheckoutModalForCounterService: "Ignorer la fenêtre Envoyer pour le service au comptoir",
  skipCheckoutModalForCounterServiceDescription: "Lorsque ce réglage est activé, les commandes au comptoir passent directement à la fenêtre de paiement.",
  skipCheckoutModalUpdated: "Réglage de la fenêtre Envoyer mis à jour",
  errorUpdatingSetting: "Échec de la mise à jour du paramètre",
  tableLayoutManagement: "Gestion des commandes en direct des tables.",
  kitchenDisplaySystem: "Système d'affichage de cuisine",
  kitchenPoweredBy: "Propulsé par NuagePOS Eagle",
  kdsUserSettings: "KDS",
  kdsNetworkAddress: "Adresse KDS",
  kdsNetworkAddressPending: "Recherche de l'adresse réseau de cet ordinateur...",
  voiceAnnouncement: "Voix",
  voiceAnnouncementHelp: "Activez la voix, choisissez les voix, puis reliez-les à un événement et à une sortie.",
  voiceAnnouncementEnabled: "Activer la voix",
  voiceAnnouncementLanguage: "Langue",
  voiceLanguageEnglish: "Anglais",
  voiceLanguageFrench: "Français",
  voiceLanguageChinese: "Chinois",
  voiceAnnouncementVoice: "Voix",
  voiceAnnouncementSpeed: "Vitesse",
  voiceAnnouncementVolume: "Volume",
  voiceAnnouncementTest: "Tester la voix",
  voiceAnnouncementTesting: "Lecture...",
  voiceAnnouncementSave: "Enregistrer",
  voiceAnnouncementSaved: "Annonce vocale enregistrée",
  voiceAnnouncementSaveFailed: "Échec de l'enregistrement de l'annonce vocale",
  voiceAnnouncementDeviceVoice: "Lu avec la voix de cet appareil",
  voiceAnnouncementDeviceVoiceHelp: "Google Text-to-Speech était indisponible, donc l'ordinateur a lu l'exemple.",
  voiceAnnouncementTestFailed: "Échec du test vocal",
  voiceLanguageTurnOn: "Activer",
  voiceGenderFemale: "Femme",
  voiceGenderMale: "Homme",
  voiceRegionEnUS: "Anglais américain",
  voiceRegionEnCA: "Anglais canadien",
  voiceRegionEnGB: "Anglais britannique",
  voiceRegionEnAU: "Anglais australien",
  voiceRegionEnIN: "Anglais indien",
  voiceRegionFrCA: "Français canadien",
  voiceRegionFrFR: "Français européen",
  voiceRegionCmnCN: "Mandarin",
  voiceRegionCmnTW: "Mandarin de Taïwan",
  voiceRegionYueHK: "Cantonais",
  voiceLibraryTab: "Bibliothèque de voix",
  voiceEventsTab: "Événements",
  voiceDestinationsTab: "Sorties",
  voiceLibraryHelp: "Chaque ligne est une voix réutilisable. La vitesse et le volume sont enregistrés avec cette voix.",
  voiceAddProfile: "Ajouter une voix",
  voiceProfileName: "Nom",
  voiceProfileOff: "désactivée",
  voiceDeleteProfileTitle: "Supprimer cette voix ?",
  voiceDeleteProfileConfirm: "Les événements qui utilisent cette voix ne l'annonceront plus.",
  voiceEventOrderCreated: "Nouvelle commande créée",
  voiceEventsHelp: "Reliez des voix et des répartiteurs KDS à chaque événement. Une voix parle lorsqu'elle est activée dans la bibliothèque et cochée ici. L'annonce se joue sur l'écran de cuisine où cet utilisateur KDS est connecté.",
  voiceEventVoices: "Voix",
  voiceEventDestinations: "Sorties",
  voiceNoProfiles: "Ajoutez d'abord une voix dans la bibliothèque.",
  voiceDestinationsHelp: "Cet ordinateur joue sur ses propres haut-parleurs pour que vous puissiez tester. Chaque répartiteur KDS joue sur l'écran de cuisine où cet utilisateur est connecté, après Activer l'audio.",
  voiceThisComputer: "Cet ordinateur",
  voiceThisComputerHelp: "Les haut-parleurs de cet ordinateur. Laissez ceci activé pour tester une nouvelle commande ici.",
  voiceNoSplitters: "Créez d'abord un répartiteur pour un utilisateur KDS.",
  voiceEnableAudio: "Activer l'audio",
  voiceAudioOn: "Audio activé",
  voiceThisScreenHelp: "Chaque page POS ou KDS ouverte annonce lorsque cette sortie est cochée sur un événement.",
  voiceAddKds: "Ajouter un écran de cuisine",
  voiceAddNetwork: "Ajouter un haut-parleur réseau",
  voiceEndpoint: "Adresse du haut-parleur",
  voiceNetworkHelp: "Enregistrée pour un pont local sur l'ordinateur du POS. Ce navigateur ne lit pas cette sortie.",
  voiceThisDevice: "Cet appareil",
  voiceThisDeviceNone: "Pas un écran de cuisine",
  voiceThisDeviceHelp: "Sur une tablette de cuisine, choisissez le nom de l'écran. Ce choix reste sur cet appareil.",
  voiceUnlock: "Activer le son sur cet écran",
  voiceUnlockHelp: "Touchez ce bouton une fois sur cet ordinateur pour que le navigateur puisse jouer le test.",
  voiceUnlocked: "Le son est activé sur cet écran",
  voiceDestinationTypeScreen: "Cet écran",
  voiceDestinationTypeKds: "Écran de cuisine",
  voiceDestinationTypeNetwork: "Haut-parleur réseau",
  voiceDeleteDestinationTitle: "Supprimer cette sortie ?",
  voiceDeleteDestinationConfirm: "Les événements qui utilisent cette sortie ne l'utiliseront plus.",
  kdsSplittingTab: "Répartition",
  kdsGroupingTab: "Regroupement",
  kdsGroupingHelp: "Chaque règle a son propre interrupteur. Activez-en une, ou les deux. La note ci-dessous suit les interrupteurs choisis.",
  kdsGroupingTimeOn: "Activé. L'horloge regroupe les plats identiques à la fin de la période.",
  kdsGroupingTimeOff: "Désactivé. L'horloge ne regroupe pas les tickets.",
  kdsGroupingCountOn: "Activé. Les plats identiques sont regroupés une fois le nombre de commandes atteint.",
  kdsGroupingCountOff: "Désactivé. Le nombre de commandes ne regroupe pas les tickets.",
  kdsGroupingOffTitle: "Les deux règles sont désactivées",
  kdsGroupingOffBody: "Les tickets restent séparés. Activez l'intervalle de temps, le nombre de commandes, ou les deux.",
  kdsGroupingTimeOnlyTitle: "L'intervalle de temps est activé",
  kdsGroupingTimeOnlyBody: "Toutes les {minutes} minutes, à partir de la minute {start} de chaque heure, les plats arrivés dans cette période sont combinés, qu'il y ait 3 ou 16 commandes. Les commandes encore dans la période en cours restent des tickets séparés jusqu'à la fin du temps.",
  kdsGroupingCountOnlyTitle: "Le nombre de commandes est activé",
  kdsGroupingCountOnlyBody: "Tous les {count} commandes du même chef, les plats identiques sont combinés. Les commandes 1 à {count} forment un groupe, puis les {count} suivantes forment le groupe suivant. Celles qui n'ont pas encore atteint {count} restent séparées.",
  kdsGroupingBothTitle: "Les deux règles sont activées",
  kdsGroupingBothBody: "La limite atteinte en premier ferme le groupe, puis les deux recommencent. Si {count} commandes arrivent avant {minutes} minutes, elles sont regroupées tout de suite et le minuteur repart. Si les {minutes} minutes passent en premier, les commandes déjà arrivées sont regroupées et le compteur repart.",
  kdsGroupingTableRule: "Règle",
  kdsGroupingTableExample: "Exemple",
  kdsGroupingTableResult: "Ce que la cuisine voit",
  kdsGroupingTableTimeRule: "Intervalle de temps seul",
  kdsGroupingTableTimeExample: "Toutes les {minutes} minutes",
  kdsGroupingTableTimeDetail: "N'importe quel nombre de commandes peut arriver dans la période, par exemple 3 ou 16.",
  kdsGroupingTableTimeResult: "À la fin des {minutes} minutes, toutes les commandes de cette période sont combinées, peu importe le nombre.",
  kdsGroupingTableCountRule: "Nombre de commandes seul",
  kdsGroupingTableCountExample: "Toutes les {count} commandes",
  kdsGroupingTableCountDetail: "Les commandes continuent d'arriver. Il n'y a pas de minuteur.",
  kdsGroupingTableCountResult: "Le groupe se ferme dès que {count} commandes arrivent. Les {count} suivantes forment le groupe suivant. Le reste reste en tickets séparés jusqu'à atteindre {count}.",
  kdsGroupingTableBothRule: "Les deux activées",
  kdsGroupingTableBothExample: "Toutes les {minutes} minutes ou toutes les {count} commandes",
  kdsGroupingTableBothDetail: "La limite atteinte en premier ferme le groupe. Le minuteur et le compteur recommencent ensuite.",
  kdsGroupingTableBothResult: "Si {count} commandes arrivent avant {minutes} minutes, elles sont regroupées tout de suite et le minuteur repart. Si les {minutes} minutes passent en premier, les commandes déjà arrivées sont regroupées et le compteur repart.",
  kdsGroupingEnabled: "Activer le regroupement",
  kdsGroupingRule: "Règle de regroupement",
  kdsGroupingTimeRule: "Intervalle de temps",
  kdsGroupingCountRule: "Nombre de commandes",
  kdsGroupingInterval: "Intervalle (minutes)",
  kdsGroupingStartMinute: "Minute de départ de chaque heure",
  kdsGroupingStartMinuteHelp: "Par exemple, 10 ou 15. Un intervalle de 5 minutes qui commence à 10 ferme les groupes à :15, :20, :25, et ainsi de suite.",
  kdsGroupingOrderCount: "Commandes par groupe",
  kdsGroupingOrderCountHelp: "Les plats identiques sont combinés après ce nombre de commandes pour le même chef. Par exemple, toutes les 5 ou 10 commandes.",
  kdsGroupingSave: "Enregistrer le regroupement",
  kdsGroupingSaved: "Regroupement enregistré",
  kdsGroupingSaveFailed: "Échec de l'enregistrement du regroupement",
  kdsGroupOrders: "{count} commandes",
  kdsGroupHideOrders: "Masquer les commandes",
  kdsGroupReady: "{count} commandes sont prêtes",
  kdsGroupConfirmBody: "Voulez-vous vraiment marquer ces commandes comme prêtes ?",
  kdsGroupPageUp: "Articles précédents",
  kdsGroupPageDown: "Articles suivants",
  kdsPageFlipInterval: "Intervalle de changement de page (secondes)",
  kdsPageFlipIntervalHelp: "Quand une carte est plus haute que l'écran, la cuisine affiche les articles suivants après ce nombre de secondes. La valeur par défaut est 5.",
  kdsPageFlipSaved: "Intervalle de changement de page enregistré",
  kdsPageFlipSaveFailed: "Échec de l'enregistrement de l'intervalle",
  kdsDefaultDisplay: "Affichage par défaut",
  kdsDefaultDisplayHelp: "Le mode nuit est un écran noir avec du texte blanc. Les écrans de cuisine s'ouvrent dans le mode choisi ici.",
  kdsNightMode: "Mode nuit",
  kdsDayMode: "Mode jour",
  kdsDisplayModeSaved: "Mode d'affichage enregistré",
  kdsDisplayModeSaveFailed: "Échec de l'enregistrement du mode d'affichage",
  kdsUserSettingsHelp: "Chaque utilisateur KDS peut avoir jusqu'à 15 répartiteurs. Nommez un répartiteur pour un chef ou un poste, puis assignez les articles qu'il affiche.",
  kdsChefStation: "Chef / poste",
  kdsChefStationPlaceholder: "Grillade, sushi, expo",
  kdsAssignItems: "Assigner les articles",
  kdsSaveStation: "Enregistrer",
  kdsNoUsers: "Aucun utilisateur KDS. Ajoutez-en un dans l'onglet Utilisateurs.",
  kdsItemsSelectedCount: "{selected} sur {total} articles sélectionnés pour ce répartiteur.",
  kdsCoverageAssigned: "{assigned} sur {total} articles sont assignés à un répartiteur KDS.",
  kdsUnassignedWarning: "{unassigned} articles sur {total} ne sont assignés à aucun répartiteur et ne s'afficheront sur aucun écran KDS.",
  kdsSplitterSaved: "Répartiteur enregistré",
  kdsSplitterSaveFailed: "Échec de l'enregistrement du répartiteur",
  kdsAddSplitter: "Ajouter un répartiteur",
  kdsSplitterCount: "{count} répartiteurs sur 15",
  kdsSplitterLimit: "Cet utilisateur KDS a déjà 15 répartiteurs.",
  kdsRemoveSplitter: "Retirer",
  kdsRemoveSplitterTitle: "Retirer ce répartiteur ?",
  kdsRemoveSplitterBody: "Ce chef ou ce poste n'aura plus sa propre liste d'articles.",
  kdsViewAllItems: "Tous les articles",
  kdsUnassignedItems: "Articles non assignés",
  kdsChooseSplitter: "Choisir un répartiteur",
  kdsStationItemsReady: "Les articles de ce poste sont prêts",
  kitchenKioskFullscreen: "Plein écran",
  kitchenKioskExitFullscreen: "Quitter le plein écran",
  kitchenOrderStatus: "État des commandes",
  kitchenAutoOff: "Auto (Désactivé)",
  kitchenIntervalOff: "Désactivé",
  kitchenView6x2: "Vue 6×2",
  kitchenView6x1: "Vue 6×1",
  kitchenReady: "Prêt",
  kdsSignOutTitle: "Se déconnecter ?",
  kdsSignOutBody: "Quitter l'écran cuisine sur cet appareil.",
  kitchenOfflineBanner: "Le PDV est hors ligne - Les mises à jour des commandes ne sont pas reçues",
  kitchenConfirmCompletionTitle: "Confirmer la fin de la commande",
  kitchenConfirmCompletionBody: "Voulez-vous vraiment marquer cette commande comme terminée ?",
  kitchenItemsIncompleteWarning: "Avertissement : certains articles de cette commande ne sont pas encore marqués comme terminés.",
  kitchenPaymentFirstNote: "Remarque : veuillez d'abord vous assurer que le paiement est effectué.",
  orderHistoryRefunds: "Historique des commandes et remboursements",
  takeawayOrders: "Commandes à emporter",
  takeawayPickupPhoneOrders: "Commandes à Emporter/À Retirer/Commandes Téléphoniques",
  takeawayPickupOrders: "Commandes à emporter/À récupérer",
  pleaseSetupStationName: "Indiquez le nom de la station dans Paramètres, Détails du magasin, Enregistrement du poste.",
  stationName: "Nom de la station",
  enterStationName: "Comptoir 1",
  stationNameHelp: "Le nom de la station peut être modifié. Les noms précédents restent dans l'historique.",
  stationId: "ID de la station",
  generateStationId: "Générer l'ID de la station",
  stationIdRequired: "Générez un ID de station.",
  stationNameHistory: "Historique du nom de la station",
  stationIdReadOnly: "L'ID de la station ne peut pas être modifié.",
  stationIdPending: "Attribué lorsque ce poste est approuvé.",
  stationType: "Type de poste",
  stationTypeRequired: "Choisissez un type de poste.",
  stationTypePos: "Terminal de point de vente",
  stationTypeHandheld: "Appareil portatif",
  stationTypeCustomerTablet: "Tablette client",
  stationTypeTablet: "Tablette",
  stationTypeKiosk: "Kiosque",
  stationLetter: "Lettre du poste",
  stationLetterRequired: "Choisissez une lettre de poste.",
  stationLetterUsed: "Cette lettre de poste est déjà utilisée.",
  stationLetterChosen: "Poste {letter}. Les factures commencent à {numbers}.",
  stationStartTime: "Heure de démarrage de la station",
  stationStartTimeDescription: "L'heure à laquelle la station crée un rapport pour les totaux de la journée et installe toutes les mises à jour logicielles en attente.",
  workstationSetup: "Enregistrement du poste",
  workstationSetupDescription: "Enregistrez ce poste. Le même ordinateur reste reconnu après la réinstallation de Windows ou de l'application.",
  workstationSetupDesktopOnly: "Ouvrez l'application Windows Nuage POS pour enregistrer ou activer ce poste.",
  workstationSetupWebBlocked: "Cette opération NE PEUT PAS être effectuée dans le navigateur Web.",
  motherboardSerial: "Numéro de série de la carte mère",
  biosUuid: "UUID du BIOS",
  stationFingerprint: "Empreinte du poste",
  registrationStatus: "État de l'enregistrement",
  stationStatusUnregistered: "Non enregistré",
  stationStatusPending: "En attente d'approbation",
  stationStatusApproved: "Approuvé",
  stationStatusRegistered: "Enregistré",
  stationStatusRejected: "Refusé",
  stationStatusDeactivated: "Désactivé",
  stationStatusRemoved: "Retiré",
  stationNameRequired: "Entrez un nom de poste.",
  submitStationRegistration: "Soumettre une demande d'enregistrement",
  stationRequestSubmitted: "Demande d'enregistrement soumise",
  stationRequestSubmittedHelp: "Un super administrateur doit approuver ce poste avant qu'il puisse être utilisé.",
  stationPendingHelp: "Cette demande d'enregistrement est en attente d'approbation.",
  stationRequestSentAt: "Demande envoyée",
  stationTechnicalContact: "Personne-ressource technique",
  stationTechnicalContactHelp: "Facultatif. En cas de problème technique, Nuage POS contacte cette personne. Elle peut être différente de la personne qui soumet la demande.",
  stationContactName: "Nom",
  stationContactEmailInvalid: "Entrez une adresse courriel valide pour la personne-ressource technique.",
  stationConsentLabel: "J'accepte d'envoyer les renseignements de l'ordinateur de ce poste à Nuage POS pour approbation.",
  stationConsentRequired: "Acceptez d'envoyer les renseignements de l'ordinateur de ce poste avant de soumettre la demande.",
  stationDeactivatedHelp: "Ce poste est désactivé. Un super administrateur peut le réactiver.",
  stationApprovedHelp: "Ce poste est enregistré.",
  workstationConnection: "Connexion du poste",
  workstationConnectionOn: "Activée",
  workstationConnectionOff: "Désactivée",
  workstationConnectionOffLogin: "La connexion du poste est désactivée. Connectez-vous avec le compte administrateur du magasin.",
  workstationSetupBanner: "Ce poste doit être approuvé avant que l'application puisse être ouverte.",
  workstationSync: "Synchronisation des postes",
  syncThisWorkstationIsEagle: "Ce poste est Eagle",
  syncThisWorkstationIsEaglet: "Ce poste est un Eaglet.",
  syncEagletFollows: "Les choix de canaux viennent d'Eagle. Ce poste peut les voir et ne peut pas les modifier.",
  syncWorkstations: "Postes",
  syncNoEaglet: "Aucun Eaglet n'est connecté.",
  syncMakeEagle: "Faire de ce poste l'Eagle",
  syncEagleHelp: "Eagle héberge la synchronisation des postes de ce magasin. Un seul poste est Eagle. Les Eaglets suivent ces choix.",
  syncEditedOnEagle: "Les choix de canaux se modifient sur Eagle.",
  syncTable: "Service aux tables",
  syncCounter: "Comptoir",
  syncTakeaway: "À emporter",
  syncDelivery: "Livraison",
  syncLocalDelivery: "Livraison locale",
  syncOnline: "Commande en ligne",
  syncSelectByDefault: "Sélectionner par défaut",
  syncUberEats: "Uber Eats",
  syncDoorDash: "DoorDash",
  syncSkip: "SkipTheDishes",
  syncFantuan: "Fantuan",
  syncFamilyHelp: "Eagle Scout et Eagle Eye suivront ces choix dans une version ultérieure. Un canal désactivé reste sur le poste qui a pris la commande.",
  syncNetworkHelp: "Autorisez la synchronisation des postes sur le réseau privé du restaurant, port 48765.",
  syncSettingsSaveFailed: "La synchronisation des postes n'a pas été enregistrée.",
  syncStatusSynced: "Synchronisé",
  syncStatusRestaurantNetwork: "Sur le réseau du restaurant. Pas d'Internet.",
  syncStatusWaiting: "En attente de synchronisation",
  syncStatusEagleDown: "Eagle est injoignable",
  syncStatusManager: "Un responsable doit intervenir",
  workstationSubmitLink: "Cliquez ici pour soumettre",
  workstationPendingBanner: "Une demande d'enregistrement a été envoyée pour ce poste.",
  workstationLocation: "Emplacement du poste",
  workstationLocationPlaceholder: "Comptoir avant",
  workstationLocationHelp: "Où se trouve ce poste.",
  workstationLocationRequired: "Entrez l'emplacement du poste.",
  stationRejectedHelp: "Cette demande d'enregistrement a été refusée.",
  stationCustomerRemarks: "Remarques",
  workstationNotSetUp: "Ce poste doit être approuvé avant que cette section puisse être ouverte.",
  offlineReturnMaxDays: "Jours maximum pour un retour hors ligne",
  offlineReturnMaxDaysDescription: "Jusqu'à combien de jours cette station peut rechercher une vente pour un retour hors ligne. Les retours en ligne ne sont pas limités par cette valeur. Défaut : 2 jours, de 1 à 7.",
  posOrderId: "ID de commande POS",
  deliveryOrders: "Commandes de livraison",
  orderHistory: "Historique des commandes",
  orderHistoryCard: "Historique des commandes",
  reproductionSent: "Reproduction envoyée",
  reproductionSentToPrinter: "Le reçu a été envoyé à l'imprimante.",
  orderId: "ID de commande",
  paymentMethod: "Méthode de paiement",
  posUserId: "Utilisateur POS",
  posUserStations: "Postes",
  posUserStationsHelp: "Cet utilisateur peut ouvrir une session sur tous les postes de ce magasin.",
  posUserStationRequired: "Sélectionnez au moins un poste.",
  posUserStationsLimited: "Cet utilisateur peut ouvrir une session seulement sur les postes sélectionnés.",
  posUserStationNotAllowed: "Cet utilisateur n'est pas assigné à ce poste. Veuillez ouvrir une session sur un poste assigné.",
  orderChannel: "Canal",
  onlineOrderManagement: "Gestion des commandes en ligne",
  onlineUnconfirmed: "Non confirmée",
  onlineConfirmed: "Confirmée",
  confirmedDueSoon: "Confirmée (Bientôt due)",
  confirmedUpcoming: "Confirmée (À venir)",
  onlineReady: "Prête",
  onlineOnRoute: "En route",
  onlineCanceled: "Annulée",
  onlineStatusUpdated: "Statut mis à jour",
  onlineErrorUpdatingStatus: "Erreur lors de la mise à jour du statut",
  onlineOrderDetails: "Détails de la commande",
  onlineNothingHere: "Rien ici...",
  onlineGuest: "Client",
  onlineServiceType: "Service",
  onlineCustomer: "Client",
  onlineNotes: "Notes",
  onlineSubtotal: "Sous-total",
  onlineTaxes: "Taxes",
  onlineCancelOrder: "Annuler la commande",
  onlineManageOrder: "Gérer la commande",
  stripeRefundPayment: "Rembourser le paiement Stripe",
  stripeRefundReceived: "Remboursement Stripe reçu",
  stripeRefundPending: "Remboursement Stripe en attente",
  stripeRefundFailed: "Échec du remboursement Stripe",
  stripeRefundConfirm: "Cette action rembourse {amount} sur le paiement Stripe de cette commande.",
  stripeRefundNone: "Enregistrez un remboursement sur cette commande avant de rembourser le paiement Stripe.",
  stripeRefundAlready: "Ce remboursement Stripe est déjà enregistré.",
  stripeRefundAmount: "Montant du remboursement",
  stripeRefundNumber: "Numéro de remboursement",
  stripeRefundHistoryItem: "Remboursement Stripe",
  stripeRefundList: "Remboursements Stripe",
  stripeRefundSucceeded: "Réussi",
  stripeRefundPendingStatus: "En attente",
  stripeRefundFailedStatus: "Échoué",
  stripeRefundCanceled: "Annulé",
  orderDetailMissingReceipt: "Le reçu original de cette commande n'a pas été enregistré.",
  onlineKeepOrder: "Conserver la commande",
  onlineCancelOrderTitle: "Annuler la commande",
  confirmCancelOnlineOrder: "Cette action annule la commande et produit un reçu de fermeture annulé.",
  confirmCancelSentBill: "Cette action annule la commande et produit un reçu de fermeture annulé.",
  reprintReceipt: "Réimprimer le reçu",
  resendReceiptEmail: "Renvoyer le courriel",
  confirmReprintReceipt: "Le reçu est imprimé de nouveau. Revenu Québec reçoit un enregistrement de cette réimpression.",
  confirmResendReceiptEmail: "Le reçu électronique est renvoyé à {email}. Revenu Québec reçoit aussi un enregistrement de ce reçu.",
  lastReprintAt: "Dernière réimpression {time}",
  receiptLogReprint: "Reçu réimprimé {time}",
  receiptLogResend: "Reçu électronique renvoyé {time}",
  receiptReprinted: "Reçu réimprimé",
  receiptEmailResent: "Reçu électronique renvoyé",
  receiptEmailNotOnStation: "Le reçu électronique n'est pas sur ce poste",
  customerEmailMissing: "Le courriel du client est absent",
  sortBy: "Trier par",
  sortByDate: "Date",
  sortByTable: "Table",
  sortByOrderId: "ID de commande",
  sortByTotal: "Total",
  orderDetails: "Détails de la commande",
  customerInfo: "Informations client",
  noPaymentMethod: "N/A",
  posSettings: "Paramètres POS",
  items: "articles",
  startOrdering: "Commencer la commande?",
  startOrderingForTable: "Voulez-vous commencer à commander pour la table",
  startOrderingButton: "Commencer la commande",
  // Takeaway translations
  activeSession: "session active",
  newTakeaway: "Nouvelle Commande à Emporter",
  clickToCreateTakeaway: "Cliquez pour créer une nouvelle commande à emporter",
  takeawayCreated: "Commande à emporter créée",
  phoneOrder: "Commande Téléphonique",
  newTakeawayForPhoneOrder: "Nouvelle Commande à Emporter pour Commande Téléphonique",
  clickToCreatePhoneOrder: "Cliquez pour créer une nouvelle commande téléphonique",
  phoneOrderCreated: "Commande téléphonique créée",
  phoneOrderHasBeenCreated: "{name} a été créée",
  errorCreatingPhoneOrder: "Erreur lors de la création de la commande téléphonique",
  phoneOrderCustomerInfoRequired: "Le nom du client et le numéro de téléphone sont requis pour les commandes téléphoniques",
  missingPhoneOrderFields: "Manquant: {fields}",
  customerNameRequired: "Le nom du client est requis",
  takeawayHasBeenCreated: "{name} a été créée",
  errorCreatingTakeaway: "Erreur lors de la création de la commande à emporter",
  offlineMode: "Mode Hors Ligne",
  disableNetwork: "Désactiver le réseau",
  enableNetwork: "Activer le réseau",
  takeawayWillBeCreatedOnline: "La nouvelle commande à emporter sera créée en ligne",
  cannotDeleteTW001: "Impossible de supprimer TW001",
  tw001CannotBeDeleted: "TW001 est la commande à emporter par défaut et ne peut pas être supprimée",
  sessionWillBeDeletedOnline: "La session sera supprimée en ligne",
  sessionDeleted: "Session supprimée",
  takeawayHasBeenDeleted: "{name} a été supprimée",
  errorDeletingSession: "Erreur lors de la suppression de la session",
  deleteTakeawaySession: "Supprimer la Session à Emporter",
  areYouSureDeleteTakeaway: "Êtes-vous sûr de vouloir supprimer {name}?",
  // Delivery translations
  newDelivery: "Nouvelle Livraison",
  clickToCreateDelivery: "Cliquez pour créer une nouvelle commande de livraison",
  deliveryCreated: "Livraison créée",
  deliveryHasBeenCreated: "{name} a été créée",
  errorCreatingDelivery: "Erreur lors de la création de la livraison",
  deliveryHasBeenDeleted: "{name} a été supprimée",
  deleteDeliverySession: "Supprimer la Session de Livraison",
  areYouSureDeleteDelivery: "Êtes-vous sûr de vouloir supprimer {name}?",
  // Unprinted items warning
  unprintedItemsWarning: "Articles Non Envoyés à la Cuisine",
  unprintedItemsWarningMessage: "Il y a des articles dans le panier qui n'ont pas encore été imprimés à la cuisine.",
  unprintedItemsWarningQuestion: "Voulez-vous procéder au paiement sans imprimer ces articles?",
  payWholeTableTitle: "Régler toute la table",
  payWholeTableMessage: "Ceci règle toute la table sur une seule facture.",
  proceedAnyway: "Continuer Quand Même",
  // Delivery address translations
  deliveryInformation: "Informations de Livraison",
  deliveryInformationRequired: "Informations de Livraison Requises",
  pleaseEnterPhoneAndAddress: "Veuillez entrer le numéro de téléphone et l'adresse de livraison",
  pleaseSelectCustomerWithPhone: "Veuillez sélectionner un client avec un numéro de téléphone",
  pleaseSelectCustomerWithAddress: "Veuillez sélectionner un client avec une adresse de livraison complète",
  customerRequired: "Client Requis",
  pleaseAssignCustomer: "Veuillez assigner un client avant le paiement",
  pleaseSelectCustomer: "Veuillez sélectionner un client",
  missingDeliveryFields: "Manquant: {fields}",
  deliveryOrder: "Commande de Livraison",
  phoneNumber: "Numéro de Téléphone",
  enterPhoneNumber: "Entrer le numéro de téléphone",
  phoneRequired: "Le numéro de téléphone est requis",
  streetAddress: "Adresse",
  enterStreetAddress: "Entrer l'adresse",
  streetAddressRequired: "L'adresse est requise",
  apartmentUnit: "Appartement/Unité",
  enterApartmentUnit: "Entrer l'appartement/unité",
  city: "Ville",
  enterCity: "Entrer la ville",
  cityRequired: "La ville est requise",
  enterPostalCode: "Entrer le code postal",
  postalCodeRequired: "Le code postal est requis",
  deliveryInstructions: "Instructions de Livraison",
  enterDeliveryInstructions: "Entrer les instructions de livraison (ex: sonner deux fois)",
  actionCannotBeUndone: "Cette action ne peut pas être annulée.",
  addGuestNumberAndCustomer: "Ajouter le Nombre d'Invités et le Client",
  selectExistingCustomer: "Sélectionner un client existant...",
  or: "OU",
  enterNewCustomerName: "Entrer un nouveau nom de client...",
  numberOfGuests: "Nombre d'Invités",
  errorSaving: "Erreur lors de l'enregistrement",
  new: "Nouveau",
  changesWillBeSavedOnline: "Les modifications seront enregistrées en ligne",
  sessionUpdated: "Session mise à jour",
  errorUpdatingSession: "Erreur lors de la mise à jour de la session",
  deleteCart: "Supprimer le Panier",
  deleteCartConfirm: "Êtes-vous sûr de vouloir vider le panier ? Cette action ne peut pas être annulée.",
  deleteCartWorking: "Suppression du panier.",
  deleteCartDeleted: "{count} articles ont été supprimés.",
  deleteCartDeletedOne: "1 article a été supprimé.",
  orderCanceledDetail: "La commande {order} a été annulée.",
  cancellationReceiptPrinted: "Reçu d'annulation imprimé pour {transaction}.",
  deleteCartLogHint: "Vous pouvez consulter les détails de la suppression dans les journaux système.",
  noteRemark: "Note/Remarque",
  remarkSaved: "Remarque enregistrée",
  errorSavingRemark: "Erreur lors de l'enregistrement de la remarque",
  tableActions: "Actions sur la Table",
  liveTables: "Tables en service",
  switchTable: "Changer de table",
  cart: "Panier",
  cartEmpty: "Le panier est vide",
  cartAddItemsHint: "Ajoutez des articles pour commencer",
  subtotal: "Sous-total",
  allProducts: "TOUS LES PRODUITS",
  assignToTable: "Assigner à la table",
  enterNoteOrRemark: "Entrer une note ou une remarque...",
  additionalNotes: "Notes Supplémentaires",
  allergies: "Allergies",
  selectAllergies: "Sélectionner les Allergies",
  commonAllergies: "Allergies Courantes",
  peanut: "Arachide",
  shellfish: "Fruits de Mer",
  dairy: "Produits Laitiers",
  gluten: "Gluten",
  eggs: "Œufs",
  soy: "Soja",
  treeNuts: "Noix",
  fish: "Poisson",
  sesame: "Sésame",
  printTemporaryBill: "Imprimer FO",
  printTemporaryBillShort: "FO",
  printCartItems: "Cuisine",
  printed: "Imprimé",
  allItemsPrinted: "Tous les articles ont été imprimés",
  itemsPrinted: "Articles imprimés avec succès",
  itemHold: "Mettre en attente",
  itemReleaseHold: "Libérer l'attente",
  itemOnHold: "EN ATTENTE",
  applyDiscount: "Appliquer une réduction",
  itemDiscount: "Réduction sur l'article",
  freeEntry: "Entrée gratuite",
  unprintedItemsDetected: "Articles non imprimés détectés",
  unprintedItemsMessage: "Il y a des articles qui n'ont pas été imprimés. Voulez-vous continuer?",
  proceed: "Continuer",
  removeDiscount: "Retirer la réduction",
  addItemNote: "Ajouter une note",
  itemNote: "Note sur l'article",
  enterItemNote: "Entrez une note pour cet article...",
  removeNote: "Retirer la note",
  printError: "Erreur lors de l'impression des articles",
  payNow: "Payer",
  returnToEditing: "Retourner à l'édition ?",
  alreadyCheckedOut: "Vous avez déjà commencé le processus de paiement.",
  returnToEditingConfirm: "Souhaitez-vous revenir en arrière et continuer à ajouter des articles à cette commande ?",
  stayOnCheckout: "Rester au paiement",
  continueAdding: "Oui, continuer l'ajout",
  cartCleared: "Panier vidé",
  transferTable: "Transférer la Table",
  pos: "POS",
  convertTakeawayToTable: "Convertir Commande à Emporter en Table",
  invalidOperation: "Opération invalide",
  onlyTakeawayCanConvert: "Seules les commandes à emporter peuvent être converties en commandes de table",
  pleaseSelectTable: "Veuillez sélectionner une table",
  conversionSuccess: "Conversion réussie",
  converted: "Converti",
  to: "vers",
  errorConvertingSession: "Erreur lors de la conversion de la session",
  occupied: "Occupé",
  convert: "Convertir",
  takeawayOrder: "Commande à Emporter",
  mergeTables: "Fusionner les Tables",
  selectDestinationTable: "Sélectionner la Table de Destination",
  selectTablesToMerge: "Sélectionner les Tables à Fusionner",
  currentTable: "Table Actuelle",
  orders: "Commandes",
  transferSuccess: "Table {from} transférée à {to}",
  mergeSuccess: "Tables fusionnées : {tables}",
  noTablesSelected: "Veuillez sélectionner au moins une table",
  tableEmpty: "La table {name} est maintenant vide",
  errorTransferringTable: "Erreur lors du transfert de la table",
  errorMergingTables: "Erreur lors de la fusion des tables",
  noAvailableTables: "Aucune table disponible",
  noTableLargeEnough: "Aucune table libre n'a {covers} places ou plus.",
  destinationTooSmall: "Cette table a {seats} places. {covers} convives sont assis.",
  tableSeats: "{seats} places",
  sortSmallestFirst: "Plus petit numéro d'abord",
  sortLargestFirst: "Plus grand numéro d'abord",
  noOtherOccupiedTables: "Aucune autre table occupée disponible",
  noFloorTablesToMerge: "Aucune autre table n'a de commande ouverte.",
  mergeReviewTitle: "Vérifier la fusion",
  mergeReviewHint: "Ces articles rejoignent Tout sur cette table. Les autres tables se ferment.",
  reviewMerge: "Vérifier",
  mergeIntoThisTable: "Les autres tables seront fusionnées dans cette table",
  mergedTotal: "Total Fusionné",
  selectedTables: "Sélectionné",
  transfer: "Transférer",
  merge: "Fusionner",
  // Split Payment Translations
  chooseItemToCheckout: "Choisir les articles à payer",
  singleSeatCheckout: "Siège unique (siège 1 uniquement)",
  splitByItem: "Diviser par siège",
  splitByItemDescription: "Sélectionnez manuellement les articles à l'aide de cases à cocher pour créer des divisions de paiement personnalisées. (Bientôt disponible)",
  splitInEqualParts: "Diviser en Parts Égales",
  fullCart: "Panier Complet",
  splitEqualPartsDescription: "Divisez la facture totale en plusieurs parts égales.",
  numberOfParts: "Nombre de parts :",
  createEqualSplits: "Créer des Parts Égales",
  seatSpecificCheckout: "Paiement par siège : Tous les articles seront payés ensemble. Aucune option de division disponible.",
  paymentSplits: "Divisions de Paiement",
  pay: "Payer",
  paid: "Payé",
  allPaid: "Tout payé",
  tableClosed: "La table est fermée",
  item: "Article",
  qty: "Qté",
  removeItemOutOfTable: "Retirer l'article de la commande de table/cuisine",
  invalidNumber: "Nombre invalide",
  numberOfPartsRange: "Le nombre de parts doit être entre 2 et 99",
  noItemsSelected: "Aucun article sélectionné",
  paymentSavedLocally: "{channel}. Paiement enregistré sur ce poste. Le reçu s'imprime maintenant.",
  orderCompletedSuccessfully: "Commande terminée avec succès",
  sendingToRevenuQuebec: "Envoi des données à Revenu Québec",
  closingBillSentToRevenuQuebec: "{channel}. La facture de clôture est envoyée à Revenu Québec et s'imprimera lorsque Revenu Québec répondra.",
  temporaryBillSentToRevenuQuebec: "{channel}. Ceci est une facture temporaire. Le reçu s'imprimera lorsque Revenu Québec répondra.",
  temporaryBillOffline: "{channel}. Facture temporaire enregistrée sur ce poste. Le reçu s'imprime maintenant.",
  offlineReceiptPrinting: "Le reçu s'imprime sur ce poste et indique un problème de communication. La facture sera envoyée au retour du réseau.",
  syncUnsentBills: "Transmettre les factures non envoyées",
  syncingUnsentBills: "Transmission...",
  noUnsentBills: "Aucune facture non envoyée",
  revenueQuebecReceivedLot: "Revenu Québec a reçu les factures non envoyées",
  revenueQuebecLotDetails: "{count} facture(s) envoyée(s) seules. Lot {noLot}. Reçu {psiDatLot}.",
  revenueQuebecReceivedWithBill: "Revenu Québec a reçu cette facture et les factures non envoyées",
  revenueQuebecWithBillDetails: "Facture {psiNoTrans}. {count} facture(s) en file envoyée(s) avec elle. Lot {noLot}.",
  revenueQuebecLotRejected: "Revenu Québec n'a pas accepté les factures non envoyées",
  unsentBillsStillQueued: "Les factures hors ligne restent sur ce poste tant que Revenu Québec ne les confirme pas.",
  offlineBillsSentSuccessfully: "Factures hors ligne envoyées avec succès",
  offlineBillsReceivedDetails: "Revenu Québec a reçu {count} facture(s) hors ligne. Lot {noLot}. Reçu {psiDatLot}.",
  offlineBillsReceivedWithBill: "Revenu Québec a reçu {count} facture(s) hors ligne avec cette facture {psiNoTrans}. Lot {noLot}.",
  offlineBillsNotConfirmed: "Revenu Québec n'a pas confirmé les factures hors ligne",
  orderWillSyncWhenOnline: "La commande sera synchronisée avec le serveur lorsque la connexion sera rétablie",
  orderSavedOffline: "Commande enregistrée hors ligne",
  fiscalReceiptQueued: "Reçu fiscal en file d'attente",
  revisedBillQueued: "Facture révisée en file d'attente",
  fiscalReceiptQueuedDescription: "Le reçu s'imprime lorsque Revenu Québec répond.",
  errorCompletingOrder: "Erreur lors de la finalisation de la commande",
  itemsReadyForPayment: "Articles prêts pour le paiement",
  clickGreenButtonToPay: "Cliquez à nouveau sur le bouton vert pour procéder au paiement",
  // Split Modal Translations
  splitModal: "Diviser",
  splitEqual: "Diviser Également",
  availableItems: "Articles Disponibles",
  seats: "Sièges",
  noSeatsCreated: "Aucun siège créé",
  clickAddSeatToCreate: "Cliquez sur l'icône + ci-dessus pour créer un siège",
  apply: "Appliquer",
  revert: "Annuler",
  finish: "Terminer",
  splitApplied: "Division appliquée",
  splitSaved: "Division enregistrée",
  quantity: "Quantité",
  discardChanges: "Annuler les modifications?",
  unsavedChangesWarning: "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir annuler? Toutes les modifications seront perdues.",
  stay: "Rester",
  discard: "Annuler les modifications",
  addSeats: "Ajouter des Sièges",
  howManySeats: "Combien de sièges souhaitez-vous ajouter?",
  enterSeatNames: "Entrer les Noms des Sièges (Optionnel)",
  enterSeatNamesOptional: "Entrez les noms des clients pour chaque siège (optionnel)",
  customerNameOptional: "Nom du client (optionnel)...",
  seat: "Siège",
  seatsAdded: "Sièges ajoutés",
  revertSplit: "Supprimer Toutes les Assignations",
  revertSplitWarning: "Cela supprimera toutes les assignations de division. Tous les articles seront non assignés. Continuer?",
  resumeSplit: "Restaurer l'État de Division Original",
  resumeSplitWarning: "Cela restaurera les assignations de division originales. Les modifications actuelles seront perdues. Continuer?",
  modeSwitchWarning: "Supprimer Tous les Sièges D'abord",
  modeSwitchWarningMessage: "Vous devez supprimer tous les sièges avant de changer de méthode. Utilisez le bouton Revert ou supprimez manuellement les sièges d'abord.",
  modeSwitchBlocked: "Supprimez tous les sièges d'abord pour changer de méthode",
  confirm: "Confirmer",
  // Customer translations
  customers: "Clients",
  customersSynced: "Synchronisé",
  customersNotSynced: "non synchronisés",
  customer: "Client",
  firstName: "Prénom",
  lastName: "Nom de famille",
  firstNameIsRequired: "Le prénom est requis",
  lastNameIsRequired: "Le nom de famille est requis",
  phoneIsRequired: "Le numéro de téléphone est requis",
  address2: "Adresse 2",
  postCode: "Code postal",
  state: "Province",
  country: "Pays",
  customerSegment: "Segment de client",
  selectSegment: "Sélectionner un segment",
  regularCustomer: "Client régulier",
  vipCustomer: "Client VIP",
  newCustomer: "Nouveau client",
  frequentCustomer: "Client fréquent",
  corporateCustomer: "Client corporatif",
  unitNumber: "Unité #",
  latitude: "Latitude",
  longitude: "Longitude",
  wizardStepName: "Nom",
  wizardStepPhone: "Téléphone",
  wizardStepAddress: "Adresse",
  wizardStepEmail: "Courriel",
  wizardStepSegment: "Segment",
  customerNumber: "No client",
  customerDetail: "Détail du client",
  customerAlreadyCreated: "Ce client a déjà été créé",
  customerAlreadyCreatedHint: "{name} existe déjà. Enregistrer ce client sous {proposed}?",
  useThisName: "Utiliser ce nom",
  next: "Suivant",
  previous: "Précédent",
  quickAreaCodes: "Indicatifs rapides",
  editQuickAreaCodes: "Modifier les indicatifs rapides",
  addAreaCode: "Ajouter",
  areaCodeHint: "Enregistrez les indicatifs utilisés par ce restaurant",
  quickPostalCodes: "Codes postaux rapides",
  editQuickPostalCodes: "Modifier les codes postaux rapides",
  postalPrefixHint: "Enregistrez les 3 premiers caractères, par exemple H3Z",
  houseNumber: "Numéro de rue",
  streetName: "Nom de rue",
  searchAddress: "Chercher",
  buzzCode: "Code d'interphone",
  manualEnter: "Entrer manuellement",
  streetChoices: "Choix de rue",
  searchStreet: "Chercher une rue",
  skipAddress: "Ignorer l'adresse",
  phoneIncomplete: "Entrez un numéro de téléphone à 10 chiffres",
  invalidAreaCode: "Entrez un indicatif à 3 chiffres",
  invalidPostalPrefix: "Entrez 3 caractères comme H3Z",
  noStreetMatches: "Aucune rue trouvée. Cherchez ci-dessous.",
  clear: "Effacer",
  createCustomer: "Créer un client",
  addCustomer: "Ajouter un client",
  editCustomer: "Modifier le client",
  manageCustomers: "Gérer la base de données des clients",
  searchCustomers: "Rechercher des clients...",
  searching: "Recherche en cours...",
  allSegments: "Tous les segments",
  noCustomersFound: "Aucun client trouvé",
  errorLoadingCustomers: "Échec du chargement des clients",
  customerDeleted: "Client supprimé avec succès",
  errorDeletingCustomer: "Échec de la suppression du client",
  confirmDeleteCustomer: "Êtes-vous sûr de vouloir supprimer ce client?",
  // Menu Management
  menus: "Menus",
  uberEatsMenu: "Uber Eats",
  uberEatsMenuEmpty: "Aucun menu Uber Eats n'a été reçu.",
  uberEatsMenuPrinterOnly: "Ce menu sert à assigner les articles Uber Eats aux imprimantes.",
  uberEatsMenuUpdated: "Ce menu a été mis à jour à",
  uberEatsActivity: "Activité",
  uberEatsEditConnection: "Modifier la connexion",
  uberEatsCancelEdit: "Annuler",
  uberEatsStoreIdHidden: "L'identifiant du magasin est masqué. Choisissez Modifier la connexion pour le changer.",
  uberEatsWebhookSecret: "Secret du webhook",
  uberEatsWebhookSecretHelp: "Collez un secret de webhook pour ce magasin.",
  uberEatsSecretSaved: "Secret du webhook enregistré",
  uberEatsReplaceSecret: "Remplacer le secret du webhook? Eat Printer doit utiliser le nouveau secret avant la prochaine commande.",
  uberEatsContinue: "Continuer",
  uberEatsSaveSecret: "Enregistrer le secret",
  uberEatsRemoveSecret: "Retirer le secret",
  uberEatsRemovePrompt: "Tapez REMOVE pour supprimer le secret enregistré.",
  uberEatsSecretInvalid: "Entrez le secret de 64 caractères.",
  uberEatsSecretKept: "Secret du webhook enregistré",
  uberEatsSecretRemoved: "Secret du webhook retiré",
  menu: "Menu",
  createMenu: "Créer un menu",
  editMenu: "Modifier le menu",
  deleteMenu: "Supprimer le menu",
  confirmDeleteMenu: "Êtes-vous sûr de vouloir supprimer ce menu? Cette action ne peut pas être annulée.",
  menuDeleted: "Menu supprimé",
  menuDeletedSuccessfully: "Menu, catégories et articles ont été supprimés avec succès.",
  errorDeletingMenu: "Erreur lors de la suppression du menu",
  menuCopied: "Menu copié",
  copyingMenu: "Copie du menu...",
  menuCopiedSuccessfully: "Menu, catégories et articles ont été copiés avec succès.",
  errorCopyingMenu: "Erreur lors de la copie du menu",
  menuCreated: "Menu créé",
  menuUpdated: "Menu mis à jour",
  errorSavingMenu: "Erreur lors de l'enregistrement du menu",
  createCategory: "Créer une catégorie",
  editCategory: "Modifier la catégorie",
  confirmDeleteCategory: "Êtes-vous sûr de vouloir supprimer cette catégorie? Cette action ne peut pas être annulée.",
  categoryDeletedSuccessfully: "Catégorie et articles ont été supprimés avec succès.",
  categoryCopied: "Catégorie copiée",
  errorCopyingCategory: "Erreur lors de la copie de la catégorie",
  categoryCreated: "Catégorie créée",
  categoryUpdated: "Catégorie mise à jour",
  errorSavingCategory: "Erreur lors de l'enregistrement de la catégorie",
  createItem: "Créer un article",
  editItem: "Modifier l'article",
  itemCreated: "Article créé",
  itemUpdated: "Article mis à jour",
  errorSavingItem: "Erreur lors de l'enregistrement de l'article",
  itemCopied: "Article copié",
  errorCopyingItem: "Erreur lors de la copie de l'article",
  createNewItem: "Créer un nouvel article",
  createNewCategory: "Créer une nouvelle catégorie",
  createNewMenu: "Créer un nouveau menu",
  rearrange: "Réorganiser",
  sequencing: "Séquençage",
  sequencingHelper: "Glissez-déposez pour réorganiser les menus, catégories et articles. Les articles peuvent être déplacés entre les catégories du même menu.",
  editPrices: "Modifier les prix",
  selected: "Sélectionné",
  itemsPaused: "Articles en pause",
  paused: "En pause",
  pauseItem: "Mettre l'article en pause",
  resumeItem: "Reprendre l'article",
  itemPaused: "Article mis en pause",
  itemResumed: "Article repris",
  errorPausingItem: "Erreur lors de la mise en pause de l'article",
  errorResumingItem: "Erreur lors de la reprise de l'article",
  favorite: "Favori",
  itemActions: "Actions de l'article",
  eightySixItem: "86 article",
  eightySixUnavailable: "Indisponible",
  eightySixOneHour: "1 heure",
  eightySixTwoHours: "2 heures",
  eightySixThreeHours: "3 heures",
  eightySixFourHours: "4 heures",
  eightySixRestOfDay: "Reste de la journée",
  eightySixThreeDays: "3 jours",
  eightySixOneWeek: "1 semaine",
  eightySixUntilResumed: "Jusqu'à reprise",
  eightySixUntil: "Jusqu'à",
  itemEightySixed: "Article 86",
  errorEightySixItem: "Impossible de rendre l'article indisponible",
  noMenus: "Aucun menu trouvé",
  noCategoriesInMenu: "Aucune catégorie dans ce menu",
  noCategoriesAvailable: "Aucune catégorie disponible",
  noItemsInCategory: "Aucun article dans cette catégorie",
  createFirstMenu: "Créer le premier menu",
  general: "Général",
  conditions: "Conditions",
  uniqueNameForMenu: "Un nom unique pour votre menu",
  displayName: "Nom d'affichage",
  displayNamePlaceholder: "Remplacera le nom unique dans votre magasin",
  displayNameHelper: "Remplacera le nom unique dans votre magasin",
  screenPin: "Code PIN d'écran",
  screenPinPlaceholder: "Code PIN de 4 à 6 chiffres",
  screenPinHelper: "Ce NIP de 6 chiffres est votre NIP PDV. Vous pouvez le changer ici.",
  idleLockTitle: "CONNEXION",
  idleLockInstruction: "Entrez les informations de connexion pour vous connecter.",
  idleLockPinLabel: "Entrez votre code PIN *",
  idleLockEnterPinOf: "Entrez le code PIN de",
  idleLockWrongPin: "Code PIN incorrect",
  idleLockClear: "effacer",
  idleLockOk: "OK",
  idleLockNoPinSet: "Code PIN d'écran non défini. Veuillez définir un code PIN dans votre profil.",
  idleLockEnterPINToUnlock: "Entrez le code PIN pour déverrouiller",
  idleLockLastUser: "Dernier utilisateur",
  idleLockEnter6Digits: "Veuillez entrer 6 chiffres",
  idleLockError: "Erreur de connexion. Veuillez réessayer.",
  idleTimeoutMinutes: "Temps d'inactivité de l'écran (minutes)",
  idleTimeoutDescription: "Temps avant que l'écran ne se verrouille en raison de l'inactivité",
  locationControlTitle: "Contrôle de localisation",
  locationControlDescription: "L'application peut être utilisée uniquement dans ce rayon de l'emplacement enregistré.",
  locationControlEnabled: "Contrôle de localisation",
  locationRadiusMeters: "Rayon autorisé (mètres)",
  locationRadiusRequired: "Saisissez le rayon autorisé en mètres.",
  locationRecord: "Enregistrer cet emplacement",
  locationRecorded: "Emplacement enregistré",
  locationRecordRequired: "Enregistrez cet emplacement avant d'activer le contrôle de localisation.",
  locationCoordinates: "Emplacement enregistré",
  locationNotRecorded: "Aucun emplacement n'est enregistré.",
  locationOutsideArea: "Ce poste est à l'extérieur de la zone autorisée.",
  locationMeasuredDistance: "Distance mesurée",
  locationUnavailable: "La localisation est indisponible. Ce poste ne peut pas être vérifié.",
  locationCheckAgain: "Vérifier la localisation",
  startWithWindows: "Démarrer au lancement de Windows",
  showWindowShortcut: "Afficher la fenêtre",
  checkApplicationUpdate: "Vérifier les mises à jour de l'application",
  applicationUpdateAvailable: "Une mise à jour de l'application est disponible.",
  applicationUpdateCurrent: "Cette application est à jour.",
  applicationUpdateUnconfigured: "Les mises à jour de l'application ne sont pas configurées.",
  applicationUpdateFailed: "La vérification des mises à jour a échoué.",
  profileUpdated: "Profil mis à jour",
  profileUpdatedSuccess: "Votre profil a été mis à jour avec succès",
  failedToUpdateProfile: "Échec de la mise à jour du profil",
  menuDescriptionPlaceholder: "Sera affiché au-dessus de votre menu. Vous pouvez l'utiliser pour résumer les exigences de votre menu. Par exemple: 'Disponible lundi-jeudi après 21h, uniquement à emporter'",
  menuDescriptionHelper: "Sera affiché au-dessus de votre menu. Vous pouvez l'utiliser pour résumer les exigences de votre menu. Par exemple: 'Disponible lundi-jeudi après 21h, uniquement à emporter'",
  hideUnavailableMenu: "Masquer le menu indisponible",
  hideUnavailableMenuHelper: "Activer cela masquera ce menu dans votre magasin s'il est indisponible. Sinon, ce menu sera toujours affiché avec un message d'avertissement indiquant qu'il n'est pas disponible.",
  services: "Services",
  // POS User Management
  posUsers: "Utilisateurs POS",
  posUser: "Utilisateur POS",
  createPOSUser: "Créer un utilisateur POS",
  editPOSUser: "Modifier l'utilisateur POS",
  deletePOSUser: "Supprimer l'utilisateur POS",
  posUserCreated: "Utilisateur POS créé avec succès",
  posUserUpdated: "Utilisateur POS mis à jour avec succès",
  posUserDeleted: "Utilisateur POS supprimé avec succès",
  confirmDeletePOSUser: "Êtes-vous sûr de vouloir supprimer",
  errorLoadingPOSUsers: "Erreur lors du chargement des utilisateurs POS",
  errorSavingPOSUser: "Erreur lors de l'enregistrement de l'utilisateur POS",
  errorDeletingPOSUser: "Erreur lors de la suppression de l'utilisateur POS",
  noPOSUsers: "Aucun utilisateur POS trouvé. Créez votre premier utilisateur POS pour commencer.",
  pinRequired: "Le code PIN est requis",
  pinMustBe6Digits: "Le code PIN doit contenir exactement 6 chiffres",
  atLeastOneRoleRequired: "Au moins un rôle est requis",
  enter6DigitPIN: "Entrez un code PIN à 6 chiffres",
  leaveBlankToKeepCurrent: "laisser vide pour garder l'actuel",
  cashier: "Caissier",
  server: "Serveur",
  manager: "Gestionnaire",
  lastLogin: "Dernière connexion",
  never: "Jamais",
  unauthorized: "Vous n'êtes pas autorisé à accéder à cette page.",
  currentPOSUser: "Utilisateur POS",
  logoutPOSUser: "Déconnexion utilisateur POS",
  posUserLoggedOut: "Utilisateur POS déconnecté",
  refreshMenu: "Actualiser le menu",
  refreshMenuDone: "Le menu est actualisé.",
  hardRefreshTitle: "Actualisation forcée",
  hardRefreshBody: "Cette actualisation forcée peut effacer les cartes de vente d'aujourd'hui et les transactions d'aujourd'hui. Quittez Nuage POS depuis la zone de notification, en bas à droite de l'écran, puis ouvrez l'application de nouveau.",
  hardRefreshTray: "Redémarrer depuis la zone de notification",
  hardRefreshConfirm: "Actualisation forcée",
  logoutPOSUserConfirmTitle: "Déconnecter l'utilisateur POS ?",
  logoutPOSUserConfirmBody: "Si vous vous déconnectez, l'autre utilisateur POS ne pourra pas poursuivre ce travail. Voulez-vous vraiment déconnecter l'utilisateur POS ? Les autres utilisateurs POS ont besoin qu'un administrateur se connecte avant de pouvoir se connecter comme utilisateur POS.",
  mevVerified: "Vérifié MEV",
  createdOn: "Créé le",
  posUserDeletedOn: "Supprimé le",
  posUserNotMevVerified: "Cet utilisateur n'est pas vérifié MEV.",
  mevUserRestriction: "Le nom correspond à l'utilisateur du certificat. Vous pouvez modifier le NIP, le rôle, l'état actif et les postes.",
  // POS User Permissions
  role: "Rôle",
  roleRequired: "Le rôle est requis",
  managePermissions: "Gérer les Permissions",
  roles: "Rôles",
  assignRole: "Attribuer un rôle",
  newRole: "Nouveau rôle",
  roleName: "Nom du rôle",
  roleSaved: "Rôle enregistré",
  roleSaveFailed: "Le rôle n'a pas pu être enregistré",
  roleChangeReport: "Rapport de changement de rôle",
  roleConfirmSave: "Confirmer et enregistrer",
  roleConfirmCreate: "Confirmer et créer",
  roleConfirmDelete: "Confirmer et supprimer",
  roleConfirmReset: "Confirmer et réinitialiser",
  roleLeaveUnsaved: "Quitter sans enregistrer",
  roleLeaveImpact: "Ces modifications ne sont pas enregistrées. Quitter ce rôle les écarte.",
  roleNameRequired: "Entrez un nom de rôle.",
  roleNameDuplicate: "Un rôle porte déjà ce nom.",
  roleAssignedPeople: "Personnes avec ce rôle",
  roleNoOneAssigned: "Personne n'est assignée à ce rôle. Aucune connexion actuelle ne change.",
  roleWillHaveAccess: "Qui aura accès",
  roleCanDo: "Qui peut le faire",
  roleCannotDo: "Qui ne peut pas le faire",
  roleWillLose: "Qui n'aura plus ceci",
  roleNoChanges: "Aucune permission de ce rôle ne change.",
  roleOwnerUnchanged: "La connexion courriel du propriétaire conserve l'accès complet lorsqu'aucun utilisateur PDV n'est connecté. Ce changement ne modifie pas cette connexion.",
  roleCreateImpact: "Ceci crée le rôle. Il commence avec les permissions du caissier. Personne ne le reçoit tant que vous ne l'assignez pas.",
  roleDeleteImpact: "Ceci retire le rôle. Les personnes ci-dessous conservent cette assignation, et ce rôle n'accordera plus aucun accès.",
  roleResetImpact: "Ceci ramène le rôle aux valeurs du produit. Les modifications non enregistrées sont écartées.",
  roleReportFailed: "Le rapport n'a pas pu être préparé. Rien n'a été enregistré.",
  roleNone: "Aucun.",
  rolePosSignIn: "PDV",
  roleEmailSignIn: "Courriel",
  roleSwitchOn: "Activé",
  roleSwitchOff: "Désactivé",
  roleInactiveExcluded: "Les utilisateurs PDV inactifs avec ce rôle ne sont pas inclus.",
  assignedOnly: "Assigné seulement",
  posCards: "Cartes du PDV",
  actions: "Actions",
  grantAllow: "Autorisé",
  grantApproval: "Approbation",
  grantDeny: "Non autorisé",
  approvalLimit: "Montant limite",
  shiftSupervisor: "Superviseur de quart",
  clockOnlyRole: "Entrée / sortie seulement",
  clockInOut: "Entrée / sortie",
  clockInOutHint: "Enregistrer une entrée ou une sortie",
  startTheDay: "Commencer la journée",
  dayAlreadyStarted: "Cette journée d'affaires est déjà commencée.",
  dayStartedBy: "Journée commencée par",
  timeClock: "Pointeuse",
  alreadyClockedIn: "Cette personne a déjà pointé son arrivée.",
  unpaidMealBreak: "Pause-repas non payée",
  paidBreak: "Pause payée",
  endBreak: "Terminer la pause",
  endShift: "Terminer le quart",
  onBreak: "En pause",
  noOpenOrders: "Aucune commande ouverte.",
  openOrdersRemain: "Des commandes ouvertes restent sur ce quart.",
  transferOrder: "Transférer une commande",
  noDrawerOnShift: "Ce quart n'a pas de tiroir-caisse.",
  sharedDrawerStaysOpen: "Le tiroir partagé reste ouvert.",
  drawerStillOpen: "Le tiroir doit encore être compté.",
  shiftClosed: "Quart terminé.",
  unpaidBreak: "Pause non payée",
  refunds: "Remboursements",
  unpaid: "Impayé",
  openOrders: "Commandes ouvertes",
  labourReport: "Rapport de présence",
  cashDrawerReport: "Rapport de tiroir-caisse",
  week: "Cette semaine",
  month: "Ce mois",
  custom: "Personnalisé",
  payable: "Payable",
  mealBreakMissing: "Aucune pause-repas non payée n'est enregistrée.",
  forcedClockOut: "Forcer le départ",
  forceClockOutAll: "Forcer le départ de tous",
  addShift: "Ajouter un quart",
  summaryCsv: "CSV sommaire",
  detailedCsv: "CSV détaillé",
  regularHours: "Heures régulières",
  overtimeHours: "Heures supplémentaires",
  grossWages: "Salaire brut",
  hourlyRate: "Taux horaire",
  reason: "Raison",
  permissionDenied: "Vous n'avez pas la permission pour cette action.",
  cashDrawer: "Tiroir-caisse",
  openCashDrawerSession: "Ouvrir le tiroir-caisse",
  cashIn: "Entrée d'argent",
  cashOut: "Sortie d'argent",
  cashDrop: "Dépôt d'argent",
  cashTipPayout: "Remise de pourboire",
  countCash: "Compter l'argent",
  handoverDrawer: "Remettre le tiroir",
  closeCashDrawer: "Fermer le tiroir-caisse",
  drawerAlreadyOpen: "Ce tiroir a déjà une session ouverte.",
  drawerClaimWaiting: "Ce poste ne peut pas prendre le tiroir tant que l'autre poste n'est pas reconcilié.",
  cashVariance: "Écart de caisse",
  addCashDrawer: "Ajouter un tiroir-caisse",
  sharedDrawer: "Partagé",
  dedicatedDrawer: "Dédié",
  manualCashBox: "Caisse manuelle",
  blindCount: "Comptage à l'aveugle",
  noSaleNeedsManager: "Une ouverture sans vente exige un gestionnaire",
  defaultFloat: "Fond de caisse proposé",
  cashDrawerSettingsHelp: "Le tiroir physique est l'appareil. La session est l'argent compté. Les modes de paiement choisissent encore quand un paiement ouvre le tiroir.",
  overtimeRules: "Heures supplémentaires hebdomadaires",
  weekStarts: "La semaine de travail commence",
  monday: "Lundi",
  sunday: "Dimanche",
  weeklyThreshold: "Seuil hebdomadaire (heures)",
  overtimeMultiplier: "Multiplicateur des heures supplémentaires",
  clockIn: "Pointer l'arrivée",
  clockOut: "Pointer le départ",
  clockedIn: "En service",
  clockedOut: "Hors service",
  noPunchesToday: "Aucun pointage aujourd'hui.",
  managerApproval: "Approbation du gestionnaire",
  managerApprovalHint: "Une personne autorisée entre son NIP. La personne connectée reste connectée.",
  approvalPin: "NIP d'approbation",
  approvalPinHint: "Ce NIP approuve une action restreinte. Il est distinct du mot de passe.",
  approvalPinInvalid: "Entrez le NIP à 6 chiffres d'une personne qui peut approuver.",
  approvalPinRejected: "Ce NIP ne peut pas approuver cette action.",
  approve: "Approuver",
  actionNotAllowed: "Ce rôle ne peut pas faire cela",
  managerRoleHint: "Le gestionnaire est un accès au bureau pour les opérations quotidiennes. Un utilisateur PDV et un NIP sont créés avec cet accès.",
  permissionDescription: "Personnalisez les permissions pour cet utilisateur. Les permissions remplacent les valeurs par défaut du rôle.",
  resetToRoleDefaults: "Réinitialiser aux Valeurs par Défaut du Rôle",
  permissionsUpdated: "Permissions mises à jour avec succès",
  posOperations: "Opérations POS",
  createOrders: "Créer des Commandes",
  completeOrders: "Finaliser les Commandes",
  processRefunds: "Traiter les Remboursements",
  processRefundsDescription: "Seul le rôle de gestionnaire a ceci par défaut",
  viewReports: "Voir les Rapports",
  manageTables: "Gérer les Tables",
  manageReservations: "Gérer les Réservations",
  manageCustomers: "Gérer les Clients",
  sidebarAccess: "Accès à la Barre Latérale",
  cashier: "Caissier",
  server: "Serveur",
  manager: "Gestionnaire",
  // PIN Management
  autoGenerate: "Auto",
  pinGenerated: "PIN généré avec succès",
  pinAlreadyInUse: "Ce PIN est déjà utilisé par un autre utilisateur",
  errorGeneratingPIN: "Erreur lors de la génération du PIN",
  errorCheckingPIN: "Erreur lors de la vérification de la disponibilité du PIN",
  pinIsSet: "PIN est défini",
  signInUser: "Utilisateur Connecté",
  backOfficeUser: "Utilisateur Back Office",
  linkedPOSUser: "Utilisateur POS lié",
  linkedPOSUserPlaceholder: "Sélectionner un utilisateur POS",
  linkedPOSUserNone: "Aucun utilisateur POS lié",
  linkedPOSUserHint: "Lorsque le pavé PIN à la connexion est désactivé, cet utilisateur POS démarre automatiquement après la connexion Firebase.",
  noPOSUsersToLink: "Créez d'abord un utilisateur POS, puis liez-le ici.",
  linkedPOSUserSaved: "Utilisateur POS lié enregistré",
  linkedPOSUserCleared: "Utilisateur POS lié retiré",
  linkedPOSUserSaveFailed: "Échec de l'enregistrement de l'utilisateur POS lié",
  logoutBackOfficeUser: "Déconnexion Utilisateur Back Office",
  logoutBackOfficeUserConfirmTitle: "Déconnecter l'utilisateur back office ?",
  logoutBackOfficeUserConfirmBody: "Si vous vous déconnectez, vous interromprez l'opération. Pour déconnecter l'utilisateur POS à la place, choisissez Déconnecter l'utilisateur POS. L'utilisateur suivant a besoin d'un mot de passe administrateur et des privilèges administrateur pour se connecter.",
  logOffPOSUser: "Déconnecter l'utilisateur POS",
  backOfficeUserLoggedOut: "Utilisateur back office déconnecté",
  errorLoggingOut: "Erreur lors de la déconnexion",
  originalPIN: "PIN Original",
  enterOriginalPIN: "Entrez le PIN original à 6 chiffres",
  originalPINRequired: "Le PIN original est requis",
  originalPINIncorrect: "Le PIN original est incorrect",
  confirmPIN: "Confirmer le Nouveau PIN",
  confirmNewPIN: "Confirmer le nouveau PIN à 6 chiffres",
  confirmPINRequired: "Veuillez confirmer le nouveau PIN",
  pinMismatch: "Le nouveau PIN et la confirmation ne correspondent pas",
  notAvailable: "Non disponible",
  notSet: "Non défini",
  profilePicture: "Photo de Profil",
  changePIN: "Changer le PIN",
  newPIN: "Nouveau PIN",
  pinChanged: "PIN modifié avec succès",
  errorChangingPIN: "Erreur lors du changement du PIN",
  noPOSUser: "Aucun Utilisateur POS",
  firstName: "Prénom",
  lastName: "Nom de famille",
  firstNameRequired: "Le prénom est requis",
  enterFirstName: "Entrez le prénom",
  enterLastName: "Entrez le nom de famille",
  selectServicesHelper: "Sélectionnez les services pour lesquels ce menu sera disponible. Laissez vide pour que ce menu s'applique à tous les services.",
  tableService: "Service à table",
  counter: "Comptoir",
  takeaway: "Pour Emporter",
  delivery: "Livraison",
  online: "En ligne",
  applicableHours: "Heures applicables",
  applicableHoursHelper: "Définissez les heures pendant lesquelles ce sera disponible. Si aucune heure n'est saisie, cela s'applique à tout moment. Entrez l'heure au format 24H, par exemple 21:00 pour 21h. Assurez-vous que les créneaux horaires ne se chevauchent pas ou ne se ferment pas avant de s'ouvrir.",
  applicableHoursOvernightHelper: "Pour les fenêtres horaires de nuit (franchissant minuit), définissez l'heure de fermeture au format 24 heures. Par exemple, 11:00 à 03:00 signifie 11h00 à 3h00 le jour suivant. Utilisez la case à cocher 24H Disponible si l'élément est disponible toute la journée.",
  storeHours: "Heures d'ouverture",
  storeHoursHelper: "Définissez les heures d'ouverture régulières de votre magasin. Ces heures s'appliquent à tous les jours sauf si elles sont remplacées par les Heures spéciales.",
  storeHoursSaved: "Heures d'ouverture enregistrées",
  storeHoursSavedSuccess: "Les heures d'ouverture ont été enregistrées avec succès",
  errorFetchingStoreHours: "Erreur lors de la récupération des heures d'ouverture",
  errorSavingStoreHours: "Erreur lors de l'enregistrement des heures d'ouverture",
  saveStoreHours: "Enregistrer les heures d'ouverture",
  allChannelSameHours: "Tous les canaux mêmes heures",
  counterStoreHours: "Heures d'ouverture du comptoir",
  tableStoreHours: "Heures d'ouverture du service à table",
  takeawayStoreHours: "Heures d'ouverture à emporter",
  deliveryStoreHours: "Heures d'ouverture de livraison",
  onlineStoreHours: "Heures d'ouverture en ligne",
  saveSpecialHours: "Enregistrer les heures spéciales",
  specialHours: "Heures spéciales",
  specialHoursHelper: "Définissez des plages de dates avec des heures d'ouverture personnalisées. Celles-ci remplacent les heures d'ouverture régulières pour les plages de dates spécifiées.",
  specialHoursSaved: "Heures spéciales enregistrées",
  specialHoursSavedSuccess: "Les heures spéciales ont été enregistrées avec succès",
  errorFetchingSpecialHours: "Erreur lors de la récupération des heures spéciales",
  errorSavingSpecialHours: "Erreur lors de l'enregistrement des heures spéciales",
  addSpecialHours: "Ajouter des heures spéciales",
  nextDay: "Jour suivant",
  openTime: "Heure d'ouverture",
  closeTime: "Heure de fermeture",
  dateRequired: "Date requise",
  pleaseSelectDate: "Veuillez sélectionner une date pour toutes les heures spéciales",
  pleaseSelectFromToDate: "Veuillez sélectionner les dates de début et de fin pour toutes les heures spéciales",
  fromDate: "De",
  toDate: "À",
  invalidDateRange: "Plage de dates invalide",
  toDateAfterFromDate: "La date de fin doit être égale ou postérieure à la date de début",
  timeRequired: "Heure requise",
  pleaseEnterOpenCloseTime: "Veuillez saisir l'heure d'ouverture et de fermeture",
  addTimeSlot: "Ajouter un créneau horaire",
  addTimeWindow: "Ajouter une fenêtre horaire",
  activeTimeWindows: "Fenêtres horaires actives",
  day: "Jour",
  open: "Ouverture",
  hour24: "24 Heures",
  hour24Available: "24H Disponible",
  noLimit: "Sans limite",
  invalidTimeFormat: "Format d'heure invalide",
  use24HFormat: "Veuillez utiliser le format 24H (par exemple, 21:00)",
  invalidTimeRange: "Plage horaire invalide",
  closeAfterOpen: "L'heure de fermeture doit être après l'heure d'ouverture",
  overlappingSlots: "Créneaux horaires qui se chevauchent",
  noOverlapSameDay: "Les créneaux horaires ne peuvent pas se chevaucher le même jour",
  enableAgeRestrictedAccess: "Activer l'accès restreint par âge",
  ageRestrictedHelper: "Activer cela permettra uniquement aux clients connectés avec leur âge vérifié de commander depuis ce menu. La vérification de l'âge doit être activée pour que cette fonctionnalité fonctionne.",
  enablePreOrdersOnly: "Activer uniquement les précommandes",
  preOrdersOnlyHelper: "Activer cela désactivera les commandes immédiates pour ce menu et exigera que les gens précommandent selon les conditions ci-dessous.",
  preOrderDaysInAdvance: "Jours de précommande à l'avance",
  preOrderDaysHelper: "Assure que les clients doivent précommander des articles de ce menu un certain nombre de jours à l'avance.",
  preOrderCutoffTime: "Heure limite de précommande (format 24H)",
  preOrderCutoffHelper: "Utilisez en conjonction avec l'option ci-dessus pour assurer que les clients doivent passer des commandes avant une certaine heure le dernier jour de précommande.",
  uniqueNameForCategory: "Un nom unique pour votre catégorie",
  categoryDescriptionPlaceholder: "Dites à vos clients plus de détails sur cette catégorie",
  categoryDescriptionHelper: "Dites à vos clients plus de détails sur cette catégorie",
  hideUnavailableCategory: "Masquer la catégorie indisponible",
  hideUnavailableCategoryHelper: "Activer cela masquera cette catégorie dans votre menu si elle est indisponible. Sinon, cette catégorie sera toujours affichée avec un message d'avertissement indiquant qu'elle n'est pas disponible.",
  selectServicesCategoryHelper: "Sélectionnez les services pour lesquels cette catégorie sera disponible. Laissez vide pour s'appliquer à tous les services. Veuillez vérifier avec le paramètre Services du menu parent dans l'onglet Conditions car il a une priorité plus élevée en cas de conflit.",
  applicableHoursCategoryHelper: "Définissez les heures pendant lesquelles cette catégorie sera disponible. Si aucune heure n'est saisie, la catégorie s'applique à tout moment. Entrez l'heure au format 24H, par exemple 21:00 pour 21h. Assurez-vous que les créneaux horaires ne se chevauchent pas ou ne se ferment pas avant de s'ouvrir. Veuillez vérifier avec le paramètre Heures applicables du menu parent dans l'onglet Conditions car il a une priorité plus élevée en cas de conflit.",
  imageAndTags: "Image et tags",
  optionsAndIngredients: "Options et ingrédients",
  image: "Image",
  imageUrlPlaceholder: "URL de l'image (incluant https://)",
  upload: "Télécharger",
  customImage: "Image personnalisée",
  remoteImageUrl: "URL d'image distante",
  fileNameRestriction: "Le nom du fichier ne peut pas contenir de caractères spéciaux. Seules les lettres et les chiffres sont autorisés.",
  errorLoadingImage: "Erreur de chargement de l'image",
  imageLoadError: "Échec du chargement de l'image. Veuillez vérifier l'URL ou réessayer de télécharger.",
  noImageSelected: "Aucune image sélectionnée",
  itemName: "Nom de l'article",
  itemDescription: "Description de l'article",
  categoryRequired: "Catégorie requise",
  menuRequired: "Menu requis",
  advanceOptionSetting: "Option avancée",
  itemTags: "Tags d'articles",
  templates: "Modèles",
  csvExport: "Export CSV",
  csvImport: "Import CSV",
  errorLoadingMenus: "Erreur lors du chargement des menus",
  menuChangesRequireOnline: "Les modifications de menu ne peuvent être effectuées qu'en ligne. Veuillez vérifier votre connexion Internet.",
  unauthorizedAccess: "Accès non autorisé",
  bulkEditPricesMode: "Mode d'édition en masse des prix",
  copy: "Copier",
  paste: "Coller",
  copiedToClipboard: "Copié dans le presse-papiers",
  pastedFromClipboard: "Collé depuis le presse-papiers",
  errorPasting: "Erreur lors du collage",
  pricesUpdated: "Prix mis à jour",
  noChanges: "Aucun changement à enregistrer",
  errorSavingPrices: "Erreur lors de l'enregistrement des prix",
  available: "Disponible",
  noStock: "Rupture de stock",
  hide: "Masquer",
  reordered: "Réorganisé",
  rearrangeHelper: "Glissez-déposez pour réorganiser les menus, catégories et articles",
  optionsAndIngredientsComingSoon: "Options et ingrédients à venir",
  selectMenu: "Sélectionner un menu",
  selectCategory: "Sélectionner une catégorie",
  imageUploaded: "Image téléchargée",
  errorUploadingImage: "Erreur lors du téléchargement de l'image",
  pleaseLogIn: "Veuillez vous connecter pour télécharger des images",
  authenticationFailed: "L'authentification a échoué. Veuillez vous reconnecter.",
  storageNotInitialized: "Firebase Storage n'est pas initialisé",
  uploadFailed: "Le téléchargement a échoué. Veuillez vérifier votre connexion Internet et réessayer.",
  pleaseEnterValidUrl: "Veuillez entrer une URL valide",
  // Reservations
  reservations: "Réservations",
  reservationManagement: "Gérer les réservations clients",
  newReservation: "Nouvelle Réservation",
  editReservation: "Modifier la Réservation",
  reservationDate: "Date de Réservation",
  reservationTime: "Heure de Réservation",
  numberOfGuests: "Nombre d'Invitations",
  assignTable: "Attribuer une Table (Optionnel)",
  reservationNotes: "Notes",
  confirmReservation: "Confirmer la Réservation",
  seatCustomer: "Asseoir le Client",
  cancelReservation: "Annuler la Réservation",
  reservationStatus: "Statut",
  pending: "En Attente",
  confirmed: "Confirmé",
  seated: "Assis",
  cancelled: "Annulé",
  noShow: "Absent",
  completed: "Terminé",
  upcomingReservations: "Réservations à Venir",
  upcoming: "À venir",
  reservationCount: "Nombre",
  timeChangedFromTo: "De {from} à {to}",
  rescheduleAwaitingConfirmation: "En attente de confirmation",
  todaysReservations: "Réservations d'Aujourd'hui",
  noReservationsFound: "Aucune réservation trouvée",
  phoneRequiredForReservation: "Le numéro de téléphone est requis pour les réservations",
  customerNameRequired: "Le nom du client est requis",
  reservationDateRequired: "La date de réservation est requise",
  reservationDateMustBeTodayOrFuture: "La date de réservation doit être aujourd'hui ou dans le futur",
  reservationTimeRequired: "L'heure de réservation est requise",
  numberOfGuestsRequired: "Le nombre d'invités est requis (minimum 1)",
  selectTime: "Sélectionner l'Heure",
  reservationCreated: "Réservation créée",
  reservationUpdated: "Réservation mise à jour",
  reservationConfirmed: "Réservation confirmée",
  reservationCancelled: "Réservation annulée",
  reservationDeleted: "Réservation supprimée",
  customerSeated: "Client assis",
  searchReservations: "Rechercher par nom ou téléphone...",
  allStatuses: "Tous les Statuts",
  allDates: "Toutes les Dates",
  today: "Aujourd'hui",
  tomorrow: "Demain",
  past: "Passé",
  tryAdjustingFilters: "Essayez d'ajuster vos filtres",
  createFirstReservation: "Créer votre première réservation",
  unknownCustomer: "Client Inconnu",
  moreOptions: "Plus d'options",
  guests: "invités",
  loading: "Chargement...",
  reservationConflictMessage: "Cette réservation a été modifiée par un autre membre du personnel. Voulez-vous écraser leurs modifications?",
  reservationWasModified: "La réservation a été modifiée par un autre membre du personnel. Veuillez actualiser et réessayer.",
  activeReservations: "réservations",
  clickToCreateReservation: "Cliquez pour créer une nouvelle réservation",
  decrease: "Diminuer",
  increase: "Augmenter",
  partySize: "Taille du groupe",
  partySizeRequired: "La taille du groupe est requise (minimum 1)",
  staff: "le personnel",
  theGuest: "le client",
  canceledByActor: "Annulée par {actor}",
  canceledByActorAt: "Annulée par {actor} à {time}",
  canceledByCustomer: "Annulée par le client",
  canceledByCustomerAt: "Annulée par le client à {time}",
  confirmedByCustomerAt: "Confirmée par le client à {time}",
  updatedByCustomerAt: "Modifiée par le client à {time}",
  acknowledgeCancellation: "Confirmer la lecture de l'annulation",
  noShowRecordedAt: "Absence enregistrée par {actor} à {time}",
  seatedByActorAt: "Client installé par {actor} à {time}",
  partySizeChangedFromTo: "Taille du groupe modifiée de {from} à {to}",
  sortByStatus: "Trier par statut",
  sortByStatusEnabled: "Tri par statut activé (cliquez pour désactiver)",
  selectCustomer: "Sélectionner un client",
  customerLanguage: "Langue",
  english: "Anglais",
  french: "Français",
  sendConfirmation: "Envoyer la confirmation",
  confirmationSent: "Envoyée",
  confirmationNotSent: "Non envoyée",
  confirmationQueued: "Confirmation en attente d'envoi",
  syncPending: "Non synchronisée",
  syncSynced: "Synchronisée",
  syncFailed: "Échec de la synchronisation",
  inStoreReservation: "En magasin",
  onlineReservation: "En ligne",
  websiteAddressMissing: "L'adresse du site web est manquante.",
  pauseServices: "Interrompre les services",
  restOfDay: "Reste de la journée",
  pauseUntilDate: "Jusqu'à une date",
  pauseDateRange: "Période",
  pauseStartDate: "Date de début",
  pauseEndDate: "Date de fin",
  tooBusy: "Trop occupé",
  closingEarly: "Fermeture anticipée",
  equipmentUnavailable: "Équipement indisponible",
  privateEvent: "Événement privé",
  fullyBooked: "Complet",
  staffUnavailable: "Personnel indisponible",
  reasonRequired: "Sélectionnez un motif ou saisissez un motif.",
  durationRequired: "Sélectionnez une durée.",
  servicesPaused: "Services interrompus",
  until: "jusqu'au",
  keyboardBackspace: "Retour arrière",
  keyboardTab: "Tabulation",
  keyboardCaps: "Verrouillage majuscules",
  keyboardEnter: "Entrée",
  keyboardShift: "Majuscule",
  keyboardSpace: "Espace",
  keyboardToggle: "Activer/désactiver le clavier virtuel",
  keyboardFrench: "FR",
  keyboardEnglish: "EN",
  // End of Day
  endOfDay: "Fin de Journée",
  endOfDayProcess: "Processus de Fin de Journée",
  closeZeroBalanceOrders: "Fermer les Commandes à Solde Zéro",
  reconcileOpenOrders: "Réconcilier les Commandes Ouvertes",
  reconcileOpenOrdersDescription: "Veuillez réconcilier toutes les commandes ouvertes avant de continuer.",
  closeCashDrawer: "Fermer le Tiroir Caisse",
  closeCashDrawerDescription: "Entrez le montant de fin de journée du tiroir caisse (optionnel).",
  generateSalesReport: "Générer le Rapport de Ventes",
  previewReport: "Aperçu du Rapport",
  printReport: "Imprimer le Rapport",
  eodComplete: "Fin de Journée Terminée",
  eodCannotComplete: "Impossible de terminer la Fin de Journée",
  eodError: "Erreur",
  eodErrorClosingOrders: "Erreur lors de la fermeture des commandes à solde zéro",
  voidOrder: "Annuler",
  closeToCash: "Fermer en Espèces",
  carryForward: "Reporter",
  goToOrder: "Aller à la Commande",
  orderReconciled: "Commande Réconciliée",
  errorReconcilingOrder: "Erreur lors de la réconciliation de la commande",
  navigateToOrder: "Naviguer vers la Commande",
  pleaseCompleteOrderManually: "Veuillez compléter la commande manuellement",
  allOrdersReconciled: "Toutes les commandes ont été réconciliées.",
  remainingOrders: "Commandes restantes",
  expectedCash: "Espèces Attendues",
  actualCash: "Montant d'Espèces Réel",
  enterCashAmount: "Entrez le montant d'espèces",
  difference: "Différence",
  skip: "Passer",
  continue: "Continuer",
  cancel: "Annuler",
  complete: "Terminer",
  processing: "Traitement en cours...",
  noZeroBalanceOrders: "Aucune commande à solde zéro trouvée.",
  generatingReport: "Génération du rapport...",
  salesReportPreview: "Aperçu du Rapport de Ventes",
  noDataAvailable: "Aucune donnée disponible",
  zeroBalanceOrdersClosed: "Commandes à Solde Zéro Fermées",
  ordersReconciled: "Commandes Réconciliées",
  savedCarts: "Tickets en attente",
  eodSavedCartsDescription: "Examinez et supprimez les tickets de comptoir en attente. Ce sont des tickets avec des articles mais sans commandes soumises.",
  savedCartsCleared: "Paniers Enregistrés Supprimés",
  clearSessions: "Effacer les Sessions",
  eodClearSessionsDescription: "Les sessions sans commandes ouvertes seront effacées. Les sessions avec les drapeaux stayAlive ou isStatic seront conservées.",
  sessionsCleared: "Sessions Effacées",
  noSessionsToClear: "Aucune session à effacer",
  clearingSessions: "Effacement des sessions...",
  readyToClear: "Prêt à Effacer",
  clearAll: "Tout Effacer",
  cashDrawerAmount: "Montant du Tiroir Caisse",
  reportReady: "Le rapport est prêt à être imprimé.",
  printingReport: "Impression du Rapport",
  printJobQueued: "Le travail d'impression a été mis en file d'attente.",
  // EOD Settings
  eodSettings: "Paramètres de Fin de Journée",
  autoCloseZeroBalance: "Fermer automatiquement les commandes à solde zéro",
  requireCashDrawer: "Exiger le décompte du tiroir caisse",
  requireAllReconciled: "Exiger que toutes les commandes soient réconciliées",
  allowCarryForward: "Permettre le report de commande",
  autoLogoutAfterEOD: "Déconnexion automatique après la fin de journée",
  eodReportPrinter: "Imprimante de Rapport de Fin de Journée",
  selectPrinter: "Sélectionner l'imprimante",
  defaultPrinter: "Par défaut",
  settingsSaved: "Paramètres Enregistrés",
  eodSettingsSaved: "Paramètres de fin de journée enregistrés avec succès",
  errorSavingSettings: "Erreur lors de l'enregistrement des paramètres",
  errorCompletingEOD: "Erreur lors de la finalisation de la fin de journée",
  noOpenOrders: "Aucune commande ouverte trouvée. Toutes les commandes sont terminées.",
  // Simplified EOD translations
  eodReminderTitle: "Avant de fermer la journée, veuillez vérifier:",
  eodNoReminders: "Aucun élément à vérifier. Vous pouvez procéder à la fin de journée.",
  eodSavedCartsReminder: "Vous avez {count} ticket(s) en attente avec des articles. Veuillez les vider avant de fermer la journée.",
  unclosedOrders: "Commandes Non Fermées",
  eodUnclosedOrdersReminder: "Vous avez {count} commande(s) non fermée(s) ou impayée(s). Veuillez les traiter avant de fermer la journée.",
  unclosedDeliveryTables: "Tables de Livraison Non Fermées",
  eodUnclosedDeliveryReminder: "Vous avez {count} table(s) de livraison non fermée(s). Veuillez les fermer avant de fermer la journée.",
  eodReminderNote: "Vous pouvez fermer cette boîte de dialogue, nettoyer les éléments ci-dessus, puis revenir pour continuer la fin de journée.",
  posSalesReport: "Rapport des Ventes POS",
  posSalesOnly: "(Ventes POS Uniquement - Exclut les Commandes en Ligne)",
  closeDay: "Fermer la Journée",
  eodDayClosed: "Journée fermée avec succès. Le jour suivant a commencé.",
  errorGeneratingReport: "Erreur lors de la génération du rapport des ventes",
  eodCannotProceed: "Impossible de Continuer",
  eodMustCleanUp: "Vous devez nettoyer tous les tickets en attente, les commandes non fermées et les tables de livraison non fermées avant de continuer.",
  localPrint: "Impression Locale",
  noPrinterConfigured: "Aucune imprimante configurée pour le rapport des ventes POS. Veuillez configurer une imprimante avec le rapport des ventes POS activé dans les paramètres de l'imprimante.",
  errorPrintingReport: "Erreur lors de l'impression du rapport des ventes",
  print: "Imprimer",
  // Transaction History
  transactionHistory: "Historique des Transactions en Argent",
  cashTransactionHistory: "Historique des Transactions en Argent",
  startingCash: "Argent de Départ",
  cashIn: "Argent Reçu",
  cashOut: "Argent Rendu",
  netCashFlow: "Flux de Trésorerie Net",
  expectedCash: "Argent Attendu",
  cashReceived: "Reçu",
  cashBalance: "Solde",
  inDrawer: "Dans le tiroir",
  fromCustomers: "Des clients",
  changeGiven: "Monnaie rendue",
  cashInMinusOut: "Reçu - Rendu",
  startingCashUpdated: "Solde d'argent de départ mis à jour",
  errorSavingStartingCash: "Erreur lors de l'enregistrement du solde d'argent de départ",
  orderCounter: "ID Commande",
  posOrderId: "ID POS",
  channelOrderId: "ID Canal",
  noTransactionsFound: "Aucune transaction trouvée",
  orderId: "ID Commande",
  dateTime: "Date/Heure",
  tableOrCounter: "Table",
  orderTotal: "Total",
  refresh: "Actualiser",
  // OEM Settings
  oem: "OEM",
  oemManagement: "Gestion OEM",
  oemDescription: "Gérer les configurations de marque blanche",
  createOEM: "Créer OEM",
  editOEM: "Modifier OEM",
  deleteOEM: "Supprimer OEM",
  deleteOEMConfirmation: "Êtes-vous sûr de vouloir supprimer cet OEM ? Cette action ne peut pas être annulée.",
  brandName: "Nom de marque",
  customDomain: "Domaine personnalisé",
  customDomainHelp: "Entrez le domaine complet qui accédera à cet OEM (sans https://)",
  searchOEM: "Rechercher par nom de marque, domaine ou e-mail...",
  noOEMsFound: "Aucun OEM trouvé",
  noOEMsYet: "Aucun OEM créé pour le moment",
  contactInformation: "Informations de contact",
  logo: "Logo",
  uploadLogo: "Télécharger le logo",
  changeLogo: "Changer le logo",
  welcomeToNuagePos: "Bienvenue à NuagePOS Eagle",
  poweredBy: "Propulsé par",
  // Training Mode
  trainingMode: "Mode Formation",
  stationTrainingOn: "Mode formation activé",
  stationTrainingHint: "La formation est désactivée jusqu'à ce que vous l'activiez. Le menu de l'utilisateur POS affiche le Mode Formation seulement sur ce poste.",
  exit: "Quitter",
  exitAdminPinPrompt: "Pour quitter, utilisez le PIN administrateur.",
  exitAdminPinWrong: "Ce PIN n'est pas un PIN administrateur.",
  exitAdminPinUnavailable: "Aucun PIN administrateur n'est disponible sur ce poste.",
  exitTrainingMode: "Quitter le Mode Formation",
  enableTrainingMode: "Activer le Mode Formation",
  disableTrainingMode: "Désactiver le Mode Formation",
  trainingModeHasEnded: "Le Mode Formation a Pris Fin",
  trainingModeExpired: "Mode Formation Expiré",
  trainingModeExpiredNote: "Toutes les transactions de formation ont été complétées. Le système sera actualisé et retournera au fonctionnement normal.",
  returnToProductionMode: "Retourner au Mode Production",
  exitTrainingModeTitle: "Quitter le Mode Formation?",
  exitTrainingModeDescription: "Êtes-vous sûr de vouloir quitter le Mode Formation? Vous retournerez au Mode Production et toutes les transactions de formation seront complétées.",
  exitTrainingModeNote: "Vous pouvez toujours réactiver le Mode Formation plus tard si nécessaire. Le système sera actualisé et retournera au fonctionnement normal.",
  trainingModeWarning: "Avertissement du Mode Formation",
  trainingModeNotForProduction: "Ceci est le Mode Formation. Il n'est pas destiné à un usage en production.",
  trainingModeReadInfo: "Veuillez lire les informations suivantes avant d'activer le Mode Formation:",
  trainingModeTransactionMarked: "Toutes les transactions seront marquées comme formation (mode FOR)",
  trainingModeNoAffectCounters: "Les transactions de formation n'affecteront pas les compteurs de ventes en production",
  trainingModeIndependentSession: "Chaque utilisateur a sa propre session de formation indépendante",
  trainingModePurpose: "Le Mode Formation est conçu uniquement à des fins d'apprentissage et de pratique. Toutes les transactions seront envoyées à WEB-SRM mais marquées comme formation.",
  trainingModeEnabled: "Mode Formation Activé",
  cannotEnableTrainingMode: "Impossible d'Activer le Mode Formation",
  failedToExitTrainingMode: "Échec de la sortie du Mode Formation",
  userMenuDisabledInTrainingMode: "Menu utilisateur désactivé en Mode Formation",
  trainingModeDuration: "Durée du Mode Formation (minutes)",
  trainingModeDurationDescription: "Définir la durée des sessions de Mode Formation (1-90 minutes)",
  trainingModeDurationInvalid: "Veuillez entrer une durée valide entre 1 et 90 minutes",
  trainingModeDurationUpdated: "Durée du Mode Formation mise à jour avec succès",
  trainingModeDurationUpdateFailed: "Échec de l'enregistrement de la durée du Mode Formation",
  storeIdMissing: "L'identifiant du magasin est manquant. Veuillez actualiser la page et réessayer.",
  storeDataNotLoaded: "Les données du magasin ne sont pas chargées. Veuillez patienter et réessayer.",
  trainingModeExpiredDescription: "Votre session de Mode Formation a pris fin. Vous retournerez maintenant au Mode Production.",
  trainingModeAutoExpire: "Le Mode Formation expirera automatiquement",
  trainingModeEnabledDescription: "Votre session expirera automatiquement.",
  sessionWillAutoExpire: "Votre session expirera automatiquement.",
  minutes: "minutes",
  storeInformation: "Informations du magasin",
  storeLogo: "Logo du magasin",
  sessionAndDisplaySettings: "Paramètres de session et d'affichage",
  hideTopBar: "Masquer la barre du haut",
  hideTopBarHelp: "Masque la barre de titre lorsque le PDV n'est pas en plein écran.",
  hideTaskbar: "Masquer la barre des tâches",
  hideTaskbarHelp: "Masque la barre des tâches Windows lorsque le PDV n'est pas en plein écran.",
  regionalIntegrationSettings: "Paramètres régionaux et d'intégration",
  siteLanguage: "Langue du site",
  posDashboardCards: "Cartes du tableau de bord POS",
  posInterfaceTheme: "Thème de l'interface POS",
  posInterfaceThemeHelp: "Sélectionnez un thème, puis appuyez sur Confirmer.",
  posThemeUpdated: "Thème du POS mis à jour",
  posThemeNow: "Le thème du POS est maintenant {name}.",
  posThemeUpdateFailed: "Le thème du POS n'a pas été mis à jour.",
  posThemeCurrent: "Actuel",
  tableView: "Vue des tables",
  modernView: "Basculer entre vue classique et moderne",
  viewModern: "Vue : Moderne",
  viewClassic: "Vue : Classique",
  modernViewLabel: "Moderne",
  classicViewLabel: "Classique",
  tableStyle: "Style de table",
  tableLayoutTitle: "Disposition des tables",
  tableLayoutDescription: "Disposez les tables sur le plan. Ajoutez une table prête à l'emploi, puis glissez-la à sa place.",
  tableLayoutLiveDescription: "Voyez l'état des tables en direct sur le plan.",
  addTable: "Ajouter une table",
  addRoom: "Ajouter une salle",
  addRoomSequence: "Salle {room}. Les tables de la suite commune vont jusqu'à {highest}.",
  addRoomSequenceEmpty: "Salle {room}. Aucune table numérotée n'est encore dans la suite commune.",
  addRoomContinue: "Continuer à partir de {next}",
  addRoomStartAtOne: "Commencer à 1",
  addRoomStartAt: "Commencer à",
  addRoomUseNumber: "Utiliser ce numéro",
  tableNameHint: "Jusqu'à 4 chiffres, ou 5 caractères.",
  tableNameTooLong: "Utilisez au plus 4 chiffres, ou 5 caractères.",
  selectSeat: "Choisir un siège",
  tableNoFloor: "Cette table n'a pas de plan.",
  tableNameSuggest: "Une lettre permet 999 tables, par exemple P001. Deux lettres permettent 99 tables, par exemple VP01. Trois lettres, par exemple VIP1, permettent 9 tables.",
  tableNameLimitTitle: "Longueur du nom",
  roomLimit: "Un plan peut compter 26 salles, de A à Z.",
  specialSetting: "Réglage spécial",
  specialName: "Nom",
  specialNameFixed: "Le nom de la salle reste le même.",
  specialOneDate: "Une date",
  specialDateRange: "Plage de dates",
  specialStartDate: "Date de début",
  specialEndDate: "Date de fin",
  specialAllDay: "Toute la journée",
  specialSetHours: "Choisir les heures",
  specialRooms: "Salles",
  specialWeekend: "Chaque fin de semaine",
  specialWeekdays: "Jours de semaine",
  specialDate: "Date",
  specialStart: "Début",
  specialEnd: "Fin",
  specialArrange: "Disposer",
  specialApply: "Appliquer maintenant",
  specialNew: "Nouveau réglage",
  specialAddNew: "Ajouter un nouveau réglage",
  specialNoEffect: "Ce réglage n'a aucun effet.",
  specialNoEffectShort: "Aucun effet",
  specialOnSchedule: "Activé. Le plan en service l'utilise pendant son horaire.",
  specialScheduleTitle: "Horaire",
  specialInUse: "Ce réglage est en service.",
  specialLater: "Ce réglage est utilisé plus tard.",
  specialEverydayNow: "Le plan de tous les jours est en service.",
  specialEverydayFloor: "le plan de tous les jours",
  specialEverydayBackDate: "Le plan de tous les jours revient le {date}.",
  specialEverydayBackTime: "Le plan de tous les jours revient à {time}.",
  specialEverydayOtherDays: "Le plan de tous les jours est utilisé les autres jours.",
  specialTurnOffEffect: "Désactivez {name}. {room} utilise {next}.",
  specialTurnOnEffect: "Activez {name}. {room} utilise {name}.",
  specialTurnOnWaits: "Activez {name}. {room} garde {next} jusqu'à cet horaire.",
  specialChooseFloor: "Choisissez la salle.",
  specialNoDates: "Aucune date pour le moment.",
  specialEditTables: "Modifier les tables",
  specialEditTablesHelp: "Déplacez, fusionnez ou divisez les tables de {name}.",
  specialThisSetting: "Ce réglage",
  specialSavedSchedule: "Horaire enregistré",
  specialNoScheduleYet: "Aucun horaire enregistré.",
  specialStepWhen: "Quand ce plan est utilisé",
  specialStepWhenHelp: "Choisissez les jours, un jour, ou une plage de dates.",
  specialByOneDay: "Un jour",
  specialSelectDays: "Sélectionnez les jours.",
  specialSelectDay: "Sélectionnez le jour.",
  specialSelectRange: "Sélectionnez la date de début et la date de fin.",
  specialStepHours: "Heures",
  specialFloorStep: "Plan de salle",
  specialEditFloor: "Modifier le plan de salle",
  specialEditFloorHelp: "Modifiez le plan de salle de {name}.",
  specialEmpty: "Aucun réglage spécial.",
  specialUntitled: "Sans titre",
  specialOnNow: "En cours",
  specialOff: "Désactivé",
  specialTurnOff: "Désactiver",
  specialTurnOn: "Activer",
  specialSaved: "Réglage spécial enregistré",
  specialOverlap: "Ces règles se chevauchent. La plage la plus courte est utilisée.",
  specialMerge: "Fusionner",
  specialMergePick: "Cliquez sur les tables. La première garde son nom.",
  specialRoomTaken: "Cette salle a déjà un réglage spécial.",
  specialFloorLimit: "Chaque salle peut avoir jusqu'à 7 réglages spéciaux.",
  specialRoomCount: "{count} sur {max}",
  specialRoomFull: "Cette salle a déjà 7 réglages spéciaux.",
  specialMergeHelp: "La première table garde son nom. Les autres restent masquées jusqu’à la fin de ce réglage.",
  specialMergeNone: "Aucune table de la même forme n’est assez proche.",
  specialSplit: "Diviser",
  specialSplitHelp: "Le nom d’origine reste sur la première partie. Chaque partie a au moins 2 places.",
  specialNameShort: "Utilisez d’abord un nom plus court. Une nouvelle partie doit tenir en 5 caractères.",
  specialOrdersTitle: "Commandes ouvertes",
  specialOrdersBody: "Des commandes sont encore ouvertes sur ces tables.",
  specialOrdersAsk: "Appliquer cette disposition ?",
  specialProceed: "Continuer",
  specialMon: "Lun",
  specialTue: "Mar",
  specialWed: "Mer",
  specialThu: "Jeu",
  specialFri: "Ven",
  specialSat: "Sam",
  specialSun: "Dim",
  specialAnd: "et",
  specialSaveSetting: "Enregistrer le plan de salle",
  specialSaveOnly: "Ceci enregistre seulement le plan spécial. Le plan de tous les jours reste en place.",
  specialOverlapTables: "Les tables {names} se chevauchent. Déplacez-en une, puis enregistrez.",
  specialRevert: "Rétablir",
  specialIntro: "Un réglage spécial est un second plan pour les salles que vous choisissez. Le plan de tous les jours reste en place. Le plan spécial est utilisé seulement pendant que ce réglage est actif.",
  specialFollow: "Suivre l'horaire",
  specialUseNow: "Utiliser ce plan maintenant",
  specialOffChoice: "Désactivé",
  specialUseNowHelp: "La salle change dès que vous confirmez. Elle n'attend pas l'horloge. Les commandes ouvertes restent sur leurs tables.",
  specialOffHelp: "Cette salle utilise le plan de tous les jours jusqu'à ce que vous choisissiez l'une des options ci-dessus.",
  specialArrangeLayout: "Disposer le plan",
  specialEditSchedule: "Modifier l'horaire",
  specialWeekdayTaken: "{day} est déjà {name}. Désactivez {name}, ou choisissez d'autres jours.",
  specialDateBeforeWeekday: "Une date est utilisée avant un jour de semaine. Cette date est utilisée avant {name}.",
  specialWeekdayAfterDate: "Une date est utilisée avant un jour de semaine. {name} est utilisé avant ce réglage de semaine.",
  specialShorterWins: "La date la plus courte est utilisée. Ce réglage est utilisé avant {name} les jours en commun.",
  specialShorterLoses: "La date la plus courte est utilisée. {name} est utilisé avant ce réglage les jours en commun.",
  specialSaveSchedule: "Enregistrer l'horaire",
  specialRoomStays: "Le nom de la salle reste {name}.",
  specialRoomsStay: "Les noms des salles restent {names}.",
  specialWholeDay: "toute la journée",
  specialFromHours: "de {start} à {end}",
  specialWeekSentence: "Les {days}, {hours}, cette salle utilise le plan spécial. À tout autre moment, elle utilise le plan de tous les jours.",
  specialDateSentence: "Le {date}, {hours}, cette salle utilise le plan spécial. À tout autre moment, elle utilise le plan de tous les jours.",
  specialRangeSentence: "Du {startDate} au {endDate}, {hours}, cette salle utilise le plan spécial. À tout autre moment, elle utilise le plan de tous les jours.",
  roomName: "Nom de la salle",
  room: "Salle",
  mainHall: "Salle principale",
  roomHasTables: "Retirez les tables de cette salle avant de la supprimer.",
  numberSeats: "Numéroter les sièges",
  chooseStartSeat: "Cliquez le siège de départ. Les numéros suivent le sens horaire.",
  rotateTable: "Pivoter",
  done: "Terminé",
  presetSmallSquare: "Petite table carrée",
  presetSmallRect: "Petite table rectangulaire",
  presetRect: "Table rectangulaire",
  presetMediumSquare: "Table carrée moyenne",
  presetBooth: "Banquette",
  presetRound: "Table ronde",
  presetBanquette: "Banquette murale",
  presetBar: "Places au bar",
  presetLargeRect: "Grande table rectangulaire",
  presetLargeRound: "Grande table ronde",
  presetCommunal: "Table commune",
  presetHighTop: "Table haute",
  presetWall: "Mur",
  presetWallArc: "Mur courbe",
  presetWallL: "Mur en L",
  presetWallLFlip: "Mur en L opposé",
  length: "Longueur",
  maxSessions: "Sessions maximum",
  sessionInterval: "Intervalle de session (min)",
  qrCardView: "Vue cartes QR",
  liveTableView: "Tables en direct",
  tableSize: "Taille de table",
  seatCountLabel: "{count} places",
  sortTimeLongest: "Plus longue",
  sortTimeShortest: "Plus courte",
  sortGuestsMost: "Plus de clients",
  sortGuestsFewest: "Moins de clients",
  sortTableNumber: "Table",
  openTable: "Ouvrir",
  startTable: "Démarrer",
  shapeRound: "Ronde",
  shapeSquare: "Carrée",
  shapeRect: "Rectangulaire",
  shapeBooth: "Banquette",
  shapeBar: "Bar",
  sortAsc: "Croiss.",
  sortDesc: "Décroiss.",
  last14Days: "14 derniers jours",
  sales: "Ventes",
  todaySales: "Ventes du jour",
  todayOrders: "Commandes du jour",
  averageTicket: "Ticket moyen",
  analyticsPosSales: "Ventes PDV",
  analyticsOnlineSales: "Ventes en ligne",
  analyticsByChannel: "Ventes par canal",
  analyticsByCategory: "Ventes par catégorie",
  analyticsByItem: "Ventes par article",
  analyticsBestSelling: "Meilleure vente",
  analyticsFirebaseCount: "Compteur",
  analyticsYesterday: "Hier",
  analyticsLast7Days: "7 derniers jours",
  analyticsLast30Days: "30 derniers jours",
  analyticsThisYear: "Cette année",
  analyticsPreviousYear: "Année précédente",
  analyticsPastYear: "Douze derniers mois",
  analyticsCustomRange: "Personnalisé",
  analyticsFrom: "Du",
  analyticsTo: "Au",
  analyticsNoSales: "Aucune vente payée pour cette période.",
  analyticsDeletedCarts: "Paniers supprimés",
  analyticsNoDeletedCarts: "Aucun panier supprimé pour cette période.",
  analyticsLatestOrders: "Dernières commandes payées",
  analyticsClearFilter: "Tout afficher",
  analyticsShowing: "Affichage",
  analyticsQty: "Qté",
  analyticsUncategorized: "Sans catégorie",
  analyticsLocalDelivery: "Livraison locale",
  analyticsOnlinePickup: "Cueillette en ligne",
  analyticsOnlineDelivery: "Livraison en ligne",
  analyticsUberEats: "Uber Eats",
  analyticsUberEatsPickup: "Cueillette Uber Eats",
  analyticsDoorDash: "DoorDash",
  analyticsDoorDashPickup: "Cueillette DoorDash",
  analyticsLoadError: "Les ventes n'ont pas pu être chargées.",
  analyticsSalesTab: "Ventes",
  tableAnalysis: "Analyse des tables",
  tablePerformance: "Performance des tables",
  openTables: "Tables ouvertes",
  tableVisits: "Visites",
  averageTurnover: "Rotation moyenne",
  averagePerVisit: "Moyenne par visite",
  tableTurnoverHint: "Parties terminées par table, y compris les tables sans visite.",
  mostUsedTable: "La plus utilisée",
  tablesWithNoVisits: "tables sans visite",
  tableWithNoVisits: "sans visite",
  noTableVisits: "Aucune visite de table terminée pour cette période.",
  lunchPeriod: "Dîner",
  dinnerPeriod: "Souper",
  otherPeriod: "Autre",
  tableClockPeriods: "Le dîner est de 11 h 00 à 15 h 59. Le souper est de 16 h 00 à 21 h 59. Heures de l'horloge du restaurant.",
  allRooms: "Toutes les salles",
  tableReportTruncated: "Cette période contient plus de commandes que le rapport peut charger. Choisissez une période plus courte.",
  tableReportLoadError: "Les ventes des tables n'ont pas pu être chargées.",
  tableLast3Months: "3 derniers mois",
  tableLastYear: "Dernière année",
  tableSummaryNotReady: "Cette période n'est pas encore prête.",
  tableSummaryPartial: "Certains jours de cette période ne sont pas encore prêts.",
  unpaidTables: "Impayées",
  noOpenTables: "Aucune table n'est ouverte.",
  tableVisitClosed: "Heure",
  tableNumber: "Table #",
  guestCount: "Convives",
  adjustGuestCount: "Modifier le nombre de convives",
  findCustomer: "Rechercher un client",
  customerSearchPlaceholder: "Nom ou numéro de téléphone",
  changeCustomer: "Changer",
  removeCustomer: "Retirer",
  closedAt: "Fermée à",
  totalTaxIn: "Total (taxes incluses)",
  menuManagementSection: "Gestion des menus",
  ruleManagement: "Gestion des règles",
  pricingAndFees: "Prix et frais",
  taxesAndFees: "Taxes et frais",
  guestGroups: "Groupes de clients",
  taxesHeading: "Taxes",
  taxesInfoItems: "Le nom, le taux et le type fiscal viennent du super administrateur. Ce commerce choisit les articles et peut utiliser sa propre exemption.",
  taxSetByAdmin: "Le nom, le taux et le type fiscal sont définis dans le super administrateur.",
  editItemTaxes: "Modifier les taxes des articles",
  taxExemptionGlobal: "Super administrateur : {status}",
  taxExemptionWarningTitle: "Avertissement – Dérogation à l'exemption de taxe",
  taxExemptionWarningBody1: "Les exemptions de taxe sont contrôlées globalement. Modifier ce réglage pour un seul commerce peut entraîner un non-respect des règles de Revenu Québec si une exemption valide ne s'applique pas.",
  taxExemptionWarningBody2: "Une exemption non autorisée ou incorrecte peut entraîner une vérification, des pénalités, des amendes ou d'autres mesures de Revenu Québec.",
  taxExemptionWarningBody3: "En enregistrant ce changement, vous reconnaissez que vous êtes responsable de la validité légale de l'exemption et de la taxe exigée et déclarée.",
  taxExemptionAgree: "J'accepte d'en assumer la responsabilité.",
  taxExemptionWarningConfirm: "Vous avez accepté d'assumer la responsabilité de l'exemption de taxe de ce commerce.",
  taxExemptionOverrideClosed: "Le super administrateur n'a pas autorisé ce commerce à modifier l'exemption.",
  taxOverrideAllowed: "Le super administrateur a autorisé ce commerce à modifier cette taxe.",
  taxExemptionStandard: "Ce commerce utilise l'exemption standard du super administrateur.",
  taxExemptionUseStore: "Utiliser une exemption du commerce",
  taxExemptionUseStandard: "Utiliser l'exemption standard",
  taxExemptionStoreOwn: "Ce commerce utilise sa propre exemption. L'exemption standard s'applique encore aux autres commerces.",
  taxesInfoFiscal: "Le type fiscal détermine le code de taxe sur la facture : F fédérale, P provinciale, S supplémentaire.",
  taxNameN: "Nom de la taxe {n}",
  taxRatePercent: "Taux (%)",
  taxCustomName: "Nom personnalisé",
  taxCustomNamePlaceholder: "Saisir un nom de taxe",
  taxFiscalType: "Type fiscal",
  taxFiscalFederal: "Fédérale (F)",
  taxFiscalProvincial: "Provinciale (P)",
  taxFiscalAdditional: "Supplémentaire (S)",
  taxExemptionRules: "Règles d'exemption",
  taxExemptionFor: "Exemption {tax}",
  taxExemptionActive: "Active",
  taxExemptionStatusOff: "Non active. Cette règle ne s'applique pas. Le taux normal s'applique.",
  taxExemptionStatusUpcoming: "Activée. La règle commence le {from}.",
  taxExemptionStatusActive: "Activée. La règle s'applique maintenant, jusqu'à sa désactivation.",
  taxExemptionStatusActiveUntil: "Activée. La règle s'applique maintenant, jusqu'au {to}.",
  taxExemptionStatusEnded: "Activée. La règle a pris fin le {to}. Le taux normal s'applique.",
  taxExemptStart: "Date et heure de début",
  taxExemptEnd: "Date et heure de fin",
  taxExemptionRate: "Taux pendant l'exemption (%)",
  taxExemptionHelp: "Laissez la fin vide pour garder la règle jusqu'à sa désactivation.",
  taxExemptionStartRequired: "Saisissez la date et l'heure de début.",
  taxExemptionOrder: "La fin doit être après le début.",
  taxExemptionSaved: "Règle d'exemption enregistrée",
  taxExemptionSaveError: "La règle d'exemption n'a pas pu être enregistrée",
  taxSelectItems: "Choisir les articles ({n})",
  taxItemsTitle: "Articles avec {tax}",
  taxItemsSelectedCount: "{n} articles sélectionnés",
  taxesSaved: "Taxes enregistrées",
  taxesSaveError: "Les taxes n'ont pas pu être enregistrées",
  editTaxes: "Modifier les taxes",
  itemTaxes: "Taxes",
  previousPage: "Précédent",
  nextPage: "Suivant",
  pageOfPages: "Page {page} sur {pages}",
  guestGroupsHelp: "Comptez les clients par groupe. Par défaut, les groupes sont établis selon l'âge. Renommez-les ou ajoutez des groupes selon d'autres critères.",
  guestGroupName: "Nom du groupe",
  guestGroupNamePlaceholder: "Nom du groupe",
  guestGroupAbbreviation: "Abréviation",
  guestGroupNameRequired: "Entrez un nom de groupe.",
  guestGroupAbbreviationRequired: "Entrez de 1 à 3 lettres.",
  guestGroupAbbreviationDuplicate: "Cette abréviation est déjà utilisée.",
  addGuestGroup: "Ajouter un groupe",
  deleteGuestGroup: "Supprimer le groupe",
  guestGroupsSaved: "Groupes de clients enregistrés",
  guestGroupsSaveError: "Impossible d'enregistrer les groupes de clients",
  orderRulesCustomization: "Règles et personnalisation des commandes",
  menuDisplay: "Affichage du menu",
  recipe: "Recette",
  recipeMenuItems: "Articles",
  recipeBack: "Retour",
  recipeUnassigned: "Non classés",
  recipeCount: "recettes",
  recipeIngredients: "Ingrédients",
  recipeReports: "Rapports",
  recipeAll: "Tous",
  recipeMissing: "Sans recette",
  recipeHasRecipe: "Avec recette",
  recipeStatus: "État",
  recipeInUse: "En vigueur",
  recipeDraft: "Brouillon",
  recipeStartsOn: "Début",
  recipeEnded: "Terminée",
  recipeNone: "Aucune recette",
  recipeEstimatedCost: "Coût estimé",
  recipeSaveRecipe: "Enregistrer la recette",
  recipeSaveDraft: "Enregistrer le brouillon",
  recipeCopyTo: "Copier vers d'autres plats",
  recipeCopyFrom: "Copier depuis un autre article",
  recipeCreateIngredient: "Créer un ingrédient",
  recipeMaterialNumber: "Numéro de matière",
  recipeMaterialNumberHint: "6 chiffres, par exemple 000123. Ce numéro relie la matière que vous achetez.",
  recipeMaterialNumberInvalid: "Entrez 6 chiffres ou laissez le numéro vide.",
  recipeMaterialNumberDuplicate: "Un autre ingrédient utilise déjà ce numéro.",
  recipeBaseUnit: "Unité",
  recipeCategory: "Catégorie",
  recipeActive: "Actif",
  recipeInactive: "Inactif",
  recipePurchaseUnit: "Unité d'achat",
  recipePurchaseCost: "Coût d'achat",
  recipePurchaseQuantity: "Quantité dans l'unité de la recette",
  recipeCost: "Coût",
  recipeCostPerUnit: "Coût par unité",
  recipeEffectiveDate: "Date d'effet",
  recipeQuantity: "Quantité",
  recipeLineCost: "Coût de la ligne",
  recipeTotalCost: "Coût estimé",
  recipeAddLine: "Ajouter",
  recipeSearchIngredient: "Rechercher par nom ou numéro de matière",
  recipeNoMatch: "Aucun ingrédient correspondant.",
  recipeKeepTyping: "Précisez la recherche.",
  recipeMoreSettings: "Autres paramètres",
  recipePortionCount: "Portions produites par cette recette",
  recipeNote: "Note",
  recipeSaveItemFirst: "Enregistrez l'article avant d'ajouter une recette.",
  recipePreparedIngredients: "Ingrédients préparés",
  recipePreparedHelp: "Afficher les ingrédients préparés en lot par la cuisine.",
  recipePreparedLater: "Les recettes de lot seront ajoutées dans une mise à jour ultérieure.",
  recipeViewOnly: "Cette version est terminée. Les quantités antérieures restent inchangées.",
  recipeOverlap: "Ces dates chevauchent une autre version. Choisissez une date de début plus tardive.",
  recipeCopied: "Recette copiée.",
  recipeSaved: "Recette enregistrée.",
  recipeSavedDraft: "Brouillon enregistré.",
  recipeIngredientSaved: "Ingrédient enregistré.",
  recipeName: "Ingrédient",
  recipeNext: "Suivant",
  recipePrevious: "Précédent",
  recipeConsumption: "Utilisation théorique",
  recipeTheoreticalCost: "Coût théorique",
  recipeFoodCostPercent: "Coût matière",
  recipeGrossProfit: "Marge brute",
  recipeRevenue: "Ventes des recettes",
  recipeUnmatchedRefunds: "Remboursements sans détail d'article",
  recipeNoRecipeSales: "Articles vendus sans recette",
  recipeReportHelp: "Estime l'utilisation des ingrédients à partir des ventes payées. Les remboursements sont inclus lorsque la commande d'origine a été créée dans les 31 jours précédant la date de début. Ce rapport ne modifie pas le stock.",
  recipeDateFrom: "Du",
  recipeDateTo: "Au",
  recipeRunReport: "Produire le rapport",
  recipeByIngredient: "Par ingrédient",
  recipeByItem: "Par plat",
  recipeEmptyReport: "Aucune vente payée avec une recette pour cette période.",
  recipeSelectDishes: "Choisir les plats",
  recipeConfirmCopy: "Copier la recette",
  recipeCopyHelp: "Chaque plat conserve sa propre copie. Les versions antérieures restent inchangées.",
  recipeStartsOnHelp: "Les dates antérieures restent sur la version précédente.",
  recipeLibraryEmpty: "Aucun ingrédient pour le moment.",
  recipeAddIngredient: "Ajouter un ingrédient",
  recipeEditIngredient: "Modifier l'ingrédient",
  recipeRequiredName: "Entrez le nom de l'ingrédient.",
  recipeRemove: "Retirer",
  recipeVersion: "Version",
  recipeLoading: "Chargement de la recette.",
  recipeOffline: "La modification des recettes nécessite une connexion.",
  recipeConflict: "Cette recette a été mise à jour. Chargez-la de nouveau, puis enregistrez.",
  recipeClosed: "Une version terminée ne peut pas être modifiée.",
  recipeInvalid: "Vérifiez les quantités et la date de début.",
  recipeNoSource: "Ce plat n'a pas de recette à copier.",
  recipeCopyFailed: "Certains plats n'ont pas été copiés.",
  recipeDish: "Plat",
  recipeNetSold: "Ventes nettes",
  recipeNoItems: "Aucun article ne correspond à ce filtre.",
  recipeCostMissing: "Ajoutez un coût pour calculer le total.",
  recipeUnitMismatch: "Choisissez une unité de la même famille que l'ingrédient.",
  recipePortionInvalid: "Entrez un nombre de portions supérieur à zéro.",
  recipeSearchDishes: "Rechercher un plat",
  recipeNothingSelected: "Sélectionnez au moins un plat.",
  recipeOpen: "Modifier la recette",
  showPosItemPictures: "Afficher les photos au POS",
  showPosItemPicturesHelp: "Les fiches produit affichent une photo. Désactivez pour n'afficher que le nom.",
  showCategoryPagePictures: "Afficher les photos sur la page des catégories",
  showCategoryPagePicturesHelp: "Les fiches de catégorie affichent une photo. Désactivez pour n'afficher que le nom.",
  favoriteCategories: "Catégories favorites",
  noFavoriteCategories: "Aucune catégorie favorite",
  toggleCategoryFavorite: "Favori",
  categoryActions: "Actions de la catégorie",
  posPicturesOn: "Les photos sont affichées",
  posPicturesOff: "Les photos sont masquées",
  posPicturesSyncFailed: "Le POS de cet ordinateur est à jour. La copie du magasin se mettra à jour au retour de la connexion.",
  showPosAddButton: "Afficher le bouton ajouter",
  showPosAddButtonHelp: "Un bouton plus figure sur chaque produit. Désactivez-le pour ajouter un article en touchant la fiche.",
  posAddButtonOn: "Le bouton ajouter est affiché",
  posAddButtonOff: "Le bouton ajouter est masqué",
  showPosItemPrice: "Afficher le prix",
  showPosItemPriceHelp: "Les fiches produit affichent le prix. Désactivez pour masquer le prix.",
  posItemPriceOn: "Le prix est affiché",
  posItemPriceOff: "Le prix est masqué",
  pricingAndRounding: "Prix et arrondi",
  orderPreferences: "Préférences de commande",
  corePrintSettings: "Paramètres d'impression principaux",
  additionalSettings: "Paramètres supplémentaires",
  qrTable: "Table QR",
  qrCodePrintSettings: "Paramètres d'impression du code QR",
  additionalQrSettings: "Paramètres QR supplémentaires",
  qrCodePresenting: "Présentation du code QR",
  printersList: "Liste des imprimantes virtuelles",
  cupLabelSection: "Étiquette de gobelet",
  cupLabelTemplateTitle: "Modèle d'étiquette de gobelet",
  cupLabelTemplates: "Modèles",
  cupLabelAdd: "Ajouter un modèle",
  cupLabelName: "Nom",
  cupLabelEnabled: "Activé",
  cupLabelDisabled: "Désactivé",
  cupLabelMedia: "Papier",
  cupLabelSticky: "Étiquette adhésive",
  cupLabelReceipt: "Papier reçu",
  cupLabelLiner: "Papier sans support",
  cupLabelStickyHelp: "Autocollant prédécoupé, largeur et hauteur fixes.",
  cupLabelReceiptHelp: "Papier thermique. De la colle peut être ajoutée à l'étiquette.",
  cupLabelLinerHelp: "Papier adhésif continu. La longueur augmente avec le texte.",
  cupLabelSize: "Format",
  cupLabelCustom: "Personnalisé",
  cupLabelWidth: "Largeur (mm)",
  cupLabelHeight: "Hauteur (mm)",
  cupLabelReceiptWidth: "Le papier reçu utilise la largeur du papier de l'imprimante.",
  cupLabelFont: "Taille du texte",
  cupLabelRotate: "Pivoter de 90° dans le sens horaire",
  cupLabelRotateHelp: "La courbe du papier suit le gobelet. Le texte suit le papier, de haut en bas.",
  cupLabelCompact: "Compact",
  cupLabelRegular: "Normal",
  cupLabelLarge: "Grand",
  cupLabelLines: "Lignes",
  cupLabelDrag: "Glisser pour arranger",
  cupLabelRowHelp: "Glissez un champ sur une ligne. Les champs d'une même ligne s'impriment ensemble. Le nombre s'imprime lorsqu'il est supérieur à 1.",
  cupLabelItemName: "Nom de l'article",
  cupLabelOption: "Option",
  cupLabelAdvanceOption: "Option avancée",
  cupLabelAdvanceQty: "Nombre",
  cupLabelOrderNumber: "Numéro de commande",
  cupLabelDrinkName: "Nom de la boisson",
  cupLabelSizeField: "Format de la boisson",
  cupLabelQuantity: "Quantité",
  cupLabelModifiers: "Options",
  cupLabelCustomer: "Nom du client",
  cupLabelTime: "Heure",
  cupLabelSource: "Source de la commande",
  cupLabelStoreName: "Nom du magasin",
  cupLabelSequence: "Séquence",
  cupLabelInstructions: "Instructions spéciales",
  cupLabelPreview: "Aperçu",
  cupLabelFitWarning: "Cette étiquette ne tient pas. Retirez une ligne ou choisissez un format plus grand.",
  cupLabelSaved: "Modèle d'étiquette enregistré",
  cupLabelSavedLocal: "Enregistré sur cet ordinateur. La copie du magasin sera mise à jour au retour de la connexion.",
  cupLabelSaveFailed: "Le modèle d'étiquette n'a pas été enregistré",
  cupLabelNameRequired: "Entrez un nom de modèle.",
  cupLabelTemplate: "Modèle",
  cupLabelNoTemplate: "Aucun modèle",
  cupLabelCreateTemplate: "Créez un modèle dans Modèle d'étiquette de gobelet.",
  cupLabelEmpty: "Aucun modèle pour le moment.",
  cupLabelConfirmDelete: "Confirmer la suppression",
  webhooksIntegration: "Intégration des webhooks",
  customerExperience: "Expérience client",
  dataManagement: "Gestion des données",
  exportData: "Exporter les données",
  downloadMenuJson: "Télécharger le menu JSON",
  uploadMenuJson: "Importer le menu JSON",
  menuJsonPasteHere: "Collez le JSON ici",
  menuJsonUsePasted: "Utiliser le JSON collé",
  menuJsonPasted: "JSON collé",
  menuJsonChooseMenu: "Choisir un menu",
  menuJsonCreateNew: "Créer un nouveau menu",
  menuJsonNewMenuName: "Nom du menu",
  menuJsonDownload: "Télécharger le JSON",
  menuJsonDownloading: "Téléchargement...",
  menuJsonDownloaded: "Menu JSON téléchargé.",
  menuJsonDownloadFailed: "Le menu JSON n'a pas pu être téléchargé.",
  menuJsonLoadMenusFailed: "Les menus n'ont pas pu être chargés.",
  menuJsonDishCountFile: "{0} plats",
  menuJsonDishPosition: "Plat {0} sur {1}",
  menuJsonPreview: "Aperçu",
  menuJsonStep1: "Étape 1. Aperçu et création",
  menuJsonStep2: "Étape 2. Synchroniser les photos et le menu",
  menuJsonStep3: "Étape 3. Actualiser la caisse",
  menuJsonPreviewCreate: "Aperçu et création",
  menuJsonSync: "Synchroniser",
  menuJsonSyncing: "Synchronisation. Restez sur cet écran.",
  menuJsonSyncDone: "Le menu est à la caisse.",
  menuJsonSyncFailed: "La synchronisation n'a pas pu se terminer.",
  menuJsonPreviewFailed: "L'aperçu n'a pas pu être ouvert.",
  menuJsonNoDishes: "Ce fichier ne contient aucun plat.",
  menuJsonBadFile: "Choisissez un fichier JSON de menu.",
  menuJsonUntitled: "Plat sans nom",
  menuJsonCategoryMissing: "Cette catégorie n'est pas dans le menu sélectionné : {0}",
  menuJsonCategoryWillCreate: "Cette catégorie sera ajoutée au menu : {0}",
  menuJsonCategoryRequired: "Une catégorie est requise.",
  menuJsonSameName: "Quand le nom existe déjà",
  menuJsonOverwrite: "Remplacer",
  menuJsonIgnore: "Ignorer",
  menuJsonKeepBoth: "Garder les deux",
  menuJsonDuplicateOverwrite: "Ce nom est déjà dans le menu. Suivant le met à jour.",
  menuJsonDuplicateIgnore: "Ce nom est déjà dans le menu. Suivant le laisse inchangé.",
  menuJsonDuplicateKeep: "Ce nom est déjà dans le menu. Suivant ajoute un autre plat.",
  menuJsonDishUpdated: "Plat mis à jour.",
  menuJsonLeftUnchanged: "Le plat existant est resté inchangé.",
  menuJsonNameRequired: "Un nom est requis.",
  menuJsonPriceRequired: "Un prix est requis.",
  menuJsonCombo: "Combo",
  menuJsonComboMissing: "Ces plats du combo ne sont pas encore dans le menu : {0}",
  menuJsonPictureNotSaved: "L'image de {0} n'a pas été enregistrée.",
  menuJsonPictureNotDownloaded: "L'image n'a pas pu être téléchargée. Le plat a été enregistré sans image.",
  menuJsonNoPicture: "Aucune image",
  menuJsonCreating: "Création...",
  menuJsonDishCreated: "Plat créé.",
  menuJsonCreateFailed: "Ce plat n'a pas pu être créé.",
  menuJsonReviewComplete: "Tous les plats ont été examinés.",
  menuJsonReviewCompleteDetail: "Choisissez Synchroniser. Les photos sont enregistrées, puis le menu de la caisse est actualisé.",
  tableManagement: "Gestion des tables",
  cloudStorageOperations: "Opérations de stockage cloud",
  onlineOrdering: "Commande en ligne",
  onlineOrderingDescription: "Les paramètres de commande en ligne sont enregistrés par magasin.",
  orderTypes: "Types de commande",
  guestPayments: "Paiements clients",
  eTransferReceived: "Virement Interac reçu",
  paymentStatusPending: "En attente",
  paymentStatusReceived: "Reçu",
  paymentAutoAssigned: "Attribué automatiquement",
  paymentReceived: "Paiement reçu",
  updatePaymentStatus: "Mettre à jour le statut du paiement",
  mevSection: "MEV (commande en ligne sans mode de paiement)",
  mevUnconfirmedIntro: "Si le mode de paiement d'une commande en ligne n'est pas mis à jour manuellement, la règle sélectionnée s'applique.",
  mevRuleComplete: "À la fin de la commande",
  mevRuleCompleteHelp: "Lorsque la commande est terminée, le reçu est envoyé avec le mode de paiement par défaut.",
  mevRuleTime: "Après un délai",
  mevRuleTimeHelp: "Lorsque ce délai passe sans mise à jour du paiement, le reçu est envoyé avec le mode de paiement par défaut.",
  mevRuleManual: "Manuel seulement",
  mevRuleManualHelp: "Le reçu est envoyé seulement après la mise à jour du statut de paiement.",
  mevDelayMinutes: "Minutes",
  mevDefaultPaymentMethod: "Mode de paiement par défaut",
  noEnabledPaymentMethods: "Aucune méthode de paiement n'est activée.",
  printReceipt: "Imprimer le reçu",
  receiptSentWhenPaid: "Le reçu est envoyé lorsque le paiement est reçu",
  transmittedToRevenuQuebec: "Transmis à Revenu Québec",
  rqReturnNumber: "Numéro de retour",
  rqReturnDate: "Date de retour",
  rqReceiptEmail: "Courriel du reçu",
  rqWaiting: "En attente de Revenu Québec",
  receiptSentTo: "Reçu électronique envoyé à {email}",
  receiptQueuedFor: "Reçu électronique en attente pour {email}",
  storeDefaults: "Paramètres du magasin",
  guestPage: "Page client",
  connectedApps: "Applications connectées",
  storeProfile: "Profil du magasin",
  addressAndHours: "Adresse et heures",
  discountsAndPromos: "Rabais et promos",
  extraCharges: "Frais supplémentaires",
  termsAndConditions: "Conditions générales",
  orderEmails: "Courriels de commande",
  newOrderSound: "Son de nouvelle commande",
  guestSignIn: "Connexion client",
  tips: "Pourboires",
  orderFlow: "Flux de commande",
  extra: "Autre",
  takeout: "À emporter",
  waitingForKitchenOrders: "En attente de commandes",
  systemLocale: "Langue du système",
  kilometresMiles: "Kilomètres/Miles",
  kilometres: "Kilomètres",
  miles: "Miles",
  timezone: "Fuseau horaire",
  timeFormatting: "Format de l'heure",
  twelveHour: "12 heures",
  twentyFourHour: "24 heures",
  dateFormatting: "Format de la date",
  taxInPrices: "Taxes incluses",
  taxOnTips: "Taxes sur les pourboires",
  firstDayOfTheWeek: "Premier jour de la semaine",
  enableTaxInPricesDescription: "Activez cette option si les prix de votre magasin incluent déjà les taxes.",
  enableTaxOnTipsDescription: "Activez cette option pour facturer des taxes sur les pourboires.",
  menuSettingsDescription: "Gérer les catégories, la mise en page du menu et les prix.",
  orderSettingsDescription: "Gérer les règles de commande, l'arrondi et les préférences de paiement.",
  categoriesAndPricing: "Catégories",
  manageOrder: "Gérer la commande",
  noItems: "Aucun article",
  tax: "Taxe",
  deliveryFee: "Frais de livraison",
  orderDetailReprint: "Réimprimer",
  orderDetailRefund: "Rembourser",
  orderDetailModifyPayment: "Modifier",
  orderDetailDone: "Terminer",
  orderDetailChannel: "Canal",
  orderDetailStaff: "Employé",
  orderDetailItems: "Articles",
  orderDetailRefundHistory: "Historique des remboursements",
  orderDetailStatusSubmitted: "Soumise",
  orderDetailStatusCompleted: "Complétée",
  orderDetailStatusCanceled: "Annulée",
  orderDetailPrintFailed: "Échec de l'impression",
  orderDetailNoRefundableItems: "Aucun article remboursable",
  orderDetailAllItemsRefunded: "Tous les articles de cette commande ont déjà été remboursés.",
  orderDetailRefundProcessed: "Remboursement effectué",
  orderDetailCreditNotePrinted: "Note de crédit imprimée",
  orderDetailRefundFailed: "Échec du remboursement",
  orderDetailProcessRefund: "Effectuer un remboursement",
  orderDetailConfirmRefund: "Confirmer le remboursement",
  orderDetailRefundByItem: "Sélection d'articles",
  orderDetailRefundByAmount: "Montant personnalisé",
  orderDetailRefundAmountAfterTax: "Montant du remboursement (taxes incluses)",
  orderDetailRefundExceeds: "Le montant dépasse le solde remboursable restant de",
  orderDetailQuantity: "Quantité",
  orderDetailRefundBeforeTax: "Total du remboursement (avant taxes)",
  orderDetailRemainingBalance: "Solde remboursable restant",
  orderDetailStatusRefunded: "Remboursée",
  orderDetailStatusPartiallyRefunded: "Remboursement partiel",
  orderDetailRefundedTag: "Remboursé",
  orderDetailRefunded: "Remboursé",
  orderDetailNetTotal: "Total net",
  orderActivityTitle: "Historique",
  orderActivityEmpty: "Aucune réimpression, aucun remboursement ni changement de paiement.",
  orderActivityReprint: "Reçu réimprimé",
  orderActivityRefund: "Remboursement",
  orderActivityPaymentChange: "Mode de paiement modifié",
  modifyPaymentTitle: "Modifier le mode de paiement",
  modifyPaymentConfirm: "Confirmer la correction",
  modifyPaymentWarningTitle: "Une transaction inverse sera transmise au MEV.",
  modifyPaymentWarningBody: "Le reçu original est annulé et un reçu corrigé est imprimé.",
  modifyPaymentCurrent: "Paiement actuel",
  modifyPaymentSelectNew: "Nouveau mode de paiement",
  modifyPaymentCurrentTag: "Mode actuel",
  modifyPaymentNoneSelected: "Aucun mode de paiement sélectionné",
  modifyPaymentSelectPrompt: "Sélectionner un nouveau mode de paiement.",
  modifyPaymentSameMethod: "Mode de paiement identique",
  modifyPaymentSelectDifferent: "Sélectionner un mode de paiement différent.",
  modifyPaymentCorrected: "Reçu corrigé",
  modifyPaymentChangedTo: "Mode de paiement remplacé par",
  modifyPaymentFailed: "Échec de la correction du reçu",
  modifyPaymentRejected: "Revenu Québec a refusé la transaction",

  // Reçus électroniques
  printAndEmailReceipts: "Impression et envoi des reçus",
  receiptFormat: "Format du reçu",
  receiptFormatHelp: "S'applique aux reçus de clôture, aux remboursements et aux changements de mode de paiement. Au moins un format demeure actif.",
  receiptFormatPaper: "Papier",
  receiptFormatElectronic: "Électronique",
  receiptFormatBoth: "Papier et électronique",
  merchantEmailAddresses: "Adresses courriel du commerçant",
  merchantEmailAddressesHelp: "Jusqu'à trois adresses. Au moins une adresse est requise pour les reçus électroniques.",
  merchantEmailNumber: "Courriel du commerçant {n}",
  onScreenKeyboard: "Clavier à l'écran",
  remove: "Retirer",
  invalidEmailAddress: "L'adresse courriel n'est pas valide.",
  merchantCopyNotice: "Ces adresses reçoivent automatiquement une copie de chaque reçu électronique, conformément aux exigences de Revenu Québec. Cette copie ne peut pas être annulée.",
  merchantEmailRequired: "Saisir au moins une adresse courriel du commerçant avant d'activer le reçu électronique.",
  receiptFormatPaperReceipt: "Reçu papier",
  receiptFormatPaperHelp: "Imprimé au poste.",
  receiptFormatElectronicReceipt: "Reçu électronique",
  receiptFormatElectronicHelp: "Transmis par courriel au client.",
  processingPayment: "Traitement du paiement",
  paymentCompleted: "Paiement effectué",
  electronicReceiptTo: "Reçu électronique à",
  receiptSettingsSaved: "Paramètres des reçus enregistrés",
  receiptDelivery: "Reçu",
  receiptPaperShort: "Papier",
  receiptEmailShort: "Courriel",
  merchantCopyShort: "Copie marchand",
  receiptBothShort: "Les deux",
  recipientEmail: "Courriel du destinataire",
  recipientEmailHelp: "Le reçu électronique est envoyé à cette adresse.",
  useCustomerEmail: "Utiliser l'adresse du client",
  saveEmailToCustomer: "Enregistrer cette adresse dans la fiche du client",
  confirmAndPay: "Confirmer et payer",
  electronicReceipt: "Reçu électronique",
  receiptEmailStatusSent: "Envoyé",
  receiptEmailStatusPending: "En attente",
  receiptEmailStatusAwaiting: "En attente de Revenu Québec",
  receiptEmailStatusFailed: "Non livré",
  customerEmailNotSent: "Courriel du client non envoyé",
  customerEmailNotSentBody: "La facture a été enregistrée. Le courriel à {email} n'a pas été envoyé.",
  receiptEmailAddressIncorrect: "L'adresse courriel n'est pas correcte.",
  receiptEmailFailedExplicit: "Le courriel à {email} pour la commande {order} a échoué. Vérifiez l'adresse courriel, corrigez-la et envoyez de nouveau.",
  receiptEmailFailedShort: "Courriel échoué",
  receiptEmailBouncedTitle: "Cette adresse courriel a été refusée",
  receiptEmailBouncedDetail: "Le courriel pour {document} {number} n'a pas été livré à {email}.",
  receiptEmailCorrectAddress: "Corriger l'adresse",
  receiptEmailLeaveIt: "Laisser ainsi",
  receiptEmailSameAddress: "Saisir une autre adresse courriel. Cette adresse a été refusée.",
  receiptEmailDocTemporary: "Facture provisoire",
  receiptEmailDocClosing: "Facture de fermeture",
  receiptEmailDocCredit: "Note de crédit",
  receiptEmailDocCancelled: "Facture annulée",
  receiptEmailDocCorrected: "Facture corrigée",
  receiptEmailLastError: "Dernière erreur",
  resendElectronicReceipt: "Renvoyer le reçu électronique",
  retrySending: "Relancer l'envoi",
  cloudMevCasEssai: "Cas d'essai (CASESSAI)",
  cloudMevRecipientEmail: "Courriel du destinataire (cas de reçu électronique)",
  cloudMevRecipientRequired: "Saisir une adresse courriel de destinataire pour ce cas d'essai",
  cloudMevCasEssaiHelp: "Le deuxième chiffre après le point détermine le format : 1 papier, 2 électronique, 4 papier et électronique.",
  essaiResetCounters: "Réinitialiser les compteurs",
  essaiResetCountersTitle: "Réinitialiser les compteurs de vente",
  essaiResetCountersMessage: "Ceci efface les compteurs de vente d'essai. La prochaine vente de chaque canal commence à 1.",
  essaiResetCountersConfirm: "Réinitialiser les compteurs",
  essaiCountersReset: "Les compteurs de vente d'essai commencent maintenant à 1.",
  essaiCountersResetFailed: "Les compteurs de vente d'essai n'ont pas été réinitialisés.",
  essaiStartTest: "Commencer l'essai",
  essaiStopTest: "Arrêter l'essai",
  rqExchangeButton: "Requêtes",
  rqExchangeTitle: "Requête et réponse",
  rqExchangeMinimize: "Réduire",
  rqExchangeList: "Liste",
  rqExchangeRequest: "Requête",
  rqExchangeResponse: "Réponse",
  rqExchangeOutHeaders: "En-têtes envoyés",
  rqExchangeOutPayload: "Données envoyées",
  rqExchangeInHeaders: "En-têtes reçus",
  rqExchangeInPayload: "Données reçues",
  rqExchangeEarlierCall: "Appel précédent",
  rqExchangeLaterCall: "Appel suivant",
  rqExchangeEmpty: "Aucune requête n'a été enregistrée.",
  rqExchangeEmptyResponse: "Aucune réponse n'a été enregistrée.",
  rqExchangeEmptyRequest: "Aucune requête n'a été enregistrée.",
  essaiSetTestCase: "Définir le cas d'essai",
  essaiOpenRecord: "Ouvrir le dossier d'essai",
  essaiTestCase: "Cas d'essai",
  essaiCustomCase: "Cas personnalisé",
  essaiCustomCaseInvalid: "Saisir un cas d'essai au format 000.000.",
  essaiUseCase: "Utiliser ce cas",
  essaiTestResponse: "Réponse d'essai",
  essaiTestSaved: "Enregistré",
  essaiTestNotSaved: "La réponse n'a pas été enregistrée.",
  essaiTestCopied: "Copié",
  essaiTestCopy: "Copier",
  essaiTestRecordFailed: "Le dossier d'essai n'a pas été créé.",
  essaiTestOpenFailed: "Le dossier d'essai n'a pas été ouvert.",
  essaiTestCopyFailed: "La réponse n'a pas été copiée.",
  signInCodesTitle: "Vérification supplémentaire à la connexion",
  signInCodesIntro: "Vérification facultative après le mot de passe. Configurez chaque méthode une seule fois. Après la configuration, activez-la ou désactivez-la pour la connexion. La désactivation ne supprime pas la configuration.",
  signInCodesRequired: "Terminez la configuration avant l'ouverture du reste de l'application. La connexion l'exigera ensuite.",
  signInStatusNotSetUp: "Non configuré",
  signInStatusSetUp: "Configuré",
  signInUseAtSignIn: "Exigence à la connexion",
  signInUseOn: "Activé",
  signInUseOff: "Désactivé",
  signInTurnOn: "Activer",
  signInTurnOff: "Désactiver",
  signInAskAtSignIn: "Activer",
  signInStopAsking: "Désactiver",
  signInAskingNow: "Activé",
  signInNotAsking: "Désactivé",
  signInSetUpOn: "Configuré le {time}.",
  authShowQr: "Afficher le code d'authentification",
  authShowQrHelp: "Scannez ce code avec Google Authenticator pour ajouter Nuage POS Eagle sur un autre appareil. La configuration actuelle demeure inchangée.",
  signInSetUpText: "Configurer le message texte",
  signInSetUpAuthenticator: "Configurer l'authentificateur",
  signInCancel: "Annuler",
  smsTitle: "Message texte",
  smsNotSetUpBody: "La vérification par message texte envoie un code à un téléphone mobile après le mot de passe. Un service cellulaire est requis pour recevoir le message. Aucun message n'est envoyé tant que cette méthode n'est pas configurée.",
  smsSetUpBody: "Un numéro mobile est enregistré pour ce compte. Lorsque la vérification par message texte est activée, la connexion exige un code envoyé à ce numéro. Lorsqu'elle est désactivée, aucun texte n'est envoyé. Le numéro demeure au dossier.",
  smsPhoneLabel: "Numéro mobile",
  smsSetupHelp: "Saisissez le numéro mobile qui doit recevoir le code de vérification, avec l'indicatif du pays, par exemple +15145551234. Un seul message est envoyé. Saisissez ce code pour terminer la configuration. Le numéro demeure ensuite au dossier.",
  smsSavedNumber: "Un code de vérification sera envoyé au {phone}. Saisissez le code pour activer la vérification par message texte. Il n'est pas nécessaire de saisir le numéro de nouveau.",
  smsSendCode: "Envoyer le code",
  smsSendAgain: "Envoyer le code de nouveau",
  smsSendAgainIn: "Renvoyer le code dans {seconds} s",
  smsTextCode: "Code texte",
  smsFinishSetup: "Terminer la configuration",
  smsTurnedOff: "La vérification par message texte est désactivée. Le numéro mobile demeure au dossier.",
  smsTurnedOn: "La vérification par message texte est activée.",
  smsCodeSent: "Le message de vérification a été envoyé. La réception peut prendre jusqu'à une minute.",
  authTitle: "Authentificateur",
  authNotSetUpBody: "La vérification par authentificateur utilise l'application Google Authenticator. Après le mot de passe, la connexion exige un code à 6 chiffres de cette application. Une connexion Internet est requise sur le téléphone. Le service cellulaire n'est pas requis.",
  authSetUpBody: "Google Authenticator est configuré pour ce compte sous le nom Nuage POS Eagle. Lorsque la vérification par authentificateur est activée, la connexion exige le code à 6 chiffres de cette application. Lorsqu'elle est désactivée, le code n'est pas requis. L'entrée demeure sur l'appareil.",
  authStep1Title: "1. Installer Google Authenticator",
  authStep1Body: "Scannez un code avec l'appareil photo du téléphone. Utilisez le code de l'App Store pour les appareils Apple et le code de Google Play pour les appareils Android.",
  authAppleStore: "App Store d'Apple",
  authGooglePlay: "Google Play",
  authStep2Title: "2. Ouvrir l'application",
  authStep2Body: "Ouvrez Google Authenticator et connectez-vous si l'application le demande. Continuez lorsque l'application est prête.",
  authInstalledNext: "Continuer",
  authStep3Title: "3. Scanner le code Nuage POS Eagle",
  authStep3Body: "Dans Google Authenticator, sélectionnez Ajouter, puis Scanner un code QR. Le nouveau compte doit s'appeler Nuage POS Eagle.",
  authQrAlt: "Code d'authentification Nuage POS Eagle",
  authStep4Title: "4. Saisir le code de vérification",
  authExampleOnPhone: "Exemple",
  authExampleHint: "Le code sur l'appareil change toutes les quelques secondes. Saisissez le code actuel. Ne saisissez pas l'exemple 123456.",
  authCodeLabel: "Code de vérification",
  authFinishSetup: "Terminer la configuration",
  authTurnedOff: "La vérification par authentificateur est désactivée. Nuage POS Eagle demeure dans Google Authenticator.",
  authTurnedOn: "La vérification par authentificateur est activée.",
  authGatePrompt: "Saisissez le code à 6 chiffres de votre application d'authentification.",
  authGateClear: "Effacer",
  signInPhoneInvalid: "Saisissez le numéro avec l'indicatif du pays, par exemple +15145551234.",
};
